/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: string;
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: EmailAddress;
  /** GID representing an object in the samdesk space. */
  GID: GID;
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: HexColorCode;
  /** LngLat custom scalar type representing a valid coordinate position on the globe. */
  LngLat: GeoJSONLngLat;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: LocalTime;
  /** Lucene String custom scalar type */
  LuceneString: string;
  /** Markdown String custom scalar type */
  MarkdownString: string;
  /** ObjectId custom scalar type */
  ObjectId: string;
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: PhoneNumber;
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: TimeZone;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: string;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: unknown;
};

export type APIKey = {
  /** The _id of the API key */
  _id: Scalars['ObjectId'];
  /** True if the API key is active */
  active: Scalars['Boolean'];
  /** The date that the API key was created */
  created: Scalars['Date'];
  /** The GID of the API Key */
  gid: Scalars['GID'];
  /** The name of the API key */
  name: Scalars['String'];
  /** The value of the API key */
  value: Scalars['String'];
};

export type Account = {
  /** The _id of the Account */
  _id: Scalars['ObjectId'];
  /** True if the Account is currently active */
  active: Scalars['Boolean'];
  /**
   * The API key for the Account (deprecated)
   * @deprecated Replaced by api_keys
   */
  api_key?: Maybe<Scalars['String']>;
  /** The API keys for the Account. Only available to admin users. */
  api_keys: Array<APIKey>;
  /** The list of domains that User emails are allowed to have */
  email_domains: Array<Scalars['String']>;
  /** The AccountFlags for the Account */
  flags: Array<AccountFlag>;
  /** The _id of the Account */
  gid: Scalars['GID'];
  /** The url of the logo for the Account */
  logo?: Maybe<Scalars['URL']>;
  /** The AccountMembers associated with the Account */
  members: Array<AccountMember>;
  /** The name of the Account */
  name: Scalars['String'];
  /** The Account's password policy */
  password_policy: AccountPasswordPolicy;
  /** The PendingAccountMembers associated with the Account */
  pending_members: Array<PendingAccountMember>;
  /** The Account's preferences, set by an Account admin */
  preferences: AccountPreferences;
  /** The Account's settings, set by a samdesk admin */
  settings: AccountSettings;
  /** The current status of the Account - ["pending","active","inactive","past_due","unpaid","delinquent"] */
  status: AccountStatus;
};

export type AccountFlag = {
  /** The key of the AccountFlag */
  key: Scalars['String'];
  /** The value of the AccountFlag */
  value: Scalars['String'];
};

export type AccountInvitation = {
  /**
   * The Account associated with the AccountInvitation
   * @deprecated Should not expose the full Account object here
   */
  account?: Maybe<Account>;
  /** The name of the Account associated with the AccountInvitation */
  account_name?: Maybe<Scalars['String']>;
  /** The AccountPasswordPolicy of the Account associated with the AccountInvitation */
  password_policy?: Maybe<AccountPasswordPolicy>;
  /** The PendingUserAccount associated with the AccountInvitation */
  pending_user_account?: Maybe<PendingUserAccount>;
  /**
   * The Person associated with the AccountInvitation
   * @deprecated Should not expose the full Person object here
   */
  person?: Maybe<Person>;
  /** The name of the Person associated with the AccountInvitation for users that already exist in the system */
  person_name?: Maybe<Scalars['String']>;
  /** The name of the SAML issuer for SSO signup */
  saml_issuer?: Maybe<Scalars['String']>;
};

export type AccountMember = {
  /** The _id of the AccountMember */
  _id: Scalars['ObjectId'];
  /** The Account associated with the AccountMember */
  account: Account;
  /** The _id of the Account the AccountMember is associated with */
  account_id: Scalars['ObjectId'];
  /** If true, the AccountMember is associated with a bounced email */
  is_bounced_email: Scalars['Boolean'];
  /** The role of the AccountMember */
  role: Scalars['String'];
  /** The User associated with the AccountMember */
  user: User;
  /** The _id of the User the AccountMember is associated with */
  user_id: Scalars['ObjectId'];
};

export type AccountMembers = {
  /** The AccountMembers for the Account */
  active: Array<AccountMember>;
  /** The PendingAccountMembers for the Account */
  pending: Array<PendingAccountMember>;
};

export type AccountPasswordPolicy = {
  /** The minimum allowed password length */
  min_length: Scalars['Float'];
  /** If true, a password must contain at least one lowercase character */
  require_lowercase: Scalars['Boolean'];
  /** If true, a password must contain at least one number */
  require_number: Scalars['Boolean'];
  /** If true, a password must contain at least one special character */
  require_special: Scalars['Boolean'];
  /** If true, a password must contain at least one uppercase character */
  require_uppercase: Scalars['Boolean'];
};

export type AccountPasswordPolicyParams = {
  /** The min length of the password */
  min_length: Scalars['Int'];
  /** Do passwords require a lower case character */
  require_lowercase: Scalars['Boolean'];
  /** Do passwords require a number */
  require_number: Scalars['Boolean'];
  /** Do passwords require special characters (ie !@#$%^&*()<>?/+=) */
  require_special: Scalars['Boolean'];
  /** Do passwords require an upper case character */
  require_uppercase: Scalars['Boolean'];
};

export type AccountPreferences = {
  /** True if the Account wishes to use Authentic8 for external links */
  authentic8: Scalars['Boolean'];
  /** Either metric or imperial (kilometers or miles) */
  distance_units: DisplayUnit;
  /** True if the Account allows Users to sign in with email/password */
  password_authentication: Scalars['Boolean'];
  /** True if the Account allows users to sign in with SSO */
  saml_authentication: Scalars['Boolean'];
  /** Either metric or imperial (celcius or fahrenheit) */
  temperature_units: DisplayUnit;
  /** True if the Account has MFA enabled */
  two_factor_authentication: Scalars['Boolean'];
};

export type AccountPreferencesParams = {
  /** Is Authentic8 enabled on the account */
  authentic8?: InputMaybe<Scalars['Boolean']>;
  /** Default units for distance on the account either imperial or metric (ie kilometers or miles) */
  distance_units?: InputMaybe<DisplayUnit>;
  /** Does the account use email/password to login */
  password_authentication?: InputMaybe<Scalars['Boolean']>;
  /** Is SAML enabled on the account */
  saml_authentication?: InputMaybe<Scalars['Boolean']>;
  /** Default units for temperature on the account  either imperial or metric (ie celcius or fahrenheit) */
  temperature_units?: InputMaybe<DisplayUnit>;
  /** Does the account require two factor */
  two_factor_authentication?: InputMaybe<Scalars['Boolean']>;
};

export type AccountSettings = {
  /** True if the Account is allowed to send webhooks */
  allow_webhooks: Scalars['Boolean'];
  /** Whether or not the Account has access to the Samdesk API */
  api_access: Scalars['Boolean'];
  /** How many calls to the API the Account can make in a minute */
  api_rate_limit: Scalars['Int'];
  /** True if the account has access to the Authentic8 toggle */
  authentic8: Scalars['Boolean'];
  /** True if Users in the Account require admin approval to change their email address */
  change_email_admin_approval: Scalars['Boolean'];
  /** True if the Account has access to Copy Stream */
  copy_stream: Scalars['Boolean'];
  /** Whether or not the Account is allowed to upload assets via CSV */
  csv_asset_upload: Scalars['Boolean'];
  /** Feature: True if the account has access to detailed summaries */
  detailed_summary: Scalars['Boolean'];
  /** True if the Account is allowed to make EverbridgeIntegrations */
  eb_integration: Scalars['Boolean'];
  /** True if the Account is allowed to make v2 EverbridgeIntegrations */
  everbridge_v2: Scalars['Boolean'];
  /** The help level for the Account - ALL, ADMIN, NONE */
  help_level: HelpLevel;
  /** True if the Account is designated public sector */
  is_public_sector: Scalars['Boolean'];
  /** True if the Account belongs to samdesk (and should have access to hidden features) */
  is_sam: Scalars['Boolean'];
  /** True if the Account has access to the Lucene string filters in the Stream builder */
  lucene_string_filters: Scalars['Boolean'];
  /** The maximum number of ProximityAssetSetLocations the Account is allowed to have per ProximityAssetSet */
  max_asset_set_locations: Scalars['Int'];
  /** The maximum number of ProximityAssetSets the Account is allowed to have */
  max_asset_sets: Scalars['Int'];
  /** The maximum number of Contacts a User in the Account is allowed to have per ContactGroup */
  max_contact_group_contacts: Scalars['Int'];
  /** The maximum number of Contact Groups a User in the Account is allowed to have */
  max_contact_groups: Scalars['Int'];
  /** The maximum number of Dark Web Streams that a User is allowed to have */
  max_dark_web_streams: Scalars['Int'];
  /** The maximum number of columns in a single columns tab the Account is allowed to have */
  max_dashboard_columns_tab_columns: Scalars['Int'];
  /** The maximum number of columns tabs the Account is allowed to have */
  max_dashboard_columns_tabs: Scalars['Int'];
  /** The maximum number of search tabs the Account is allowed to have */
  max_dashboard_search_tabs: Scalars['Int'];
  /** The maximum number of tracked tabs the Account is allowed to have */
  max_dashboard_tracked_tabs: Scalars['Int'];
  /** The maximum number of Genetec Integrations the account is allowed to have */
  max_genetec_integrations: Scalars['Int'];
  /** The maximum number of ImpactAgents the Account is allowed to have */
  max_impact_agents: Scalars['Int'];
  /** The maximum number of incidents an Account can export via samalytics */
  max_samalytics_exportable_incidents: Scalars['Int'];
  /** The maximum number of search streams that the User is allowed to have */
  max_search_streams: Scalars['Int'];
  /** The maximum number of UserAccounts the Account is allowed to have */
  max_users: Scalars['Int'];
  /** The maximum number of Sources that a User is allowed to have in a single Web Alert Stream */
  max_web_alert_stream_sources: Scalars['Int'];
  /** The maximum number of Web Alert Streams that the User is allowed to have */
  max_web_alert_streams: Scalars['Int'];
  /** True if the Account is has MsTeams Integration */
  ms_teams: Scalars['Boolean'];
  /** True if the Account is has Resolver Integration */
  resolver: Scalars['Boolean'];
  /** True if the Account is allowed to see featured RTC content */
  rtc_content: Scalars['Boolean'];
  /** True if the account has access to samalytics */
  samalytics: Scalars['Boolean'];
  /** True if the account has access to the samalytics tab */
  samalytics_tab: Scalars['Boolean'];
  /** True if the account has access to SAML signin */
  saml: Scalars['Boolean'];
  /** True if the account has access to sammerizer */
  sammerizer: Scalars['Boolean'];
  /** True if the Account has access to Shared Streams */
  shared_streams: Scalars['Boolean'];
  /** True if the Account has proximity enabled */
  show_proximity: Scalars['Boolean'];
  /** True if the account has access to the Read/Unread toggle */
  show_read_unread: Scalars['Boolean'];
  /** True if the Account is allowed to connect a Traveller Integration */
  travel_integration: Scalars['Boolean'];
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  DELINQUENT = 'DELINQUENT',
  INACTIVE = 'INACTIVE',
  PAST_DUE = 'PAST_DUE',
  PENDING = 'PENDING',
  UNPAID = 'UNPAID'
}

export type AcknowledgeIncidentResponseParams = {
  /** The gid of the Incident to acknowledge an IncidentResponse for */
  incidentGID: Scalars['GID'];
};

export type AlertHeadline = {
  /** The Date the AlertHeadline was created */
  date: Scalars['Date'];
  /** The source of the AlertHeadline */
  source?: Maybe<Scalars['String']>;
  /** The labels belonging to the source of the AlertHeadline - ["chatter","news","official"] */
  source_labels?: Maybe<Array<Scalars['String']>>;
  /** The text of the AlertHeadline */
  text: Scalars['String'];
  /** The type of the AlertHeadline */
  type?: Maybe<Scalars['String']>;
};

export type AlertsPane = DashboardPane & {
  /** The unique key of the DashboardPane */
  key: Scalars['String'];
  /** Optional name for this Alerts pane */
  name?: Maybe<Scalars['String']>;
  /** What sound to play when the pane alerts */
  sound: AlertsTabDataSound;
  /** The gids of the streams selected on this AlertsPane */
  streamGIDs: Array<Scalars['GID']>;
  /** The ids of the streams selected on this AlertsPane */
  streamIds: Array<Scalars['ObjectId']>;
  /** Duration of time window (in seconds) used to filter alerts */
  timeWindowSeconds: Scalars['Int'];
  /** The type of the DashboardPane */
  type: DashboardPaneType;
  /** Whether to fetch only unread alerts or not for this AlertsPane */
  unreadOnly: Scalars['Boolean'];
};

export type AlertsTab = DashboardTab & {
  /** The data specific to an AlertsTab */
  alerts_tab_data: AlertsTabData;
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type AlertsTabData = {
  /** The list of Streams in the bottom pane of the AlertsTab */
  bottom: Array<AlertsTabDataStream>;
  /** What sound to play when the bottom pane alerts */
  bottom_sound: AlertsTabDataSound;
  /** Last set map_width by moving around the resizer */
  map_width: Scalars['Float'];
  /** The name of the AlertsTab */
  name: Scalars['String'];
  /** Last set pane_height by moving around the resizer */
  pane_height: Scalars['Float'];
  /** AssetSets currently tracked by the AlertsTab */
  selected_asset_sets: Array<AlertsTabDataAssetSet>;
  /** The list of Streams in the top pane of the AlertsTab */
  top: Array<AlertsTabDataStream>;
  /** What sound to play when the bottom pane alerts */
  top_sound: AlertsTabDataSound;
};

export type AlertsTabDataAssetSet = {
  /** The _id of the AssetSet present in this AlertsTab */
  asset_set_id: Scalars['ObjectId'];
  /** Whether this AssetSet is included to be shown in this AlertsTab */
  include: Scalars['Boolean'];
};

export type AlertsTabDataAssetSetInput = {
  /** The _id of the AssetSet present in this AlertsTab */
  asset_set_id: Scalars['ObjectId'];
  /** Whether this AssetSet is included to be shown in this AlertsTab */
  include: Scalars['Boolean'];
};

export type AlertsTabDataSound = {
  /** Whether to actually play the sound */
  enabled: Scalars['Boolean'];
  /** Which sound to play */
  name: Scalars['String'];
};

export type AlertsTabDataSoundInput = {
  /** Whether sound notification is enabled in the tab */
  enabled: Scalars['Boolean'];
  /** The name of the sound to play upon notification */
  name: Scalars['String'];
};

export type AlertsTabDataStream = {
  /** The _id of the Stream in the AlertsTab */
  stream_id: Scalars['ObjectId'];
};

export type AlertsTabDataStreamInput = {
  /** The _id of the Stream in the AlertsTab */
  stream_id: Scalars['ObjectId'];
};

export type AltName = {
  /** The type of the alt name */
  type: Scalars['String'];
  /** The value of the alt name */
  value: Scalars['String'];
};

export type AnalyticsInput = {
  /** Type of the alert interacted with */
  alert_type?: InputMaybe<Scalars['String']>;
  /** The ref_id of the email tracker. */
  ref_id?: InputMaybe<Scalars['ObjectId']>;
  /** Which platform the user is on at the time of reading */
  source?: InputMaybe<Scalars['String']>;
  /** The stream_id the user was alerted from */
  stream_id?: InputMaybe<Scalars['ObjectId']>;
  /** More details on which platform the user on at time of reading */
  sub_source?: InputMaybe<Scalars['String']>;
};

export type AnalyticsSearch = {
  created: Scalars['Date'];
  /** The GID of the AnalyticsSearch */
  gid: Scalars['GID'];
  location_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  search_params: AnalyticsSearchParams;
  updated: Scalars['Date'];
};

export type AnalyticsSearchData = {
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** The search params to associate with the AnalyticsSearch */
  search_params: BaseSearchIncidentsAnalyticsParams;
};

export type AnalyticsSearchGeoFilter = {
  geometry: GeoJSONGeometry;
  radius_km?: Maybe<Scalars['Float']>;
};

export type AnalyticsSearchParams = {
  after?: Maybe<Scalars['Date']>;
  asset_set_id?: Maybe<Scalars['ObjectId']>;
  before?: Maybe<Scalars['Date']>;
  geo_filter?: Maybe<AnalyticsSearchGeoFilter>;
  incident_types?: Maybe<Array<Scalars['String']>>;
  keyword_query?: Maybe<Scalars['String']>;
  /** The array of keywords used to build the search, derived from keyword_query */
  keywords: Array<Scalars['String']>;
  longkey?: Maybe<Scalars['String']>;
  relative_timestamp?: Maybe<AnalyticsSearchRelativeTimestamp>;
  severities?: Maybe<Array<IncidentSeverity>>;
};

export type AnalyticsSearchRelativeTimestamp = {
  offset: RelativeTimestampOffset;
  timezone: Scalars['TimeZone'];
};

export type AssetContact = ContactMethod & {
  /** The asset to send data to */
  asset: ProximityAssetSnapshot;
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
};

export type AssetContactInput = {
  /** The asset to send data to */
  assetGID: Scalars['GID'];
  /** The asset contact methods to send data to */
  selectedContactMethods?: InputMaybe<Array<ContactMethodInput>>;
};

export type AssetSetContact = ContactMethod & {
  /** The asset to send data to */
  assetSet: ProximityAssetSetSnapshot;
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
};

export type AssetSetContactInput = {
  /** The asset set to send data to */
  assetSetGID: Scalars['GID'];
};

export type BaseAlert = {
  /** The _id of the Alert */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Alert belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Alert was created */
  created: Scalars['Date'];
  /** The GID of the Alert */
  gid: Scalars['GID'];
  /** True if the Alert has been read by the User */
  read: Scalars['Boolean'];
  /** The _id of the Stream that the Alert was generated for */
  stream_id: Scalars['ObjectId'];
  /** The Date the Alert was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Alert was generated for */
  user_id: Scalars['ObjectId'];
};

export type BaseDashboardTab = DashboardTab & {
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type BaseSearchIncidentsAnalyticsParams = {
  /** The date to search for results after */
  after?: InputMaybe<Scalars['Date']>;
  /** The asset set ID to filter search results by */
  asset_set_id?: InputMaybe<Scalars['ObjectId']>;
  /** The date to search for results before */
  before?: InputMaybe<Scalars['Date']>;
  /** The _ids of the categories to filter search results by */
  category_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The geo filter for radius or polygon-based filtering */
  geo_filter?: InputMaybe<GeoFilterInput>;
  /** The incident types to filter search results by */
  incident_types?: InputMaybe<Array<Scalars['String']>>;
  /** The keywords to filter search results by */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** The location to filter search results by */
  longkey?: InputMaybe<Scalars['String']>;
  /** The relative timestamp to use for time based filtering */
  relative_timestamp?: InputMaybe<RelativeTimestampInput>;
  /** The severities to filter search results by */
  severities?: InputMaybe<Array<IncidentSeverity>>;
};

export type BasicAPIKeyResponse = {
  /** The API Key now belonging to the Account */
  api_key?: Maybe<APIKey>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicAccountAPIKeyResponse = {
  /** The api_key now belonging to the Account */
  api_key?: Maybe<Scalars['String']>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicAccountMemberResponse = {
  /** The AccountMember affected by the operation, if there is one */
  account_member?: Maybe<AccountMember>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The PendingAccountMember affected by the operation, if there is one */
  pending_account_member?: Maybe<PendingAccountMember>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicAnalyticsSearchResponse = {
  /** The AnalyticsSearch affected by the operation */
  analytics_search?: Maybe<AnalyticsSearch>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicColumnsTabResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The index of the ColumnsTab in the Dashboard's tabs array */
  index?: Maybe<Scalars['Int']>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The ColumnsTab affected by the operation */
  tab?: Maybe<ColumnsTab>;
};

export type BasicContactGroupResponse = {
  /** The ContactGroup affected by the operation */
  contactGroup?: Maybe<ContactGroup>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicContactResponse = {
  /** The Contact affected by the operation */
  contact?: Maybe<Contact>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicCreateCaseResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The CaseID created in Salesforce */
  id?: Maybe<Scalars['String']>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicDashboardResponse = {
  /** The Dashboard affected by the operation */
  dashboard?: Maybe<Dashboard>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicDashboardTabResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The index of the DashboardTab in the Dashboard's tabs array */
  index?: Maybe<Scalars['Int']>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The DashboardTab affected by the operation */
  tab?: Maybe<DashboardTab>;
};

export type BasicDownloadStatusResponse = {
  /** The DownloadStatus affected by the operation */
  download_status?: Maybe<DownloadStatus>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicError = {
  /** The error code */
  code: Scalars['String'];
  /** The error message */
  message: Scalars['String'];
};

export type BasicEverbridgeIntegrationResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The EverbridgeIntegration affected by the operation */
  everbridge_integration?: Maybe<EverbridgeIntegration>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicGenetecIntegrationResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The GenetecIntegration affected by the operation */
  genetecIntegration?: Maybe<GenetecIntegration>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicImpactAgentFeedbackResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The ImpactAgentFeedback affected by the operation */
  impact_agent_feedback?: Maybe<ImpactAgentFeedback>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicImpactAgentResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The ImpactAgent affected by the operation */
  impact_agent?: Maybe<ImpactAgent>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicIncidentFlagResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The IncidentFlag affected by the operation */
  incident_flag?: Maybe<IncidentFlag>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicIncidentResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The Incident affected by the operation */
  incident?: Maybe<Incident>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicIncidentSummarySessionFollowupResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The text response for the followup */
  text?: Maybe<Scalars['String']>;
};

export type BasicIncidentSummarySessionResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The IncidentSummarySession affected by the operation */
  incident_summary_session?: Maybe<IncidentSummarySession>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicMsTeamsWebhookResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The MsTeamsWebhook affected by the operation */
  ms_teams_webhook?: Maybe<MsTeamsWebhook>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicOutgoingWebhookResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The OutgoingWebhook affected by the operation */
  outgoing_webhook?: Maybe<OutgoingWebhook>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicPersonResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The Person affected by the operation */
  person?: Maybe<Person>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicPostAuthorResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The PostAuthor for the request */
  post_author?: Maybe<PostAuthor>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicProximityAssetResponse = {
  /** The ProximityAsset affected by the operation */
  asset?: Maybe<ProximityAsset>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicProximityAssetSetResponse = {
  /** The ProximityAssetSet affected by the operation */
  asset_set?: Maybe<ProximityAssetSet>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicProximityAssetsResponse = {
  /** The ProximityAssets affected by the operation */
  assets?: Maybe<Array<ProximityAsset>>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicPublicIncidentResponseNotificationResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The PublicIncidentResponseNotification affected by the operation */
  notification?: Maybe<PublicIncidentResponseNotification>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicResolverWebhookResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The ResolverWebhook affected by the operation */
  resolver_webhook?: Maybe<ResolverWebhook>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicSAMLConfigurationResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The SAMLConfiguration affected by the operation */
  saml_configuration?: Maybe<SAMLConfiguration>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicStreamResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The Stream affected by the operation */
  stream?: Maybe<Stream>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type BasicUploadResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The UploadStatus affected by the operation */
  upload_status?: Maybe<UploadStatus>;
};

export type BasicUserResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The User affected by the operation */
  user?: Maybe<User>;
};

export type BriefStatus = {
  _id: Scalars['ObjectId'];
  /** The brief_id is used to get the status of the brief and is returned when creating a brief */
  brief_id: Scalars['ObjectId'];
  /** The date the BriefStatus was inserted into the db */
  created: Scalars['Date'];
  /** The list of emails to send the RegionBrief to once complete */
  emails: Array<Scalars['String']>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The current status of the BriefStatus - ["completed", "failed", "in_progress"] */
  status: BriefStatusStatus;
  /** The most recent date the BriefStatus was updated */
  updated: Scalars['Date'];
};

export enum BriefStatusStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum BriefType {
  region = 'region',
  travel = 'travel'
}

export type CancelChangeEmailRequestParams = {
  /** The unique code for the ChangeEmailRequest */
  code: Scalars['String'];
};

export type ChangeEmailRequest = {
  /** The unique code for the ChangeEmailRequest */
  code: Scalars['String'];
  /** The email address requested to be changed to */
  email: Scalars['String'];
};

export type ClientSetting = {
  /** The ClientSetting key */
  key: Scalars['String'];
  /** The ClientSetting value, JSON.stringified */
  value: Scalars['String'];
};

export type ColumnsTab = DashboardTab & {
  /** The data specific to an ColumnsTab */
  columns_tab_data: ColumnsTabData;
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type ColumnsTabData = {
  /** The columns associated with the ColumnsTab */
  columns: Array<DashboardColumn>;
  /** The name of the ColumnsTab */
  name: Scalars['String'];
};

export type ColumnsTabDataAlertsPaneInput = {
  /** Optional name for this Alerts pane */
  name?: InputMaybe<Scalars['String']>;
  /** Optional sound config for this alerts pane */
  sound?: InputMaybe<AlertsTabDataSoundInput>;
  /** Stream ids for this alerts pane */
  streamIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Time window in seconds for this pane */
  timeWindowSeconds?: InputMaybe<Scalars['Float']>;
  /** Show only unread in this pane */
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type ColumnsTabDataColumnInput = {
  /** Panes contained in this column (defaults to a single Alerts pane if omitted) */
  panes?: InputMaybe<Array<ColumnsTabDataAlertsPaneInput>>;
};

export type Contact = {
  /** The GID of the ContactGroup this Contact belongs to */
  contactGroupGID: Scalars['GID'];
  /** The ContactMethods attached to this Contact */
  contactMethods: Array<DeliverableContactMethod>;
  /** The GID of the Contact */
  gid: Scalars['GID'];
  /** The name of the Contact */
  name: Scalars['String'];
};

export type ContactData = {
  /** The string to attach to the new Contact */
  contactMethods: Array<ContactMethodInput>;
  /** The string to attach to the new Contact */
  name: Scalars['String'];
};

export type ContactGroup = {
  /** The number of Contacts in the ContactGroup */
  contactCount: Scalars['Int'];
  /** The date the ContactGroup was created (UTC) */
  created: Scalars['Date'];
  /** The GID of the ContactGroup */
  gid: Scalars['GID'];
  /** The name of the ContactGroup */
  name: Scalars['String'];
  /** The date the ContactGroup was last updated (UTC) */
  updated: Scalars['Date'];
};

export type ContactGroupData = {
  /** The name to attach to the new ContactGroup */
  name: Scalars['String'];
};

export type ContactGroupInput = {
  /** The GID of the ContactGroup to send data to */
  contactGroupGID: Scalars['GID'];
};

export type ContactMethod = {
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
};

export type ContactMethodInput = {
  /** The data required to send data to a proximity asset */
  asset?: InputMaybe<AssetContactInput>;
  /** The data required to send data to a proximity asset set */
  asset_set?: InputMaybe<AssetSetContactInput>;
  /** The data required to send data to a contact group */
  contact_group?: InputMaybe<ContactGroupInput>;
  /** The data required to send data via email */
  email?: InputMaybe<EmailContactInput>;
  /** The data required to send data to nearby proximity assets */
  nearby_assets?: InputMaybe<NearbyAssetsContactInput>;
  /** The data required to send data via SMS */
  phone?: InputMaybe<PhoneContactInput>;
  /** The data required to send data via Slack */
  slack?: InputMaybe<SlackContactInput>;
};

export enum ContactMethodType {
  ASSET = 'ASSET',
  ASSET_SET = 'ASSET_SET',
  EMAIL = 'EMAIL',
  NEARBY_ASSETS = 'NEARBY_ASSETS',
  PHONE = 'PHONE',
  SLACK = 'SLACK',
  USER = 'USER'
}

export type CopyStreamParams = {
  /** The name to give to the copied Stream */
  name?: InputMaybe<Scalars['String']>;
  /** The GID of the Stream to copy */
  stream_gid?: InputMaybe<Scalars['GID']>;
  /** The _id of the Stream to copy */
  stream_id?: InputMaybe<Scalars['ObjectId']>;
};

export type CreateAPIKeyParams = {
  /** The name of the API Key */
  name: Scalars['String'];
};

export type CreateAlertsTabDataInput = {
  /** The list of Streams in the bottom pane of the AlertsTab */
  bottom: Array<AlertsTabDataStreamInput>;
  /** The notification sound data for the bottom pane of the AlertsTab */
  bottom_sound?: InputMaybe<AlertsTabDataSoundInput>;
  /** Map width set by sliding the resizer */
  map_width?: InputMaybe<Scalars['Float']>;
  /** The name of the AlertsTab */
  name: Scalars['String'];
  /** Pane height set by sliding the resizer */
  pane_height?: InputMaybe<Scalars['Float']>;
  /** AssetSets excluded to show on this tab */
  selected_asset_sets?: InputMaybe<Array<AlertsTabDataAssetSetInput>>;
  /** The list of Streams in the top pane of the AlertsTab */
  top: Array<AlertsTabDataStreamInput>;
  /** The notification sound data for the top pane of the AlertsTab */
  top_sound?: InputMaybe<AlertsTabDataSoundInput>;
};

export type CreateAnalyticsSearchParams = {
  /** The data to apply to the AnalyticsSearch */
  data: AnalyticsSearchData;
};

export type CreateChangeEmailRequestParams = {
  /** The email to create a ChangeEmailRequest for */
  email: Scalars['String'];
};

export type CreateColumnsTabDataInput = {
  /** Optional list of columns to create. If omitted, a single default column with one Alerts pane is created. */
  columns?: InputMaybe<Array<ColumnsTabDataColumnInput>>;
  /** The name of the ColumnsTab */
  name: Scalars['String'];
};

export type CreateContactGroupParams = {
  /** The data to use to create the ContactGroup */
  data: ContactGroupData;
};

export type CreateContactParams = {
  /** The ContactGroup to create the Contact in */
  contactGroupGID: Scalars['GID'];
  /** The data to use to create the Contact */
  data: ContactData;
};

export type CreateDarkWebStreamParams = {
  /** The filter criterion for a DarkWebStream */
  criterion: DarkWebStreamCriterionInput;
  /** The name of the Stream */
  name: Scalars['String'];
  /** The notification configuration for a DarkWebStream */
  notifications: DarkWebStreamNotificationsInput;
  /** If and how the Stream should be shared */
  share_type?: InputMaybe<StreamShareType>;
};

export type CreateDarkWebTabDataInput = {
  /** The _id of the DarkWebPost referenced by this tab */
  dark_web_post_id: Scalars['ObjectId'];
};

export type CreateDashboardColumnWithAlertsPaneParams = {
  /** The destination index of the dashboard tab */
  destinationIndex: Scalars['Int'];
  /** The key of the tab to add the new column to */
  tabKey: Scalars['String'];
};

export type CreateDashboardTabInput = {
  /** The data specific to an AlertsTab */
  alerts_tab_data?: InputMaybe<CreateAlertsTabDataInput>;
  /** The data specific to a ColumnsTab */
  columns_tab_data?: InputMaybe<CreateColumnsTabDataInput>;
  /** The data specific to a DarkWebTab */
  dark_web_tab_data?: InputMaybe<CreateDarkWebTabDataInput>;
  /** The data specific to an IncidentTab */
  incident_tab_data?: InputMaybe<CreateIncidentTabDataInput>;
  /** The type of DashboardTab */
  type: DashboardTabType;
};

export type CreateDashboardTabParams = {
  /** The DashboardTab to create */
  tab: CreateDashboardTabInput;
};

export type CreateEverbridgeIntegrationParams = {
  /** API key provided by Everbridge */
  api_key: Scalars['String'];
  /** Default category mapping for this Everbridge Integration. V1 Only. */
  default_vcc_category?: InputMaybe<Scalars['String']>;
  /** Whether or not to send updates to this Everbridge Integration */
  disabled: Scalars['Boolean'];
  /** The mappings to use when sending updates to Everbridge. V1 Only. */
  event_mapping?: InputMaybe<Array<EverbridgeIntegrationEventMappingInput>>;
  /** Whether to format the location granularity. V1 Only. */
  granularity_format?: InputMaybe<Scalars['Boolean']>;
  /** Name of the Everbridge Integration */
  name: Scalars['String'];
  /** Which datas to send or skip sending for this Everbridge Integration. V1 Only. */
  social_types?: InputMaybe<EverbridgeIntegrationSocialTypesInput>;
  /** URL to the Everbridge Integration */
  url: Scalars['String'];
  /** Which version this Everbridge Integration is. Currently only V1 or V2. */
  version: Scalars['Int'];
};

export type CreateGenetecIntegrationParams = {
  /** The map ID to use when sending messages to Genetec for the new GenetecIntegration */
  mapID?: InputMaybe<Scalars['String']>;
  /** The name of the new GenetecIntegration */
  name: Scalars['String'];
  /** The password used to access the new GenetecIntegration, encrypted */
  password: Scalars['String'];
  /** The server of the new GenetecIntegration */
  server: Scalars['URL'];
  /** The username used to access the new GenetecIntegration */
  username: Scalars['String'];
};

export type CreateImpactAgentCorrectionFeedbackParams = {
  /** The corrected category for the impact agent output */
  correct_category: Scalars['Int'];
  /** The user feedback text for the impact agent output */
  feedback_text?: InputMaybe<Scalars['String']>;
  /** The _id of the Impact Agent associated with the impact agent feedback */
  impact_agent_id: Scalars['ObjectId'];
  /** The _id of the Incident to create impact agent feedback for */
  incident_id: Scalars['ObjectId'];
  /** True when this feedback was submitted with a thumbs-down */
  is_correction: Scalars['Boolean'];
};

export type CreateImpactAgentFeedbackParams = {
  /** The corrected category for the impact agent output */
  correct_category: Scalars['Int'];
  /** The user feedback text for the impact agent output */
  feedback_text?: InputMaybe<Scalars['String']>;
  /** The _id of the Impact Agent associated with the impact agent feedback */
  impact_agent_id: Scalars['ObjectId'];
  /** The _id of the Incident to create impact agent feedback for */
  incident_id: Scalars['ObjectId'];
};

export type CreateImpactAgentParams = {
  /** The prompt used to filter impact agent matches */
  agent_filter_prompt: Scalars['String'];
  /** The prompt used to format the impact agent presentation output */
  agent_presentation_prompt?: InputMaybe<Scalars['String']>;
  /** The allowed impact agent categories used to build the response schema */
  categories: Array<ImpactAgentCategoryInput>;
  /** The display name of the ImpactAgent */
  name: Scalars['String'];
};

export type CreateIncidentFlagData = {
  /** User suggested location for the incident */
  place_id?: InputMaybe<Scalars['String']>;
  /** User comment on why this incident was flagged */
  text?: InputMaybe<Scalars['String']>;
};

export type CreateIncidentFlagParams = {
  /** Extra data provided by the User on why the Incident was flagged */
  data: CreateIncidentFlagData;
  /** The _id of the Incident to flag */
  incident_id: Scalars['ObjectId'];
  /** The user defined reason for flagging */
  type: Scalars['String'];
};

export type CreateIncidentStreamParams = {
  /** The filter criterion for a IncidentStream */
  criterion: IncidentStreamCriterionInput;
  /** The ImpactAgentStream configuration to couple to this IncidentStream */
  impact_agent_stream?: InputMaybe<ImpactAgentStreamConfigurationInput>;
  /** The name of the Stream */
  name: Scalars['String'];
  /** The notification configuration for a IncidentStream */
  notifications: IncidentStreamNotificationsInput;
  /** If and how the Stream should be shared */
  share_type?: InputMaybe<StreamShareType>;
};

export type CreateIncidentTabDataInput = {
  /** The _id of the Incident referenced by this tab */
  incident_id: Scalars['ObjectId'];
};

export type CreateMsTeamsWebhookParams = {
  /** The display name of the ms teams webhook */
  name: Scalars['String'];
  /** The url of the ms teams webhook */
  url: Scalars['String'];
};

export type CreateOutgoingWebhookParams = {
  /** The header key for the outgoing webhook */
  header_key?: InputMaybe<Scalars['String']>;
  /** The header value for the outgoing webhook */
  header_value?: InputMaybe<Scalars['String']>;
  /** The headers for the outgoing webhook */
  headers?: InputMaybe<Array<OutgoingWebhookHeaderInput>>;
  /** The display name of the outgoing webhook */
  name: Scalars['String'];
  /** The url of the outgoing webhook */
  url: Scalars['String'];
};

export type CreatePrivateIncidentParams = {
  headline: Scalars['String'];
  severity: IncidentSeverity;
  types: Array<Scalars['String']>;
  wheres: Array<CreatePrivateIncidentWhereParams>;
};

export type CreatePrivateIncidentWhereParams = {
  place_id?: InputMaybe<Scalars['String']>;
};

export type CreateProximityAssetParams = {
  /** The type of the ProximityAsset */
  asset_type: ProximityAssetType;
  /** The contact_methods of the ProximityAsset */
  contact_methods?: InputMaybe<Array<ContactMethodInput>>;
  /** The email of the ProximityAsset */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** The end date of the ProximityAsset. */
  end_date?: InputMaybe<Scalars['Date']>;
  /** The geometry representing the ProximityAsset on the globe */
  geometry?: InputMaybe<GeoJSONGeometryParams>;
  /** The open/close hours for the ProximityAsset. Follows JavaScript day conventions (ie hours at index 0 is Sunday, 1 is Monday...) */
  hours?: InputMaybe<Array<InputMaybe<ProximityAssetHoursParams>>>;
  /** The latitude of the ProximityAsset */
  lat?: InputMaybe<Scalars['Float']>;
  /** The longitude of the ProximityAsset */
  lng?: InputMaybe<Scalars['Float']>;
  /** The name of the ProximityAsset */
  name: Scalars['String'];
  /** The start date of the ProximityAsset. */
  start_date?: InputMaybe<Scalars['Date']>;
  /** The unique user defined ID of the ProximityAsset */
  uid?: InputMaybe<Scalars['String']>;
};

export type CreateProximityAssetSetParams = {
  /** The name of the ProximityAssetSet */
  name: Scalars['String'];
  /** The place level proximity of the ProximityAssetSet, in meters */
  proximity: Scalars['Int'];
};

export type CreateProximityAssetsParams = {
  /**
   * If true, will append the new ProximityAssets to the existing list
   * Else will delete the existing ProximityAssets before creating the new ones
   */
  append?: Scalars['Boolean'];
  /** The _id of the ProximityAssetSet to create these ProximityAssets in */
  asset_set_id: Scalars['ObjectId'];
  /** The ProximityAssets to be created */
  assets: Array<CreateProximityAssetParams>;
};

export type CreateRegionBriefParams = {
  /** The longkeys of the GeoDatas or GeoDataGroups to create a Region Brief for */
  longkeys: Array<Scalars['String']>;
  /** The type of the brief to generate */
  type?: BriefType;
};

export type CreateRegionBriefResponse = {
  /** The brief_id of the BriefStatus */
  brief_id: Scalars['ObjectId'];
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type CreateResetPasswordRequestParams = {
  /** The email to create a ResetPasswordRequest for */
  email: Scalars['String'];
};

export type CreateResolverWebhookParams = {
  /** The headers for the resolver webhook */
  headers?: InputMaybe<Array<ResolverWebhookHeaderInput>>;
  /** The display name of the resolver webhook */
  name: Scalars['String'];
  /** The url of the resolver webhook */
  url: Scalars['String'];
};

export type CreateWebAlertsStreamParams = {
  /** The filter criterion for a WebAlertsStream */
  criterion: WebAlertsStreamCriterionInput;
  /** The name of the Stream */
  name: Scalars['String'];
  /** The notification configuration for a WebAlertsStream */
  notifications: WebAlertsStreamNotificationsInput;
  /** If and how the Stream should be shared */
  share_type?: InputMaybe<StreamShareType>;
};

export type DarkWebAlert = BaseAlert & {
  /** The _id of the Alert */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Alert belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Alert was created */
  created: Scalars['Date'];
  /** The GID of the Alert */
  gid: Scalars['GID'];
  /** The DarkWebPost for the DarkWebAlert */
  post: DarkWebPost;
  /** True if the Alert has been read by the User */
  read: Scalars['Boolean'];
  /** The _id of the Stream that the Alert was generated for */
  stream_id: Scalars['ObjectId'];
  /** The Date the Alert was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Alert was generated for */
  user_id: Scalars['ObjectId'];
};

export type DarkWebPost = {
  /** The _id of the DarkWebPost */
  _id: Scalars['ObjectId'];
  /** The crawl date of the DarkWebPost */
  crawlDate: Scalars['Date'];
  /** The headline of the DarkWebPost, using logic to try to use whichever text fields are available on the Post */
  flattenedHeadline: Scalars['String'];
  /** The GID of the DarkWebPost */
  gid: Scalars['GID'];
  /** The headline of the DarkWebPost */
  headline?: Maybe<Scalars['String']>;
  /** The snippets of the DarkWebPost */
  snippets: TextSnippetRelay;
  /** The summary of the DarkWebPost */
  summary?: Maybe<DarkWebPostSummary>;
  /** The title of the DarkWebPost */
  title?: Maybe<Scalars['String']>;
};

export type DarkWebPostSummary = {
  /** The generated date of the summary */
  generatedOn?: Maybe<Scalars['Date']>;
  /** The generated date of the summary */
  generated_on?: Maybe<Scalars['Date']>;
  /** The text content of the summary */
  text?: Maybe<Scalars['String']>;
};

export type DarkWebStream = Stream & {
  /** The _id of the Stream */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Stream belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Stream was created */
  created: Scalars['Date'];
  /** The filter criterion for the given DarkWebStream */
  criterion: DarkWebStreamCriterion;
  /** The Date the Stream criterion was last changed */
  criterion_updated: Scalars['Date'];
  /** The Date the Stream was deleted */
  deleted_date?: Maybe<Scalars['Date']>;
  /** The GID of the Stream */
  gid: Scalars['GID'];
  /** True if the current User is the owner of the Stream */
  is_owner: Scalars['Boolean'];
  /** The name of the Stream */
  name: Scalars['String'];
  /** The notification configurations for the given DarkWebStream */
  notifications: DarkWebStreamNotifications;
  /** The owner of the Stream */
  owner?: Maybe<OtherUser>;
  /** If and how the Stream is shared */
  share_type: StreamShareType;
  /** The Date the Stream was transferred to the current owner */
  transferred_date?: Maybe<Scalars['Date']>;
  /** The type of the Stream */
  type: StreamType;
  /** The number of unread Alerts in the Stream */
  unread_count: Scalars['Int'];
  /** The Date the Stream was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Stream belongs to */
  user_id: Scalars['ObjectId'];
};

export type DarkWebStreamCriterion = {
  lucene_string?: Maybe<IncidentStreamLuceneStringCriterion>;
};

export type DarkWebStreamCriterionInput = {
  /** The Lucene string to filter the WebAlertsStream Alerts by */
  lucene_string?: InputMaybe<StandardStreamLuceneStringCriterionInput>;
};

export type DarkWebStreamNotifications = {
  /** The email notification configuration for the given DarkWebStream */
  email: IncidentStreamEmailNotifications;
};

export type DarkWebStreamNotificationsInput = {
  /** The email notification configuration for a DarkWebStream */
  email: IncidentStreamEmailNotificationsInput;
};

export type DarkWebTab = DashboardTab & {
  /** The data specific to a DarkWebTab */
  dark_web_tab_data: DarkWebTabData;
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type DarkWebTabData = {
  /** The _id of the DarkWebPost referenced by this tab */
  dark_web_post_id: Scalars['ObjectId'];
};

export type Dashboard = {
  /** The _id of the Dashboard */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the Dashboard belongs to */
  account_id: Scalars['ObjectId'];
  /** The tabs of the Dashboard */
  tabs: Array<DashboardTab>;
  /** When the Dashboard was last updated */
  updated: Scalars['Date'];
  /** The _id of the User the Dashboard belongs to */
  user_id: Scalars['ObjectId'];
};

export type DashboardColumn = {
  /** The _id of this DashboardColumn */
  _id: Scalars['ObjectId'];
  /** The panes held by this column */
  panes: Array<DashboardPane>;
};

export type DashboardPane = {
  /** The unique key of the DashboardPane */
  key: Scalars['String'];
  /** The type of the DashboardPane */
  type: DashboardPaneType;
};

export enum DashboardPaneType {
  ALERTS = 'ALERTS'
}

export type DashboardTab = {
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export enum DashboardTabType {
  ALERTS = 'ALERTS',
  COLUMNS = 'COLUMNS',
  DARK_WEB = 'DARK_WEB',
  HISTORICAL_SEARCH = 'HISTORICAL_SEARCH',
  INCIDENT = 'INCIDENT',
  SEARCH = 'SEARCH',
  SETTINGS = 'SETTINGS',
  STREAM_MANAGER = 'STREAM_MANAGER',
  TRACKED_EVENT = 'TRACKED_EVENT'
}

export type DashboardTabUpdateCount = {
  /** The update count for the given DashboardTab */
  count: Scalars['Int'];
  /** The _id of the DashboardTab this count is for */
  tab_id: Scalars['ObjectId'];
};

export type DeepLinkData = {
  /** The type of SearchStream update the link came from */
  alert_type: Scalars['String'];
  /** Where the link came from */
  source: Scalars['String'];
  /** The stream_id that generated the notification */
  stream_id?: Maybe<Scalars['ObjectId']>;
};

export type DefaultEverbridgeIntegration = {
  /** Whether this integration is currently disabled */
  disabled: Scalars['Boolean'];
  /** How to map Samdesk events to Everbridge labels */
  event_mapping: Array<EverbridgeIntegrationRawEventMapping>;
  /** URL of the integration on Everbridge */
  url: Scalars['String'];
};

export type DeleteAPIKeyParams = {
  /** The GID of the API Key to delete */
  gid: Scalars['GID'];
};

export type DeleteAccountMemberParams = {
  /** The _id of the AccountMember to delete (either UserAccount or PendingUserAccount id) */
  _id: Scalars['ObjectId'];
};

export type DeleteAnalyticsSearchParams = {
  /** The GID of the AnalyticsSearch to delete */
  gid: Scalars['GID'];
};

export type DeleteContactGroupParams = {
  /** The gid of the ContactGroup to delete */
  gid: Scalars['GID'];
};

export type DeleteContactParams = {
  /** The gid of the Contact to delete */
  gid: Scalars['GID'];
};

export type DeleteDashboardColumnParams = {
  /** The _id of the DashboardColumn to delete */
  columnId: Scalars['ObjectId'];
  /** The key of the tab to remove the column from */
  tabKey: Scalars['String'];
};

export type DeleteDashboardTabParams = {
  /** The key of the DashboardTab to delete */
  key: Scalars['String'];
};

export type DeleteEverbridgeIntegrationParams = {
  /** _id of the EverbridgeIntegration to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteGenetecIntegrationByGIDParams = {
  /** The gid of the GenetecIntegration to delete */
  gid: Scalars['GID'];
};

export type DeleteMsTeamsWebhookParams = {
  /** The _id of the MsTeamsWebhook to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteOutgoingWebhookParams = {
  /** The _id of the OutgoingWebhook to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteProximityAssetSetParams = {
  /** The _id of the ProximityAssetSet to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteProximityAssetsParams = {
  /** The _ids of the ProximityAssets to delete */
  _ids: Array<Scalars['ObjectId']>;
  /** The _id of the ProximityAssetSet to delete the ProximityAssets from */
  asset_set_id: Scalars['ObjectId'];
};

export type DeleteResolverWebhookParams = {
  /** The _id of the ResolverWebhook to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteSalesforceIntegrationParams = {
  /** The _id of the SalesforceIntegration to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteSlackWebhookParams = {
  /** The _id of the SlackWebhook to delete */
  _id: Scalars['ObjectId'];
};

export type DeleteSlackWorkspaceParams = {
  /** The _id of the SlackWorkspace to delete */
  workspaceGID: Scalars['GID'];
};

export type DeleteStreamParams = {
  /** The _id of the Stream to delete */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The GID of the Stream to delete */
  gid?: InputMaybe<Scalars['GID']>;
  /**
   * If true, will delete the Stream immediately
   * Else will set deleted_date and kick off a TTL
   */
  hard_delete?: Scalars['Boolean'];
};

export type DeliverableContactMethod = EmailContact | PhoneContact | SlackContact;

export enum DisplayUnit {
  IMPERIAL = 'IMPERIAL',
  METRIC = 'METRIC'
}

export type DownloadStatus = {
  /** The Date that the DownloadStatus was created */
  created: Scalars['Date'];
  /** The User who initiated the DownloadStatus */
  created_by: User;
  /** Any errors that happened during the download represented by this DownloadStatus */
  download_errors: Array<BasicError>;
  /** The date after which the file generated by this DownloadStatus will no longer be available */
  expiration_date?: Maybe<Scalars['Date']>;
  /** The URL through which the file created by this download can be access. Will only be available once completed. */
  file_url?: Maybe<Scalars['String']>;
  /** The GID of the download represented by this DownloadStatus */
  gid: Scalars['GID'];
  /** The current progress of this DownloadStatus */
  progress: DownloadStatusProgress;
  /** The purpose of this DownloadStatus */
  purpose: DownloadStatusPurpose;
  /** The status of this DownloadStatus */
  status: DownloadStatusStatus;
  /** The GID of the object affected by this DownloadStatus */
  target_gid: Scalars['GID'];
  /** The Date that the DownloadStatus was last updated */
  updated: Scalars['Date'];
};

export type DownloadStatusProgress = {
  /** The current number of items retrieved so far by the download represented by this DownloadStatus */
  count: Scalars['Int'];
  /** The percent of items retrieved so far by the download represented by this DownloadStatus */
  percent: Scalars['Float'];
  /** The total number of items being retrieved by the download represented by this DownloadStatus in total */
  total: Scalars['Int'];
};

export enum DownloadStatusPurpose {
  ProximityAssetSet_Assets = 'ProximityAssetSet_Assets',
  TweetEventAnalyticsReport = 'TweetEventAnalyticsReport'
}

export enum DownloadStatusStatus {
  /** The Download completed and the file is ready. */
  COMPLETED = 'COMPLETED',
  /** The Download failed and has been cancelled. */
  FAILED = 'FAILED',
  /** The Download has been received by the server and is queued for processing. */
  PENDING = 'PENDING',
  /** The Download is being processed by the server. */
  PROCESSING = 'PROCESSING'
}

export type EmailContact = ContactMethod & {
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The email address to send data to */
  emailValue: Scalars['EmailAddress'];
  /**
   * The email address to send data to
   * @deprecated replaced by emailValue
   */
  email_value: Scalars['EmailAddress'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
};

export type EmailContactInput = {
  /** The email address to send data to */
  value: Scalars['EmailAddress'];
};

export type EnableOutgoingWebhookParams = {
  /** The _id of the OutgoingWebhook to enable */
  _id: Scalars['ObjectId'];
};

export type EverbridgeIntegration = {
  /** The _id of the EverbridgeIntegration */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that owns this EverbridgeIntegration */
  account: Scalars['ObjectId'];
  /** API key given to the account by Everbridge */
  api_key: Scalars['String'];
  /** When this EverbridgeIntegration was created */
  created?: Maybe<Scalars['Date']>;
  /** Version 1 only. Which VCC category use as default for unmapped event types. */
  default_vcc_category?: Maybe<Scalars['String']>;
  /** Whether this integration is currently disabled */
  disabled: Scalars['Boolean'];
  /** How to map Samdesk events to Everbridge labels */
  event_mapping?: Maybe<Array<EverbridgeIntegrationRawEventMapping>>;
  /** Version 1 only. Whether we add granularity to the formatting. */
  granularity_format?: Maybe<Scalars['Boolean']>;
  /** The name of the EverbridgeIntegration */
  name: Scalars['String'];
  /** Version 1 only. Which social types are allowed to be sent to this integration. */
  social_types?: Maybe<EverbridgeIntegrationSocialTypes>;
  /** When this EverbridgeIntegration was last updated */
  updated?: Maybe<Scalars['Date']>;
  /** URL of the integration on Everbridge */
  url: Scalars['String'];
  /** Which version this integration is */
  version: Scalars['Int'];
};

export type EverbridgeIntegrationEventMappingInput = {
  /** The Samdesk event type to map to Everbridge */
  event_type: Scalars['String'];
  /** Which severity events of this type we want to send to Everbridge */
  severity_level: Scalars['String'];
  /** The corresponding Everbridge category */
  vcc_category: Scalars['String'];
};

export type EverbridgeIntegrationRawEventMapping = {
  /** Event type to map to Everbridge VCC Category */
  event_type: Scalars['String'];
  /** Which severity levels to send to Everbridge for this event type */
  severity_level: Scalars['String'];
  /** The corresponding Everbridge VCC category */
  vcc_category: Scalars['String'];
};

export type EverbridgeIntegrationSocialTypes = {
  /** Used in V1 Only. Whether tweet events with social type twitter are allowed for this integration. */
  twitter: Scalars['Boolean'];
  /** Used in V1 Only. Whether tweet events with social type twitter are allowed for this integration. */
  web: Scalars['Boolean'];
};

export type EverbridgeIntegrationSocialTypesInput = {
  /** Whether we send twitter datas to this Everbridge Integration */
  twitter: Scalars['Boolean'];
  /** Whether we send web datas to this Everbridge Integration */
  web: Scalars['Boolean'];
};

export type EverbridgeVCCCategory = {
  /** The _id of the EverbridgeVCCCategory */
  _id: Scalars['ObjectId'];
  /** The name of the EverbridgeVCCCategory */
  category: Scalars['String'];
};

export enum FollowupQuestionType {
  primary = 'primary',
  suggested = 'suggested'
}

export type FormattedWhere = {
  /** The compact display name of the referenced location */
  compact_display: Scalars['String'];
  /** The full display name of the referenced location */
  display: Scalars['String'];
  /** The lat/lng of the referenced location */
  geo?: Maybe<GeoPoint>;
  /** The longkey of the referenced location */
  longkey: Scalars['String'];
};

export type GenetecIntegration = {
  /** The _id of the GenetecIntegration */
  _id: Scalars['ObjectId'];
  /** The GID of the Account that owns the GenetecIntegration */
  accountGID: Scalars['GID'];
  /** The GID of the Account that owns the GenetecIntegration */
  accountID: Scalars['ObjectId'];
  /** When this GenetecIntegration was created */
  created: Scalars['Date'];
  /** If the GenetecIntegration has been disabled due to multiple consecutive errors */
  disabled: Scalars['Boolean'];
  /** The GID of the GenetecIntegration */
  gid: Scalars['GID'];
  /** The ID of the map to use when sending messages to the GenetecIntegration */
  mapID?: Maybe<Scalars['String']>;
  /** The name of the GenetecIntegration */
  name: Scalars['String'];
  /** The server to use for the genetec integration */
  server: Scalars['URL'];
  /** When this GenetecIntegration was last updated */
  updated: Scalars['Date'];
  /** The username to use for the GenetecIntegration */
  username: Scalars['String'];
};

export type GeoFilterInput = {
  geometry: GeoJSONGeometryParams;
  radius_km?: InputMaybe<Scalars['Float']>;
};

export type GeoJSONGeometry = {
  /** The GeoJSON LineString representing the geometry, if type === LINESTRING */
  line_string?: Maybe<Array<Scalars['LngLat']>>;
  /** The GeoJSON Point representing the geometry, if type === POINT */
  point?: Maybe<Scalars['LngLat']>;
  /** The GeoJSON Polygon representing the geometry, if type === POLYGON */
  polygon?: Maybe<Array<Array<Scalars['LngLat']>>>;
  /** The type of the GeoJSONGeometry */
  type: GeoJSONType;
};

export type GeoJSONGeometryParams = {
  /** The GeoJSON LineString representing the geometry, if type === LINESTRING */
  line_string?: InputMaybe<Array<Scalars['LngLat']>>;
  /** The GeoJSON Point representing the geometry, if type === POINT */
  point?: InputMaybe<Scalars['LngLat']>;
  /** The GeoJSON Polygon representing the geometry, if type === POLYGON */
  polygon?: InputMaybe<Array<Array<Scalars['LngLat']>>>;
  /** The type of the GeoJSONGeometry */
  type: GeoJSONType;
};

export enum GeoJSONType {
  LINESTRING = 'LINESTRING',
  POINT = 'POINT',
  POLYGON = 'POLYGON'
}

export type GeoPoint = {
  /** latitude */
  lat: Scalars['Float'];
  /** longitude */
  lng: Scalars['Float'];
};

export type GetAccountInvitationParams = {
  /** The verification code sent to the person in the invitation */
  verification_code: Scalars['String'];
};

export type GetAnalyticsSearchParams = {
  /** The gid of the AnalyticsSearch to get */
  gid: Scalars['GID'];
};

export type GetBriefStatusParams = {
  /** The brief_id of the desired brief */
  brief_id: Scalars['ObjectId'];
};

export type GetChangeEmailRequestParams = {
  /** The unique code for the ChangeEmailRequest */
  code: Scalars['String'];
};

export type GetContactGroupParams = {
  /** The gid of the ContactGroup to get */
  gid: Scalars['GID'];
};

export type GetContactParams = {
  /** The gid of the Contact to get */
  gid: Scalars['GID'];
};

export type GetDarkWebPostParams = {
  /** The _id of the DarkWebPost to get */
  _id: Scalars['ObjectId'];
};

export type GetDownloadStatusParams = {
  /** The purpose of the relevant DownloadStatus */
  purpose: DownloadStatusPurpose;
  /** The gid of the object to retrieve an DownloadStatus for */
  target_gid: Scalars['GID'];
};

export type GetEverbridgeIntegrationParams = {
  /** The _id of the EverbridgeIntegration to get */
  _id: Scalars['ObjectId'];
};

export type GetGenetecIntegrationByGIDParams = {
  /** The gid of the GenetecIntegration to get */
  gid: Scalars['GID'];
};

export type GetImpactAgentParams = {
  /** The _id of the ImpactAgent */
  _id: Scalars['ObjectId'];
};

export type GetIncidentCountsParams = {
  /** The _id of the Incident to get counts for */
  _id: Scalars['ObjectId'];
};

export type GetIncidentFeaturedContentParams = {
  /** The _id of the Incident to get the IncidentFeaturedContent for */
  incident_id: Scalars['ObjectId'];
};

export type GetIncidentParams = {
  /** The _id of the Incident to get */
  _id: Scalars['ObjectId'];
  /** If true, the backend will follow merge chains and return the final Incident */
  follow_merges?: InputMaybe<Scalars['Boolean']>;
};

export type GetIncidentSummarySessionByGIDParams = {
  /** The gid of the Incident to get the IncidentSummarySession for */
  incidentGID: Scalars['GID'];
  /** Used during testing, use this param to include analysis in the summary */
  include_analysis?: InputMaybe<Scalars['Boolean']>;
};

export type GetIncidentSummarySessionFollowupParams = {
  /** The GID of the followup question to ask */
  followup_question_gid: Scalars['GID'];
};

export type GetIncidentSummarySessionParams = {
  /** The _id of the Incident to get the IncidentSummarySession for */
  incident_id: Scalars['ObjectId'];
  /** Used during testing, use this param to include analysis in the summary */
  include_analysis?: InputMaybe<Scalars['Boolean']>;
};

export type GetMsTeamsWebhookParams = {
  /** The _id of the MsTeamsWebhook to get */
  _id: Scalars['ObjectId'];
};

export type GetOutgoingWebhookParams = {
  /** The _id of the OutgoingWebhook to get */
  _id: Scalars['ObjectId'];
};

export type GetPostAuthorByUrlParams = {
  /** The URL of the PostAuthor to get */
  url: Scalars['URL'];
};

export type GetProximityAssetParams = {
  /** The _id of the ProximityAsset to get */
  _id: Scalars['ObjectId'];
};

export type GetProximityAssetSetParams = {
  /** The _id of the ProximityAssetSet to get */
  _id: Scalars['ObjectId'];
};

export type GetPublicIncidentResponseNotificationByUUIDParams = {
  /** The UUID of the IncidentResponseNotification to get */
  uuid: Scalars['UUID'];
};

export type GetResetPasswordRequestParams = {
  /** The unique code for the ResetPasswordRequest */
  code: Scalars['String'];
};

export type GetResolverWebhookParams = {
  /** The _id of the ResolverWebhook to get */
  _id: Scalars['ObjectId'];
};

export type GetSlackContactParams = {
  /** The Slack data to get the SlackContact for */
  slack: SlackContactInput;
};

export type GetSlackWebhookParams = {
  /** The _id of the SlackWebhook to get */
  _id: Scalars['ObjectId'];
};

export type GetSlackWorkspaceParams = {
  /** The gid of the SlackWorkspace to get */
  workspaceGID: Scalars['GID'];
};

export type GetStreamParams = {
  /** The _id of the Stream to get */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The GID of the Stream to get */
  gid?: InputMaybe<Scalars['GID']>;
};

export type GetTravelRegionDataParams = {
  /** Which country to get the region data for */
  country: Scalars['String'];
  /** Which status of traveller we are collecting data for (active or pending) */
  status: Scalars['String'];
};

export type GetWeatherParams = {
  /** The latitude */
  lat: Scalars['Float'];
  /** The longitude */
  lng: Scalars['Float'];
};

export type GetWhereByLongkeyParams = {
  /** The longkey for the Where to get */
  longkey: Scalars['String'];
};

export type HeatmapPoint = {
  /** Number of Incidents */
  count: Scalars['Int'];
  /** Latitude */
  lat: Scalars['Float'];
  /** Longitude */
  lng: Scalars['Float'];
};

export enum HelpLevel {
  ADMIN = 'ADMIN',
  ALL = 'ALL',
  NONE = 'NONE'
}

export type HistoricalSearchTab = DashboardTab & {
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type IUser = {
  /** The _id of the IUser */
  _id: Scalars['ObjectId'];
  /** The email of the IUser */
  email: Scalars['String'];
  /** The gid of the IUser */
  gid: Scalars['GID'];
  /** The name of the IUser */
  name: Scalars['String'];
};

export type ImpactAgent = {
  /** The _id of the ImpactAgent */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that owns the ImpactAgent */
  account_id: Scalars['ObjectId'];
  /** The prompt used to filter impact agent matches */
  agent_filter_prompt: Scalars['String'];
  /** The prompt used to format the impact agent presentation output */
  agent_presentation_prompt?: Maybe<Scalars['String']>;
  /** The allowed impact agent categories */
  categories: Array<ImpactAgentCategory>;
  /** The Date the ImpactAgent was created */
  created: Scalars['Date'];
  /** The display name of the ImpactAgent */
  name: Scalars['String'];
  /** The Date the ImpactAgent was updated */
  updated: Scalars['Date'];
};

export type ImpactAgentCategory = {
  /** The description for this impact agent category */
  description: Scalars['String'];
  /** The numeric category value used by the impact agent response */
  value: Scalars['Int'];
};

export type ImpactAgentCategoryInput = {
  /** The description for this impact agent category */
  description: Scalars['String'];
  /** The numeric category value used by the impact agent response */
  value: Scalars['Int'];
};

export type ImpactAgentFeedback = {
  /** The _id of the Impact Agent feedback */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that created the impact agent feedback */
  account_id: Scalars['ObjectId'];
  /** The category assigned by the Impact Agent */
  agent_assigned_category: Scalars['Int'];
  /** The reasoning provided by the Impact Agent */
  agent_assigned_reasoning: Scalars['String'];
  /** The author of the incident trigger post */
  author?: Maybe<Scalars['String']>;
  /** The corrected category for the impact agent output */
  correct_category: Scalars['Int'];
  /** The date the feedback was created */
  created: Scalars['Date'];
  /** The review state of the feedback */
  feedback_status: ImpactAgentFeedbackStatus;
  /** The freeform feedback text for the impact agent output */
  feedback_text?: Maybe<Scalars['String']>;
  /** The _id of the Impact Agent associated with the impact agent feedback */
  impact_agent_id: Scalars['ObjectId'];
  /** The _id of the Incident associated with the impact agent feedback */
  incident_id: Scalars['ObjectId'];
  /** The ML-generated incident title */
  incident_title?: Maybe<Scalars['String']>;
  /** True when the feedback was submitted as a thumbs-down correction */
  is_correction?: Maybe<Scalars['Boolean']>;
  /** The incident location */
  location?: Maybe<Scalars['String']>;
  /** The model used to generate the impact agent output */
  model_used: Scalars['String'];
  /** The name of the account that submitted the feedback */
  submitting_analyst: Scalars['String'];
  /** The date the feedback was last updated */
  updated: Scalars['Date'];
};

export enum ImpactAgentFeedbackStatus {
  APPLIED = 'APPLIED',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type ImpactAgentStreamConfiguration = {
  /** The _id of the ImpactAgent linked to this Search Stream */
  impact_agent_id: Scalars['ObjectId'];
  /** The category-matching configuration for the linked ImpactAgent */
  match_config: ImpactAgentStreamMatchConfig;
};

export type ImpactAgentStreamConfigurationInput = {
  /** The _id of the ImpactAgent to link to the created IncidentStream */
  impact_agent_id: Scalars['ObjectId'];
  /** The category-matching configuration for the linked ImpactAgent */
  match_config: ImpactAgentStreamMatchConfigInput;
};

export type ImpactAgentStreamMatchConfig = {
  /** The impact agent categories to match for the linked search stream */
  match_categories: Array<Scalars['Int']>;
};

export type ImpactAgentStreamMatchConfigInput = {
  /** The impact agent categories to match for the linked search stream */
  match_categories?: InputMaybe<Array<Scalars['Int']>>;
};

export type Incident = {
  /** The _id of the Incident */
  _id: Scalars['ObjectId'];
  /** The description of the area affected by the Incident */
  area_description?: Maybe<Scalars['String']>;
  /** The Date that the Incident was or will be completed */
  completed_date?: Maybe<Scalars['Date']>;
  /** The OtherUser who originally created the Incident (only relevant for private Incidents) */
  createdBy?: Maybe<OtherUser>;
  /** The Date that the Incident was originally detected */
  detected_date?: Maybe<Scalars['Date']>;
  /** The Date that the Incident expires */
  expiration_date?: Maybe<Scalars['Date']>;
  /** The geometries of the Incident */
  geometries: Array<GeoJSONGeometry>;
  /** The GID of the Incident */
  gid: Scalars['GID'];
  /** If true, the Incident has featured RTC content */
  has_featured_content: Scalars['Boolean'];
  /** The headline to show for the Incident */
  headline: IncidentHeadline;
  /** The impact information for the Incident */
  impact?: Maybe<IncidentImpact>;
  /** The impact agent information for the Incident */
  impact_agent?: Maybe<IncidentImpactAgent>;
  /** The IncidentResponse associated with this Incident */
  incident_response?: Maybe<IncidentResponse>;
  /** The list of InputStream _ids that the Incident matches */
  input_streams: Array<Scalars['ObjectId']>;
  /** If true, the Incident was featured by RTC */
  is_featured: Scalars['Boolean'];
  /** If true, the Incident is being monitored by RTC */
  is_live: Scalars['Boolean'];
  /** The lifecycle stage of the Incident */
  lifecycle: IncidentLifecycle;
  /** The _id of the Incident that the Incident has been merged into */
  merged_into?: Maybe<Scalars['ObjectId']>;
  /** The ProximityAssets that are nearby the Incident */
  nearby_assets: Array<NearbyProximityAsset>;
  /** The polygons representing the Incident's affected area */
  polygons: Array<Scalars['String']>;
  /** If true, the Incident is private to the requesting Account */
  private: Scalars['Boolean'];
  /** The severity of the Incident */
  severity: IncidentSeverity;
  /** A snapshot of the current state of the Incident */
  snapshot: IncidentSnapshot;
  /** The status of the Incident */
  status: IncidentStatus;
  /** The summary of the Incident */
  summary: IncidentSummaryGenerated;
  /** The tags of the Incident */
  tags: Array<Scalars['String']>;
  /** The timezone of the Incident */
  timezone: Array<Scalars['String']>;
  /** How many posts are associated with this Incident */
  total_posts: Scalars['Int'];
  /** The types of the Incident */
  types: Array<Scalars['String']>;
  /** The warning type of the Incident */
  warning_type: IncidentWarningType;
  /** The wheres of the Incident */
  wheres: Array<Where>;
};


export type Incidentimpact_agentArgs = {
  impact_agent_id?: InputMaybe<Scalars['ObjectId']>;
};

export type IncidentAlert = BaseAlert & {
  /** The _id of the Alert */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Alert belongs to */
  account_id: Scalars['ObjectId'];
  /** The single closest ProximityMatch for this Alert */
  closest_proximity?: Maybe<ProximityMatch>;
  /** The Date the Alert was created */
  created: Scalars['Date'];
  /** The Date the Incident referenced by the Alert was created */
  detected_date: Scalars['Date'];
  /** If true, this Alert is the first time the referenced Incident has matched the referenced Stream */
  first_match: Scalars['Boolean'];
  /** The GID of the Alert */
  gid: Scalars['GID'];
  /** The gid of the Incident referenced by the given Alert */
  incident_gid: Scalars['GID'];
  /** The _id of the Incident referenced by the given Alert */
  incident_id: Scalars['ObjectId'];
  /** The IncidentUpdate that generated the Alert, or null if it is hidden from the account */
  incident_update?: Maybe<IncidentUpdate>;
  /** The _id of the IncidentUpdate that generated the Alert */
  incident_update_id: Scalars['ObjectId'];
  /** The list of ProximityMatches for the given Alert */
  proximity_matches: Array<ProximityMatch>;
  /** True if the Alert has been read by the User */
  read: Scalars['Boolean'];
  /** The list of recent AlertHeadlines for the given Alert */
  recent_headlines: Array<AlertHeadline>;
  /** The _id of the Stream that the Alert was generated for */
  stream_id: Scalars['ObjectId'];
  /** The Date the Alert was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Alert was generated for */
  user_id: Scalars['ObjectId'];
};

export type IncidentConnection = {
  nodes: Array<Incident>;
  pageInfo: PageInfo;
};

export type IncidentCounts = {
  /** The number of media items associated with this Incident after applying account social filters */
  media_count: Scalars['Int'];
  /** The number of assets that are near this Incident */
  nearby_asset_count: Scalars['Int'];
  /** The number of incidents that are near this Incident */
  nearby_incident_count: Scalars['Int'];
  /** The number of posts associated with this Incident after applying account social filters */
  post_count: Scalars['Int'];
};

export type IncidentFeaturedContent = {
  /** The Date that the IncidentFeaturedContent was created */
  created: Scalars['Date'];
  /** The _id of the Incident that this IncidentFeaturedContent is for */
  incident_id: Scalars['ObjectId'];
  /** The featured content items */
  items: Array<IncidentFeaturedContentItem>;
  /** The Date that the IncidentFeaturedContent was last updated */
  updated: Scalars['Date'];
};

export type IncidentFeaturedContentItem = {
  /** The data for if the IncidentFeaturedContentItem is type === embed */
  embed_data?: Maybe<IncidentFeaturedEmbedData>;
  /** The data for if the IncidentFeaturedContentItem is type === incident */
  incident_data?: Maybe<IncidentFeaturedIncidentData>;
  /** The unique key of the IncidentFeaturedContentItem */
  key: Scalars['String'];
  /** The IncidentFeaturedContentItems nested under this one */
  nested: Array<IncidentFeaturedContentItem>;
  /** The data for if the IncidentFeaturedContentItem is type === note */
  note_data?: Maybe<IncidentFeaturedNoteData>;
  /** The data for if the IncidentFeaturedContentItem is type === post */
  post?: Maybe<Post>;
  /**
   * The data for if the IncidentFeaturedContentItem is type === post
   * @deprecated Replaced with post
   */
  post_data?: Maybe<IncidentFeaturedPostData>;
  /** The type of the IncidentFeaturedContentItem */
  type: Scalars['String'];
};

export type IncidentFeaturedEmbedData = {
  /** The Date that the FeaturedEmbed was created at */
  created_at: Scalars['Date'];
  /** The code to embed the FeaturedEmbed */
  embed_code: Scalars['String'];
};

export type IncidentFeaturedIncidentData = {
  /** The _id of the FeaturedIncident */
  incident_id: Scalars['String'];
};

export type IncidentFeaturedNoteData = {
  /** The _id of the author of the FeaturedNote */
  author_id: Scalars['String'];
  /** The name of the author of the FeaturedNote */
  author_name: Scalars['String'];
  /** The Date that the FeaturedNote was created at */
  created_at: Scalars['Date'];
  /** The text of the FeaturedNote */
  text: Scalars['String'];
};

export type IncidentFeaturedPostData = {
  /** The avatar url of the author of the FeaturedPost */
  author_avatar: Scalars['String'];
  /** The handle of the author of the FeaturedPost */
  author_handle: Scalars['String'];
  /** The id of the author of the FeaturedPost */
  author_id: Scalars['String'];
  /** The name of the author of the FeaturedPost */
  author_name: Scalars['String'];
  /** The permalink of the author of the FeaturedPost */
  author_permalink: Scalars['String'];
  /** The Date that the FeaturedPost was created at */
  created_at: Scalars['Date'];
  /** The medias of the FeaturedPost */
  medias: Array<PostMedia>;
  /** The permalink of the FeaturedPost */
  permalink: Scalars['String'];
  /** The public_id of the FeaturedPost */
  public_id: Scalars['String'];
  /** Social Type of the Post */
  social_type: SocialType;
  /** The subtext of the FeaturedPost */
  subtext?: Maybe<Scalars['String']>;
  /** The text of the FeaturedPost */
  text: Scalars['String'];
};

export type IncidentFlag = {
  /** The _id of the IncidentFlag */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that flagged the Incident */
  account_id?: Maybe<Scalars['ObjectId']>;
  /** When this IncidentFlag was created */
  created: Scalars['Date'];
  /** The extra information provided by the user on why they flagged the Incident */
  data?: Maybe<IncidentFlagData>;
  /** The _id of the Incident being flagged */
  incident?: Maybe<Scalars['ObjectId']>;
  /** When this flag was resolved and by who */
  resolved?: Maybe<IncidentFlagResolved>;
  /** The type of the IncidentFlag */
  type: Scalars['String'];
  /** The _id of the User that flagged the Incident */
  user_id?: Maybe<Scalars['ObjectId']>;
};

export type IncidentFlagData = {
  /** The longkey suggested by location feedback */
  longkey?: Maybe<Scalars['String']>;
  /** Place ID provided by the user on where they believe the incident should be taking place */
  place_id?: Maybe<Scalars['String']>;
  /** Text provided by the user on why the incident was flagged */
  text?: Maybe<Scalars['String']>;
};

export type IncidentFlagResolved = {
  /** Who resolved the flag */
  by: Scalars['String'];
  /** When the flag was resolved */
  date: Scalars['Date'];
};

export type IncidentHeadline = {
  /** The headline source (i.e. author name) */
  source?: Maybe<Scalars['String']>;
  /** The headline text */
  text?: Maybe<Scalars['String']>;
  /** The headline type */
  type?: Maybe<IncidentHeadlineType>;
};

export enum IncidentHeadlineType {
  COMPUTED = 'COMPUTED',
  KI = 'KI',
  MANUAL = 'MANUAL',
  ML = 'ML',
  UNKNOWN = 'UNKNOWN'
}

export type IncidentImpact = {
  /** The reason for the impact */
  reason: Scalars['String'];
  /** The type of impact */
  type: Scalars['String'];
};

export type IncidentImpactAgent = {
  /** The impact agent category */
  category: Scalars['Int'];
  /** The impact agent filter evidence */
  filter_evidence: Scalars['String'];
  /** The _id of the Impact agent */
  impact_agent_id: Scalars['ObjectId'];
  /** The impact agent presentation evidence */
  presentation_evidence?: Maybe<Scalars['String']>;
};

export enum IncidentLifecycle {
  ACTIVE = 'ACTIVE',
  CLEAR = 'CLEAR',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING'
}

export type IncidentResponse = {
  /** When the IncidentResponse was acknowledged */
  acknowledgedAt?: Maybe<Scalars['Date']>;
  /** The IncidentResponseActions associated with this IncidentResponse */
  actions: IncidentResponseActionRelay;
  /** Aggregate data of all IncidentResponseNotifications of this IncidentResponse */
  aggregates: IncidentResponseNotificationAggregates;
  /** The ContactMethod who first acknowledged the IncidentResponse */
  createdBy: ContactMethod;
  /** The gid of the IncidentResponse */
  gid: Scalars['GID'];
  /** The Incident associated with this IncidentResponse */
  incident?: Maybe<Incident>;
  /** The ContactMethod who last acknowledged the IncidentResponse */
  lastAcknowledgedBy: ContactMethod;
  /** When the IncidentResponse was resolved */
  resolvedAt?: Maybe<Scalars['Date']>;
};


export type IncidentResponseactionsArgs = {
  params?: InputMaybe<ListIncidentResponseActionsByIncidentResponseParams>;
};

export type IncidentResponseAction = {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
};

export type IncidentResponseActionAcknowledged = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
};

/** Target specific. Fires when all notifications for a given target are determined to have been processed. */
export type IncidentResponseActionNotificationCompleted = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
  /** The status of the notification that completed processing */
  notificationStatus: IncidentResponseNotificationNotificationStatus;
  /** More details about the status of the notification */
  notificationStatusMessage?: Maybe<Scalars['String']>;
  /** The IncidentResponseNotification associated with notifying this ContactMethod */
  target: IncidentResponseActionNotificationTarget;
};

/** Message specific. Fires when one individual notification (SMS, Email, or Slack) has been processed. */
export type IncidentResponseActionNotificationProcessed = IncidentResponseAction & {
  /** The ContactMethod the notification was processed for */
  contactMethod: ContactMethod;
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
  /** The status of the notification that was processed */
  notificationStatus: IncidentResponseNotificationNotificationStatus;
  /** More details about the status of the notification */
  notificationStatusMessage?: Maybe<Scalars['String']>;
  /** The IncidentResponseNotification associated with notifying this ContactMethod */
  target: IncidentResponseActionNotificationTarget;
};

/** Target specific. Fires when notifications for a given target have been queued for processing. */
export type IncidentResponseActionNotificationQueued = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
  /** The IncidentResponseNotification associated with notifying this ContactMethod */
  target: IncidentResponseActionNotificationTarget;
};

export type IncidentResponseActionNotificationTarget = {
  /** The IncidentResponseNotification associated with this target */
  notification: IncidentResponseNotification;
};

export type IncidentResponseActionNotified = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The message sent along with the IncidentResponseNotifications sent as part of this IncidentResponseActionNotified */
  message?: Maybe<Scalars['String']>;
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
  /**
   * The IncidentResponseNotification sent as part of this IncidentResponseActionNotified
   * @deprecated  Replaced by targets
   */
  notifications: Array<IncidentResponseNotification>;
  /** The IncidentResponseActionNotifiedTargets notifications were sent to as part of this IncidentResponseActionNotified */
  targets: Array<IncidentResponseActionNotifiedTarget>;
};

export type IncidentResponseActionNotifiedResponded = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
  /** The status of the IncidentResponseActionNotifiedResponded */
  status: IncidentResponseNotificationStatus;
};

export type IncidentResponseActionNotifiedTarget = {
  /** The IncidentResponseNotification sent to this target */
  notification: IncidentResponseNotification;
  /** The ContactMethods the IncidentResponseNotification was sent to */
  selectedContactMethods: Array<ContactMethod>;
};

export type IncidentResponseActionNotifiedViewed = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
};

export type IncidentResponseActionNotifyInitiated = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The message sent along with the IncidentResponseNotifications sent as part of this IncidentResponseActionNotified */
  message?: Maybe<Scalars['String']>;
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
};

export type IncidentResponseActionRelay = {
  /** The IncidentResponseActions associated with this IncidentResponse */
  nodes: Array<IncidentResponseAction>;
  /** The PageInfo required for pagination */
  pageInfo: PageInfo;
};

export type IncidentResponseActionResolved = IncidentResponseAction & {
  /** When the IncidentResponseAction was created */
  createdAt: Scalars['Date'];
  /** The gid of the IncidentResponseAction */
  gid: Scalars['GID'];
  /** The ContactMethod who performed the IncidentResponseAction */
  newCreatedBy: ContactMethod;
};

export type IncidentResponseNotification = {
  /** The Recipient of the IncidentResponseNotification */
  contactMethod: ContactMethod;
  /** The IncidentResponseActionNotifiedViewed representing the first time the IncidentResponseNotification was viewed */
  firstViewed?: Maybe<IncidentResponseActionNotifiedViewed>;
  /** The gid of the IncidentResponseNotification */
  gid: Scalars['GID'];
  /** The IncidentResponseActionNotifiedResponded representing the last time the IncidentResponseNotification was viewed */
  lastResponded?: Maybe<IncidentResponseActionNotifiedResponded>;
  /** The IncidentResponseActionNotifiedViewed representing the last time the IncidentResponseNotification was viewed */
  lastViewed?: Maybe<IncidentResponseActionNotifiedViewed>;
  /** The name to display for the ContactMethod */
  nameText: Scalars['String'];
  /** The statusText representing the current state of the notifications to send to the target of the IncidentResponseNotification. */
  notificationStatusText: IncidentResponseNotificationNotificationStatus;
  /**
   * The status text to display
   * @deprecated Replaced by targetStatusText
   */
  statusText: Scalars['String'];
  /** The statusText representing the current state of the target of the the IncidentResponseNotification. */
  targetStatusText: Scalars['String'];
};

export type IncidentResponseNotificationAggregates = {
  /** The number of IncidentResponseNotifications whose targets have notifications that have totally failed to be sent */
  failedCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have notifications that are still in a queued state */
  queuedCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have marked themselves as safe */
  safeCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have notifications that have all successfully sent */
  sentCount: Scalars['Int'];
  /** The total number of IncidentResponseNotifications for this IncidentResponse */
  totalCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have unknown statuses */
  unknownCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have marked themselves as unsafe */
  unsafeCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have viewed the landing page but not responded */
  viewedCount: Scalars['Int'];
  /** The number of IncidentResponseNotifications whose targets have notifications that have partially succeeded in sending */
  warningCount: Scalars['Int'];
};

export type IncidentResponseNotificationFilterParams = {
  /** The fields to apply the text filter to */
  fields: Array<IncidentResponseNotificationFilterableField>;
  /** The text value to filter by */
  text: Scalars['String'];
};

export enum IncidentResponseNotificationFilterableField {
  NAME = 'NAME',
  NOTIFICATION_STATUS = 'NOTIFICATION_STATUS',
  STATUS = 'STATUS'
}

export enum IncidentResponseNotificationNotificationStatus {
  ERROR = 'ERROR',
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  WARNING = 'WARNING'
}

export type IncidentResponseNotificationRelay = {
  /** Aggregate data of all IncidentResponseNotifications of this IncidentResponse */
  aggregates: IncidentResponseNotificationAggregates;
  /** The IncidentResponseNotifications associated with this Relay */
  nodes: Array<IncidentResponseNotification>;
  /** The PageInfo required for pagination */
  pageInfo: PageInfo;
};

export type IncidentResponseNotificationSortParams = {
  /** The direction to sort field by */
  dir: SortDirection;
  /** The field to sort by */
  field: IncidentResponseNotificationSortableField;
};

export enum IncidentResponseNotificationSortableField {
  CREATED = 'CREATED',
  NAME = 'NAME',
  STATUS = 'STATUS',
  UPDATED = 'UPDATED'
}

export enum IncidentResponseNotificationStatus {
  SAFE = 'SAFE',
  UNKNOWN = 'UNKNOWN',
  UNSAFE = 'UNSAFE'
}

export type IncidentResponseRelay = {
  /** The IncidentResponses associated with this Relay */
  nodes: Array<IncidentResponse>;
  /** The PageInfo required for pagination */
  pageInfo: PageInfo;
};

export enum IncidentSeverity {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  UNKNOWN = 'UNKNOWN'
}

export type IncidentSnapshot = {
  /** The description of the area affected by the Incident */
  area_description?: Maybe<Scalars['String']>;
  /** The Date that the Incident expires */
  expiration_date?: Maybe<Scalars['Date']>;
  /** The GeoJSONGeometries of the Incident */
  geometries: Array<GeoJSONGeometry>;
  /** If true, the Incident has featured RTC content */
  has_featured_content: Scalars['Boolean'];
  /** The headline to show for the Incident */
  headline: Scalars['String'];
  /** The source of the headline */
  headline_source?: Maybe<Scalars['String']>;
  /** The labels from the headline_source - ["chatter","news","official"] */
  headline_source_labels?: Maybe<Array<Scalars['String']>>;
  /** The type of the headline */
  headline_type: IncidentHeadlineType;
  /** The list of InputStream _ids that the Incident matches */
  input_streams: Array<Scalars['ObjectId']>;
  /** If true, the Incident was featured by RTC */
  is_featured: Scalars['Boolean'];
  /** The lifecycle stage of the Incident */
  lifecycle: Scalars['String'];
  /** The polygons representing the Incident's affected area */
  polygons: Array<Scalars['String']>;
  /** If true, the Incident is private to the requesting Account */
  private: Scalars['Boolean'];
  /** The severity of the Incident */
  severity: IncidentSeverity;
  /** The status of the Incident */
  status: IncidentStatus;
  /** The tags of the Incident */
  tags: Array<Scalars['String']>;
  /** The types of the Incident */
  types: Array<Scalars['String']>;
  /** The warning type of the Incident */
  warning_type?: Maybe<IncidentWarningType>;
  /** The Wheres of the Incident */
  wheres: Array<Where>;
};

export enum IncidentStatus {
  COMPLETED = 'COMPLETED',
  DETECTED = 'DETECTED',
  DISMISSED = 'DISMISSED',
  MANUALLY_CREATED = 'MANUALLY_CREATED',
  MERGED = 'MERGED',
  PREDETECTED = 'PREDETECTED',
  UNDETECTED = 'UNDETECTED',
  UNKNOWN = 'UNKNOWN',
  VERIFIED = 'VERIFIED'
}

export type IncidentStream = Stream & {
  /** The _id of the Stream */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Stream belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Stream was created */
  created: Scalars['Date'];
  /** The filter criterion for the given IncidentStream */
  criterion: IncidentStreamCriterion;
  /** The Date the Stream criterion was last changed */
  criterion_updated: Scalars['Date'];
  /** The Date the Stream was deleted */
  deleted_date?: Maybe<Scalars['Date']>;
  /** The GID of the Stream */
  gid: Scalars['GID'];
  /** The ImpactAgent configuration linked to this Stream */
  impact_agent_stream_configuration?: Maybe<ImpactAgentStreamConfiguration>;
  /** True if the current User is the owner of the Stream */
  is_owner: Scalars['Boolean'];
  /** The name of the Stream */
  name: Scalars['String'];
  notifications: IncidentStreamNotifications;
  /** The owner of the Stream */
  owner?: Maybe<OtherUser>;
  /** If and how the Stream is shared */
  share_type: StreamShareType;
  /** The Date the Stream was transferred to the current owner */
  transferred_date?: Maybe<Scalars['Date']>;
  /** The type of the Stream */
  type: StreamType;
  /** The number of unread Alerts in the Stream */
  unread_count: Scalars['Int'];
  /** The Date the Stream was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Stream belongs to */
  user_id: Scalars['ObjectId'];
};

export type IncidentStreamAssetSetCriterion = {
  /** The _id of the asset set referenced by this criterion */
  asset_set_id: Scalars['ObjectId'];
  /** The configuration to apply to the asset set referenced by this criterion */
  configuration?: Maybe<IncidentStreamProximityConfiguration>;
};

export type IncidentStreamAssetSetCriterionInput = {
  /** The _id of a ProximityAssetSet to filter the IncidentStream Alerts by */
  asset_set_id: Scalars['ObjectId'];
  /** The configuration to apply to the given ProximityAssetSet when filtering IncidentStream Alerts */
  configuration?: InputMaybe<IncidentStreamProximityConfigurationInput>;
};

export type IncidentStreamAudioNotifications = {
  /** If true, audio notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The list of severities to filter mobile notifications by */
  severities: Array<IncidentSeverity>;
};

export type IncidentStreamAudioNotificationsInput = {
  /** If true, audio notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The list of severities to filter audio notifications by */
  severities: Array<IncidentSeverity>;
};

export type IncidentStreamCoverageCriterion = {
  /** The _ids of the InputStreams to filter the IncidentStream Alerts by */
  input_stream_ids: Array<Scalars['ObjectId']>;
  /** The type of InputStreams selected - ["coverage","impact"] */
  type: Scalars['String'];
};

export type IncidentStreamCoverageCriterionInput = {
  /** The _ids of the InputStreams to filter the IncidentStream Alerts by */
  input_stream_ids: Array<Scalars['ObjectId']>;
  /** The type of InputStreams selected - ["coverage","impact"] */
  type: Scalars['String'];
};

export type IncidentStreamCriterion = {
  /** The list of ProximityAssetSets to filter the IncidentStream Alerts by */
  asset_sets: Array<IncidentStreamAssetSetCriterion>;
  /** The list of InputStreams to filter the IncidentStream Alerts by */
  coverage: IncidentStreamCoverageCriterion;
  /** The list of keywords to filter the IncidentStream Alerts by */
  keywords: Array<IncidentStreamKeywordCriterion>;
  /** The list of lifecycles to filter the IncidentStream Alerts by */
  lifecycles: Array<Scalars['String']>;
  /** The list of locations to filter the IncidentStream Alerts by */
  locations: Array<IncidentStreamLocationCriterion>;
  /** The Lucene string to filter the IncidentStream Alerts by */
  lucene_string?: Maybe<IncidentStreamLuceneStringCriterion>;
  /** The list of severities to filter Alerts by */
  severities: Array<IncidentSeverity>;
};

export type IncidentStreamCriterionInput = {
  /** The list of ProximityAssetSets to filter the IncidentStream Alerts by */
  asset_sets: Array<IncidentStreamAssetSetCriterionInput>;
  /** The list of InputStreams to filter the IncidentStream Alerts by */
  coverage: IncidentStreamCoverageCriterionInput;
  /** The list of keywords to filter the IncidentStream Alerts by */
  keywords: Array<IncidentStreamKeywordCriterionInput>;
  /** The list of lifecycles to filter the IncidentStream Alerts by */
  lifecycles: Array<Scalars['String']>;
  /** The list of locations to filter the IncidentStream Alerts by */
  locations: Array<IncidentStreamLocationCriterionInput>;
  /** The Lucene string to filter the IncidentStream Alerts by */
  lucene_string?: InputMaybe<IncidentStreamLuceneStringCriterionInput>;
  /** The list of severities to filter Alerts by */
  severities?: InputMaybe<Array<IncidentSeverity>>;
};

export type IncidentStreamEmailNotifications = {
  /** If true, email notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The list of emails to send email notifications to */
  emails: Array<Scalars['String']>;
  /** If true, email notifications will be sent to Nearby Assets for new Alerts added to the Stream */
  nearby_assets: Scalars['Boolean'];
  /** The list of severities to filter email notifications by */
  severities: Array<IncidentSeverity>;
  /** If true, email notifications will be sent to the Stream owner for new Alerts added to the Stream */
  stream_owner: Scalars['Boolean'];
};

export type IncidentStreamEmailNotificationsInput = {
  /** If true, email notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The list of emails to send email notifications to */
  emails: Array<Scalars['String']>;
  /** If true, email notifications will be sent to Nearby Assets for new Alerts added to the Stream */
  nearby_assets?: Scalars['Boolean'];
  /** The list of severities to filter email notifications by */
  severities: Array<IncidentSeverity>;
  /** If true, email notifications will be sent to the Stream owner for new Alerts added to the Stream */
  stream_owner?: Scalars['Boolean'];
};

export type IncidentStreamEverbridgeNotifications = {
  /** If true, everbridge notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
};

export type IncidentStreamEverbridgeNotificationsInput = {
  /** If true, everbridge notifications will be sent for new Alerts added to the stream */
  active: Scalars['Boolean'];
};

export type IncidentStreamGenetecNotifications = {
  /** If true, genetec notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The GenetecIntegration selected for this Stream */
  genetec_integration?: Maybe<GenetecIntegration>;
  /** The gid of the GenetecIntegration selected for this Stream */
  genetec_integration_gid?: Maybe<Scalars['GID']>;
  /** The _id of the GenetecIntegration selected for this Stream */
  genetec_integration_id?: Maybe<Scalars['ObjectId']>;
};

export type IncidentStreamGenetecNotificationsInput = {
  /** If true, genetec notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The gid of the GenetecIntegration to select for this Stream */
  genetec_integration_gid?: InputMaybe<Scalars['GID']>;
};

export type IncidentStreamKeywordCriterion = {
  /**
   * If true, will filter Alerts to ones that contain the associated keyword
   * Else, will filter Alerts to ones that do not contain the associated keyword
   */
  include: Scalars['Boolean'];
  /** The keyword to filter Alerts by */
  keyword: Scalars['String'];
};

export type IncidentStreamKeywordCriterionInput = {
  /**
   * If true, will filter Alerts to ones that contain the associated keyword
   * Else, will filter Alerts to ones that do not contain the associated keyword
   */
  include: Scalars['Boolean'];
  /** The keyword to filter Alerts by */
  keyword: Scalars['String'];
};

export type IncidentStreamLocationCriterion = {
  /** The _id of the GeoData referenced by this criterion */
  geo_id: Scalars['ObjectId'];
  /** The longkey of the GeoData referenced by this criterion */
  longkey: Scalars['String'];
  /** The name of the GeoData referenced by this criterion */
  name: Scalars['String'];
  /** The type of the GeoData referenced by this criterion */
  type: Scalars['String'];
};

export type IncidentStreamLocationCriterionInput = {
  /** The _id of the GeoData referenced by this criterion */
  geo_id: Scalars['ObjectId'];
  /** The longkey of the GeoData referenced by this criterion */
  longkey: Scalars['String'];
  /** The name of the GeoData referenced by this criterion */
  name: Scalars['String'];
  /** The type of the GeoData referenced by this criterion */
  type: Scalars['String'];
};

export type IncidentStreamLuceneStringCriterion = {
  /** True if the LuceneString is advanced */
  advanced: Scalars['Boolean'];
  /** The value of the LuceneString filter */
  value: Scalars['LuceneString'];
};

export type IncidentStreamLuceneStringCriterionInput = {
  /** True if the LuceneString is advanced */
  advanced: Scalars['Boolean'];
  /** The value of the LuceneString filter */
  value: Scalars['LuceneString'];
};

export type IncidentStreamMobileNotifications = {
  /** If true, mobile notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The list of severities to filter mobile notifications by */
  severities: Array<IncidentSeverity>;
};

export type IncidentStreamMobileNotificationsInput = {
  /** If true, mobile notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The list of severities to filter mobile notifications by */
  severities: Array<IncidentSeverity>;
};

export type IncidentStreamMsTeamsNotifications = {
  /** If true, ms teams notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The MsTeamsWebhook selected for this Stream */
  ms_teams_webhook?: Maybe<MsTeamsWebhook>;
  /** The _id of the MsTeamsWebhook selected for this Stream */
  ms_teams_webhook_id?: Maybe<Scalars['ObjectId']>;
  /** If true, MS Teams notifications will be sent to Nearby Assets for new Alerts added to the Stream */
  nearby_assets: Scalars['Boolean'];
};

export type IncidentStreamMsTeamsNotificationsInput = {
  /** If true, ms_teams notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The _id of the MsTeamsWebhook to select for this Stream */
  ms_teams_webhook_id?: InputMaybe<Scalars['ObjectId']>;
  /** If true, MS Teams notifications will be sent to Nearby Assets for new Alerts added to the Stream */
  nearby_assets?: Scalars['Boolean'];
};

export type IncidentStreamNotifications = {
  /** The audio notification configuration for the given IncidentStream */
  audio: IncidentStreamAudioNotifications;
  /** The email notification configuration for the given IncidentStream */
  email: IncidentStreamEmailNotifications;
  /** The everbridge notification configuration for the given IncidentStream */
  everbridge: IncidentStreamEverbridgeNotifications;
  /** The genetec notification configuration for the given IncidentStream */
  genetec: IncidentStreamGenetecNotifications;
  /** The mobile notification configuration for the given IncidentStream */
  mobile: IncidentStreamMobileNotifications;
  /** The ms teams notification configuration for the given IncidentStream */
  ms_teams: IncidentStreamMsTeamsNotifications;
  /** The outgoing webhook notification configuration for the given IncidentStream */
  outgoing_webhook: IncidentStreamOutgoingWebhookNotifications;
  /** The resolver notification configuration for the given IncidentStream */
  resolver: IncidentStreamResolverNotifications;
  /** The scheduled brief notification configuration for the given IncidentStream */
  scheduled_brief: IncidentStreamScheduledBriefNotifications;
  /** The slack notification configuration for the given IncidentStream */
  slack: IncidentStreamSlackNotifications;
  /** The webhook notification configuration for the given IncidentStream */
  webhook: IncidentStreamWebhookNotifications;
};

export type IncidentStreamNotificationsInput = {
  /** The audio notification configuration for a IncidentStream */
  audio?: InputMaybe<IncidentStreamAudioNotificationsInput>;
  /** The email notification configuration for a IncidentStream */
  email: IncidentStreamEmailNotificationsInput;
  /** The everbridge notification configuration for a IncidentStream */
  everbridge?: InputMaybe<IncidentStreamEverbridgeNotificationsInput>;
  /** The genetec notification configuration for a IncidentStream */
  genetec?: InputMaybe<IncidentStreamGenetecNotificationsInput>;
  /** The mobile notification configuration for a IncidentStream */
  mobile: IncidentStreamMobileNotificationsInput;
  /** The ms_teams notification configuration for a IncidentStream */
  ms_teams?: InputMaybe<IncidentStreamMsTeamsNotificationsInput>;
  /** The outgoing webhook notification configuration for a IncidentStream */
  outgoing_webhook?: InputMaybe<IncidentStreamOutgoingWebhookNotificationsInput>;
  /** The resolver notification configuration for a IncidentStream */
  resolver?: InputMaybe<IncidentStreamResolverNotificationsInput>;
  /** The scheduled brief notification configuration for a IncidentStream */
  scheduled_brief?: InputMaybe<IncidentStreamScheduledBriefNotificationsInput>;
  /** The slack notification configuration for a IncidentStream */
  slack?: InputMaybe<IncidentStreamSlackNotificationsInput>;
  /** The webhook notification configuration for a IncidentStream */
  webhook?: InputMaybe<IncidentStreamWebhookNotificationsInput>;
};

export type IncidentStreamOutgoingWebhookNotifications = {
  /** If true, outgoing webhook notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The OutgoingWebhook selected for this Stream */
  outgoing_webhook?: Maybe<OutgoingWebhook>;
  /** The _id of the OutgoingWebhook selected for this Stream */
  outgoing_webhook_id?: Maybe<Scalars['ObjectId']>;
};

export type IncidentStreamOutgoingWebhookNotificationsInput = {
  /** If true, outgoing notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The _id of the OutgoingWebhook to select for this Stream */
  outgoing_webhook_id?: InputMaybe<Scalars['ObjectId']>;
};

export type IncidentStreamProximityConfiguration = {
  /** The radius applied when prox matching for this IncidentStream */
  radius: Scalars['Int'];
  /** The radius to apply when prox matching for this IncidentStream */
  use_hours_of_operation: Scalars['Boolean'];
};

export type IncidentStreamProximityConfigurationInput = {
  /** The radius that will be applied to the ProximityAssetSet when creating Alerts for this IncidentStream */
  radius: Scalars['Int'];
  /** Whether or not to consider hours to the ProximityAssetSet when creating Alerts for this IncidentStream */
  use_hours_of_operation: Scalars['Boolean'];
};

export type IncidentStreamResolverNotifications = {
  /** If true, resolver notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The ResolverWebhook selected for this Stream */
  resolver_webhook?: Maybe<ResolverWebhook>;
  /** The _id of the ResolverWebhook selected for this Stream */
  resolver_webhook_id?: Maybe<Scalars['ObjectId']>;
};

export type IncidentStreamResolverNotificationsInput = {
  /** If true, resolver notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** The _id of the ResolverWebhook to select for this Stream */
  resolver_webhook_id?: InputMaybe<Scalars['ObjectId']>;
};

export type IncidentStreamScheduledBriefNotifications = {
  /** If true, scheduled briefs will be sent daily for this Stream */
  active: Scalars['Boolean'];
  /** The next run of the scheduled brief */
  next_run?: Maybe<Scalars['Date']>;
  /** The time of day ie 08:00 */
  time?: Maybe<Scalars['LocalTime']>;
  /** The timezone of the time ie America/New_York */
  timezone?: Maybe<Scalars['TimeZone']>;
};

export type IncidentStreamScheduledBriefNotificationsInput = {
  /** If true, scheduled brief emails will be sent at the scheduled time */
  active: Scalars['Boolean'];
  /** The time of day ie 08:00 */
  time?: InputMaybe<Scalars['LocalTime']>;
};

export type IncidentStreamSlackNotifications = {
  /** If true, slack notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** If true, slack notifications will be sent to Nearby Assets for new Alerts added to the Stream */
  nearby_assets: Scalars['Boolean'];
  /** The SlackWebhook selected for this Stream */
  slack_webhook?: Maybe<SlackWebhook>;
  /** The _id of the SlackWebhook selected for this Stream */
  slack_webhook_id?: Maybe<Scalars['ObjectId']>;
};

export type IncidentStreamSlackNotificationsInput = {
  /** If true, slack notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** If true, slack notifications will be sent to Nearby Assets for new Alerts added to the Stream */
  nearby_assets?: Scalars['Boolean'];
  /** The _id of the SlackWebhook to select for this Stream */
  slack_webhook_id?: InputMaybe<Scalars['ObjectId']>;
};

export type IncidentStreamWebhookNotifications = {
  /** If true, webhook notifications will be sent for new Alerts added to the Stream */
  active: Scalars['Boolean'];
  /** header key for the webhook */
  header_key: Scalars['String'];
  /** header value for the webhook */
  header_value: Scalars['String'];
  /** The url for the webhook */
  url: Scalars['String'];
};

export type IncidentStreamWebhookNotificationsInput = {
  /** If true, webhook notifications will be sent for new Alerts added to the stream */
  active: Scalars['Boolean'];
  /** header key for the webhook */
  header_key: Scalars['String'];
  /** header value for the webhook */
  header_value: Scalars['String'];
  /** Url for the webhook */
  url: Scalars['String'];
};

export type IncidentSummaryDetailed = {
  /** The markdown version of the summary. */
  text_markdown: Scalars['MarkdownString'];
  /** The plain text version of the summary. */
  text_plain: Scalars['String'];
};

export type IncidentSummaryGenerated = {
  generated_on: Scalars['Date'];
  sources: Array<IncidentSummarySource>;
  text: Scalars['String'];
  timezone: Scalars['String'];
};

export type IncidentSummaryQuestion = {
  /** The gid of the question. Will be in the format of gid://samdesk/IncidentSummaryFollowupQuestion/<question_id> */
  gid: Scalars['GID'];
  /** The label of the question. */
  label: Scalars['String'];
  /** The type of the question - either primary or suggested. */
  type: FollowupQuestionType;
};

export type IncidentSummarySession = {
  /** The detailed summary */
  detailed_summary: IncidentSummaryDetailed;
  /** The followup questions related to the summary */
  followup_questions: Array<IncidentSummaryQuestion>;
  /** The gid of the summary */
  gid: Scalars['GID'];
  /** The _id of the Incident the summary is for */
  incident_id: Scalars['ObjectId'];
  /** The markdown version of the summary. */
  text_markdown: Scalars['MarkdownString'];
  /** The plain text version of the summary. */
  text_plain: Scalars['String'];
};

export type IncidentSummarySource = {
  author_name: Scalars['String'];
  created_at: Scalars['Date'];
  permalink: Scalars['String'];
  social_key: Scalars['String'];
  social_type: Scalars['String'];
  text: Scalars['String'];
};

export type IncidentTab = DashboardTab & {
  /** The data specific to an IncidentTab */
  incident_tab_data: IncidentTabData;
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type IncidentTabData = {
  /** The _id of the Incident referenced by this tab */
  incident_id: Scalars['ObjectId'];
};

export type IncidentType = {
  /** Category of the IncidentType */
  category: Scalars['String'];
  /** Category name of the IncidentType */
  category_name: Scalars['String'];
  /** Color of the IncidentType */
  color: Scalars['HexColorCode'];
  /** Name of the IncidentType to show to the user */
  name: Scalars['String'];
  /** Status of the IncidentType */
  status: Scalars['String'];
  /** Name of the IncidentType for internal use */
  type: Scalars['String'];
};

export type IncidentUpdate = {
  /** The _id of the IncidentUpdate */
  _id: Scalars['ObjectId'];
  /** The Date that the Incident was or will be completed */
  completed_date?: Maybe<Scalars['Date']>;
  /** The Date that the IncidentSnapshot was created */
  created: Scalars['Date'];
  /** The Date that the Incident was originally detected */
  detected_date?: Maybe<Scalars['Date']>;
  /** The _id of the Incident referenced by this IncidentUpdate */
  incident_id: Scalars['ObjectId'];
  /** The _id of the Incident that was merged into this Incident as part of the update */
  merged_from?: Maybe<Scalars['ObjectId']>;
  /** The _id of the Incident that this Incident was merged into as part of the update */
  merged_into?: Maybe<Scalars['ObjectId']>;
  /** A snapshot of the Incident's state from after the Incident was updated */
  new: IncidentSnapshot;
  /** A snapshot of the Incident's state from before the Incident was updated */
  old: IncidentSnapshot;
  /** If true, the Incident is private to the requesting Account */
  private: Scalars['Boolean'];
  /** The manual update put out by the RTC team that generated this Alert */
  rtc_update?: Maybe<RTCUpdate>;
};

export enum IncidentWarningType {
  ADVISORY = 'ADVISORY',
  STATEMENT = 'STATEMENT',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
  WATCH = 'WATCH'
}

export type InitiateDownloadStatusParams = {
  /** The purpose of the relevant DownloadStatus */
  purpose: DownloadStatusPurpose;
  /** The gid of the object to retrieve an DownloadStatus for */
  target_gid: Scalars['GID'];
};

export type InputStream = {
  /** The _id of the InputStream */
  _id: Scalars['ObjectId'];
  /** The _id of the InputStreamCategory that the InputStream belongs to */
  category_id?: Maybe<Scalars['ObjectId']>;
  /** The Date the InputStream was created */
  created: Scalars['Date'];
  /** The description of the InputStream */
  description?: Maybe<Scalars['String']>;
  /** If true, the InputStream is enabled */
  is_enabled: Scalars['Boolean'];
  /** The name of the InputStream */
  name: Scalars['String'];
  /** The sort index of the Input Stream */
  sort?: Maybe<Scalars['Int']>;
  /** The tooltip for the InputStream */
  tooltip?: Maybe<Scalars['String']>;
  /** The Date the InputStream was last updated */
  updated: Scalars['Date'];
};

export type InputStreamCategory = {
  /** The _id of the InputStreamCategory */
  _id: Scalars['ObjectId'];
  /** The list of InputStreams that are children of the InputStreamCategory */
  children: Array<InputStream>;
  /** The hexcode color of the InputStreamCategory */
  color: Scalars['HexColorCode'];
  /** The Date the InputStreamCategory was created */
  created: Scalars['Date'];
  /** The description of the InputStream */
  description?: Maybe<Scalars['String']>;
  /** Example IncidentTypes for the given InputStreamCategory */
  example_incident_types: Array<IncidentType>;
  /** If true, the InputStreamCategory is enabled */
  is_enabled: Scalars['Boolean'];
  /** The name of the InputStreamCategory */
  name: Scalars['String'];
  /** The sort index of the InputStreamCategory. Defaults to 0. */
  sort?: Maybe<Scalars['Int']>;
  /** The type of the InputStreamCategory - ["impact","coverage"] */
  type: Scalars['String'];
  /** The Date the InputStreamCategory was last updated */
  updated: Scalars['Date'];
};

export type IntercomConfig = {
  /** The Intercom hash for the current User */
  user_hash: Scalars['String'];
};

export type Language = {
  /** The unique key for the Language */
  key: Scalars['String'];
  /** The name of the Language */
  name: Scalars['String'];
};

export type ListAlertsParams = {
  /** If provided, will only return Alerts that were created after the given Date */
  after?: InputMaybe<Scalars['Date']>;
  /**
   * If true, will attempt to backfill Alerts into the Stream, if there is room
   * NOTE: requires before to also be provided
   */
  backfill?: InputMaybe<Scalars['Boolean']>;
  /** If provided, will only return Alerts that were created before the given Date */
  before?: InputMaybe<Scalars['Date']>;
  /** The number of Alerts to return */
  count?: InputMaybe<Scalars['Int']>;
  /** If provided, will only return Alerts that were created after the given Date */
  created_after?: InputMaybe<Scalars['Date']>;
  /** If provided, will only return Alerts that were created before the given Date */
  created_before?: InputMaybe<Scalars['Date']>;
  /** If provided, will only return Alerts that have or have not been read */
  read?: InputMaybe<Scalars['Boolean']>;
  /** The direction in which to sort the Alerts */
  sort_dir?: InputMaybe<SortDirection>;
  /** The _ids of the Streams to return Alerts for */
  stream_ids: Array<Scalars['ObjectId']>;
  /** If provided, will only return Alerts that were updated after the given Date */
  updated_after?: InputMaybe<Scalars['Date']>;
  /** If provided, will only return Alerts that were updated before the given Date */
  updated_before?: InputMaybe<Scalars['Date']>;
};

export type ListAnalyticsSearchesParams = {
  /** The number of AnalyticsSearches to get */
  count?: Scalars['Int'];
};

export type ListContactGroupsParams = {
  /** The number of ContactGroups to return */
  count?: InputMaybe<Scalars['Float']>;
};

export type ListContactsParams = {
  /** The ContactGroup to list Contacts in */
  contactGroupGID: Scalars['GID'];
};

export type ListDashboardTabUpdateCount = {
  /** The _id of the Incident that the IncidentTab is pointing at */
  incident_id?: InputMaybe<Scalars['ObjectId']>;
  /** The _ids of the Streams that the AlertsTab is pointing at */
  stream_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The _id of the DashboardTab to get the count for */
  tab_id: Scalars['ObjectId'];
  /** The type of the DashboardTab to get the count for */
  type: DashboardTabType;
};

export type ListDashboardTabUpdateCountsParams = {
  /** The Date to get update counts since */
  since: Scalars['Date'];
  /** The list of DashboardTabs to get counts for */
  tabs: Array<ListDashboardTabUpdateCount>;
};

export type ListEverbridgeIntegrationsParams = {
  /** The _ids of the EverbridgeIntegrations to get */
  _ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Whether or not to exclude disabled integrations */
  exclude_disabled?: InputMaybe<Scalars['Boolean']>;
  /** Which version of integrations to get */
  version?: InputMaybe<Scalars['Float']>;
};

export type ListGenetecIntegrationsParams = {
  /** The number of GenetecIntegrations to return */
  count?: Scalars['Int'];
};

export type ListImpactAgentFeedbacksParams = {
  /** Only return feedback with this review status */
  feedback_status?: InputMaybe<ImpactAgentFeedbackStatus>;
  /** The _id of the Impact Agent associated with the impact agent feedback */
  impact_agent_id: Scalars['ObjectId'];
  /** The _id of the Incident to list impact agent feedback for */
  incident_id?: InputMaybe<Scalars['ObjectId']>;
  /** Only return feedback with this correction state */
  is_correction?: InputMaybe<Scalars['Boolean']>;
};

export type ListImpactAgentsParams = {
  /** The maximum number of ImpactAgents to return */
  count?: InputMaybe<Scalars['Int']>;
  /** Only return ImpactAgents with _id greater than this value */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** Only return ImpactAgents with _id less than this value */
  min_id?: InputMaybe<Scalars['ObjectId']>;
};

export type ListIncidentResponseActionsByIncidentResponseNotificationParams = {
  /** The cursor to get nodes after */
  after?: InputMaybe<Scalars['String']>;
  /** The number of nodes to get from first */
  first?: Scalars['Int'];
  /** The gid of the IncidentResponseNotification to list IncidentResponseActions for */
  incidentResponseNotificationGID: Scalars['GID'];
};

export type ListIncidentResponseActionsByIncidentResponseParams = {
  /** The cursor to get nodes after */
  after?: InputMaybe<Scalars['String']>;
  /** The number of nodes to get from first */
  first?: Scalars['Int'];
};

export type ListIncidentResponseNotificationsParams = {
  /** The cursor to get nodes after */
  after?: InputMaybe<Scalars['String']>;
  /** The cursor to get nodes before */
  before?: InputMaybe<Scalars['String']>;
  /** The filters to apply to the returned list */
  filters?: InputMaybe<Array<IncidentResponseNotificationFilterParams>>;
  /** The number of nodes to get from the start */
  first?: InputMaybe<Scalars['Int']>;
  /** The IncidentResponse to get IncidentResponseNotifications for */
  incidentResponseGID: Scalars['GID'];
  /** The number of nodes to get from the end */
  last?: InputMaybe<Scalars['Int']>;
  /** The sort to apply to the returned list */
  sort?: InputMaybe<Array<IncidentResponseNotificationSortParams>>;
};

export type ListIncidentResponsesParams = {
  /** The cursor to get nodes after */
  after?: InputMaybe<Scalars['String']>;
  /** The number of IncidentResponses to return */
  count?: Scalars['Int'];
  /** The number of nodes to get from first */
  first?: Scalars['Int'];
};

export type ListIncidentsParams = {
  /** The _ids of the Incidents to list */
  _ids: Array<Scalars['ObjectId']>;
  /** If true, the backend will follow merge chains and return the final Incidents */
  follow_merges?: InputMaybe<Scalars['Boolean']>;
};

export type ListInputStreamCategoriesParams = {
  /** The _ids of the InputStreamCategories to list */
  _ids?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type ListLocalAccountsParams = {
  /** The longkey for the location */
  longkey: Scalars['String'];
};

export type ListMsTeamsWebhooksParams = {
  /** The number of MsTeamsWebhooks to return */
  count?: Scalars['Int'];
  /** The _id of the MsTeamsWebhooks to page after */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** The _id of the MsTeamsWebhooks to page before */
  min_id?: InputMaybe<Scalars['ObjectId']>;
};

export type ListOutgoingWebhooksParams = {
  /** The number of OutgoingWebhooks to return */
  count?: Scalars['Int'];
  /** The _id of the OutgoingWebhook to page after */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** The _id of the OutgoingWebhook to page before */
  min_id?: InputMaybe<Scalars['ObjectId']>;
};

export type ListPostsForIncidentParams = {
  /** The number of Posts to return */
  count?: Scalars['Int'];
  /**
   * If true, will return Posts that have articles
   * If false, will return Posts that DO NOT have articles
   * Else, will return all Posts, regardless of articles
   */
  has_articles?: InputMaybe<Scalars['Boolean']>;
  /**
   * If true, will return Posts that have medias
   * If false, will return Posts that DO NOT have medias
   * Else, will return all Posts, regardless of medias
   */
  has_medias?: InputMaybe<Scalars['Boolean']>;
  /** The _id of the Incident to list Posts for */
  incident_id: Scalars['ObjectId'];
  /** When paging, return Posts that appear BEFORE the Post with the given _id, following the sort params */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** When paging, return Posts that appear AFTER the Post with the given _id, following the sort params */
  min_id?: InputMaybe<Scalars['ObjectId']>;
  /** The field by which to sort the Posts */
  sort_by?: PostSortBy;
  /** The direction in which to sort the Posts */
  sort_dir?: SortDirection;
  /** The source label categories (chatter, news, official) to filter Posts by */
  source_label_categories?: InputMaybe<Array<Scalars['String']>>;
};

export type ListPrivateIncidentsParams = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ListProximityAssetSetsParams = {
  /** The _ids of the ProximityAssetSets to list */
  _ids?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type ListProximityAssetsParams = {
  /** The _ids of the ProximityAssets to list */
  _ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The _ids of the ProximityAssetSets to list ProximityAssets for */
  asset_set_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The number of ProximityAssets to return */
  count?: Scalars['Int'];
  /** The latitude to search for ProximityAssets near */
  lat?: InputMaybe<Scalars['Float']>;
  /** The longitude to search for ProximityAssets near */
  lng?: InputMaybe<Scalars['Float']>;
  /** If there are more than max_count results, return an empty array */
  max_count?: InputMaybe<Scalars['Int']>;
  /** The _id of the ProximityAsset to page after */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** The _id of the ProximityAsset to page before */
  min_id?: InputMaybe<Scalars['ObjectId']>;
  /** A list of polygons to filter ProximityAssets by */
  polygons?: InputMaybe<Array<Scalars['String']>>;
  /** A query to filter ProximityAssets by name */
  q?: InputMaybe<Scalars['String']>;
  /** The radius from lat/lng to filter ProximityAssets by */
  radius?: InputMaybe<Scalars['Float']>;
  /** The field to sort the ProximityAssets by */
  sort_by?: ProximityAssetSortBy;
  /** The direction to sort the ProximityAssets by */
  sort_dir?: SortDirection;
};

export type ListProximityMatchesParams = {
  /** The _id of the Incident to list ProximityMatches for */
  incident_id: Scalars['ObjectId'];
};

export type ListResolverWebhooksParams = {
  /** The number of ResolverWebhooks to return */
  count?: Scalars['Int'];
  /** The _id of the ResolverWebhooks to page after */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** The _id of the ResolverWebhooks to page before */
  min_id?: InputMaybe<Scalars['ObjectId']>;
};

export type ListSlackWebhooksParams = {
  /** The number of SlackWebhooks to return */
  count?: Scalars['Float'];
  /** The _id of the SlackWebhook to page after */
  max_id?: InputMaybe<Scalars['ObjectId']>;
  /** The _id of the SlackWebhook to page before */
  min_id?: InputMaybe<Scalars['ObjectId']>;
};

export type ListSlackWorkspacesParams = {
  /** The number of SlackWorkspaces to return */
  count?: Scalars['Float'];
};

export type ListStreamsParams = {
  /** The _ids of the Streams to list */
  _ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** If true, will exclude shared Streams from the response */
  exclude_shared?: InputMaybe<Scalars['Boolean']>;
  /** The GIDs of the Streams to list */
  gids?: InputMaybe<Array<Scalars['GID']>>;
  /** Which types of Searches to include in the response */
  types?: Array<StreamType>;
};

export type ListUpdatedIncidentResponseNotificationsParams = {
  gids: Array<Scalars['GID']>;
  updatedAfter: Scalars['Date'];
};

export type ListUpdatedIncidentResponseNotificationsResponse = {
  updatedLastAt: Scalars['Date'];
  updatedNotifications: Array<IncidentResponseNotification>;
};

export type LocalAccount = {
  /** The alt names for this LocalAccount */
  alt_names: Array<AltName>;
  /** The concepts for the local account */
  concepts: Array<Scalars['String']>;
  /** LocalAccount name */
  name: Scalars['String'];
};

export type Location = {
  /** The _id of the Location */
  _id: Scalars['ObjectId'];
  /** The unique key of the Location */
  key: Scalars['String'];
  /** Returns the label of the geo data type to display */
  label: Scalars['String'];
  /** The longkey of the Location */
  longkey: Scalars['String'];
  /** The name of the Location */
  name: Scalars['String'];
  /** The type of the Location */
  type: Scalars['String'];
};

export type LogIncidentInteractionExtendedDataParams = {
  /** The id of the media the User clicked on */
  clicked_media_id?: InputMaybe<Scalars['ObjectId']>;
  /** How many emails were sent through a Share interaction */
  count?: InputMaybe<Scalars['Float']>;
  /** The handle of the KnowledgeItem clicked */
  handle?: InputMaybe<Scalars['String']>;
  /** The public_id associated with the incident */
  public_id?: InputMaybe<Scalars['String']>;
  /** The social_type associated with the incident */
  social_type?: InputMaybe<SocialType>;
  /** Where the IncidentInteraction is coming from */
  source?: InputMaybe<Scalars['String']>;
  /** The Tab the IncidentInteraction is coming from */
  tab?: InputMaybe<Scalars['String']>;
};

export type LogIncidentInteractionParams = {
  /** Any extra data to send to the EventStore */
  extended_data?: InputMaybe<LogIncidentInteractionExtendedDataParams>;
  /** The gid of the Incident to mark as read */
  incidentGID?: InputMaybe<Scalars['GID']>;
  /** The _id of the Incident to mark as read */
  incident_id?: InputMaybe<Scalars['ObjectId']>;
  /** How the user interacted with the incident */
  interaction_type: Scalars['String'];
  /** Which platform the user is on at the time of interaction */
  source: Scalars['String'];
};

export type MarkEmailTrackerClickedParams = {
  /** The _id of the EmailTracker to mark as clicked */
  email_tracker_id: Scalars['ObjectId'];
  /** The type of link to redirect to */
  link_type?: InputMaybe<Scalars['String']>;
  /** The URL to redirect to */
  redirect_url?: InputMaybe<Scalars['String']>;
};

export type MarkEmailTrackerClickedResponse = {
  /** Any extra data to send along when redirecting */
  deep_link_data?: Maybe<DeepLinkData>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The URL to redirect to for this EmailTracker */
  redirect_url?: Maybe<Scalars['String']>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type MarkReadParams = {
  /** Metadata for tracking analytics */
  analytics?: InputMaybe<AnalyticsInput>;
  /** The GID of the object to mark read */
  gid: Scalars['GID'];
};

export type MsTeamsWebhook = {
  /** The _id of the MsTeamsWebhook */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the MsTeamsWebhook belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the MsTeamsWebhook was created */
  created: Scalars['Date'];
  /** If the webhook is disabled on Microsoft's side */
  disabled: Scalars['Boolean'];
  /** The MsTeamsWebhook name */
  name: Scalars['String'];
  /** The Date the MsTeamsWebhook was updated */
  updated: Scalars['Date'];
  /** The MsTeamsWebhook url */
  url: Scalars['String'];
  /** The _id of the User the MsTeamsWebhook belongs to */
  user_id: Scalars['ObjectId'];
};

export type Mutation = {
  /** Acknowledges an IncidentResponse */
  acknowledgeIncidentResponse: BasicIncidentResponse;
  /**
   * @Public()
   * Cancels an existing ChangeEmailRequest for the currently logged in Person
   */
  cancelChangeEmailRequest: BasicResponse;
  /** Copies a Stream for the currently logged in User */
  copyStream: BasicStreamResponse;
  /**
   * @Roles(ADMIN)
   * Create a new API Key for the Account
   */
  createAPIKey: BasicAPIKeyResponse;
  /**
   * Generate new API key for the Account
   * @Roles(ADMIN)
   * @deprecated Replaced by createAPIKey
   */
  createAccountAPIKey: BasicAccountAPIKeyResponse;
  /** Creates a new AnalyticsSearch for the given params */
  createAnalyticsSearch: BasicAnalyticsSearchResponse;
  /** Creates a new ChangeEmailRequest for the currently logged in Person */
  createChangeEmailRequest: BasicResponse;
  /** Creates a Contact */
  createContact: BasicContactResponse;
  /** Creates a ContactGroup */
  createContactGroup: BasicContactGroupResponse;
  /** Creates a new DarkWebStream for the logged in User */
  createDarkWebStream: BasicStreamResponse;
  /** Creates a new DashboardColumn at the given index in a ColumnsTab and pre-populates it with an AlertsPane */
  createDashboardColumnWithAlertsPane: BasicColumnsTabResponse;
  /** Create and add a new DashboardTab to the currently logged in User's Dashboard */
  createDashboardTab: BasicDashboardTabResponse;
  /** Creates a new DeletePersonRequest for the currently logged in Person */
  createDeletePersonRequest: BasicResponse;
  /**
   * Creates a new EverbridgeIntegration for the current Account
   * @Roles(ADMIN)
   */
  createEverbridgeIntegration: BasicEverbridgeIntegrationResponse;
  /** Creates a GenetecIntegration belonging to the Account of the currently logged in User */
  createGenetecIntegration: BasicGenetecIntegrationResponse;
  /** Creates a new ImpactAgent for the current Account */
  createImpactAgent: BasicImpactAgentResponse;
  /** Create impact agent feedback with an explicit correction state */
  createImpactAgentCorrectionFeedback: BasicImpactAgentFeedbackResponse;
  /** Create impact agent feedback for the given Incident */
  createImpactAgentFeedback: BasicImpactAgentFeedbackResponse;
  /** Create a new IncidentFlag for the given Incident */
  createIncidentFlag: BasicIncidentFlagResponse;
  /** Creates a new IncidentStream for the logged in User */
  createIncidentStream: BasicStreamResponse;
  /** Create an MFA Token in the current Session and send an MFA email */
  createMFACode: BasicResponse;
  /** Creates a new MsTeamsWebhook */
  createMsTeamsWebhook: BasicMsTeamsWebhookResponse;
  /** Creates a new Outgoing Webhook */
  createOutgoingWebhook: BasicOutgoingWebhookResponse;
  createPrivateIncident: BasicIncidentResponse;
  /** Creates a new ProximityAssetSet for the currently logged in Account */
  createProximityAssetSet: BasicProximityAssetSetResponse;
  /** Creates new ProximityAssets for the given ProximityAssetSet */
  createProximityAssets: BasicProximityAssetsResponse;
  /** Adds a Region Brief request on the BriefProcessor queue, returns the brief_id */
  createRegionBrief: CreateRegionBriefResponse;
  /**
   * @Public()
   * Creates a new ResetPasswordRequest for Person with the provided email
   */
  createResetPasswordRequest: BasicResponse;
  /** Creates a new ResolverWebhook */
  createResolverWebhook: BasicResolverWebhookResponse;
  /** Creates a new WebAlertsStream for the logged in User */
  createWebAlertsStream: BasicStreamResponse;
  /**
   * @Roles(ADMIN)
   * Delete an API Key from the Account
   */
  deleteAPIKey: BasicResponse;
  /**
   * Remove the Account Logo
   * @Roles(ADMIN)
   */
  deleteAccountLogo: BasicResponse;
  /**
   * Delete and remove an AccountMember from the currently logged in User's Account
   * @Roles(ADMIN)
   */
  deleteAccountMember: BasicResponse;
  /** Deletes an existing AnalyticsSearch */
  deleteAnalyticsSearch: BasicResponse;
  /** Deletes the given Contact */
  deleteContact: BasicResponse;
  /** Deletes the given ContactGroup */
  deleteContactGroup: BasicResponse;
  /** Deletes a DashboardColumn from a ColumnsTab */
  deleteDashboardColumn: BasicColumnsTabResponse;
  /** Delete and remove a DashboardTab from the currently logged in User's Dashboard */
  deleteDashboardTab: BasicDashboardTabResponse;
  /**
   * Deletes an existing EverbridgeIntegration if it exists
   * @Roles(ADMIN)
   */
  deleteEverbridgeIntegration: BasicEverbridgeIntegrationResponse;
  /** Deletes a GenetecIntegration belonging to the Account of the currently logged in User */
  deleteGenetecIntegrationByGID: BasicResponse;
  /** Deletes a MsTeamsWebhook belonging to the currently logged in User */
  deleteMsTeamsWebhook: BasicResponse;
  /** Deletes an OutgoingWebhook belonging to the currently logged in User */
  deleteOutgoingWebhook: BasicResponse;
  /** Deletes a ProximityAssetSet */
  deleteProximityAssetSet: BasicProximityAssetSetResponse;
  /** Deletes multiple ProximityAssets from the given ProximityAssetSet */
  deleteProximityAssets: BasicResponse;
  /** Deletes a ResolverWebhook belonging to the currently logged in User */
  deleteResolverWebhook: BasicResponse;
  /** Deletes a SalesforceIntegration belonging to the currently logged in User/Account */
  deleteSalesforceIntegration: BasicResponse;
  /** Deletes a SlackWebhook belonging to the currently logged in User */
  deleteSlackWebhook: BasicResponse;
  /** Deletes a SlackWorkspace belonging to the currently logged in User */
  deleteSlackWorkspace: BasicResponse;
  /** Deletes a Stream belonging to the currently logged in User */
  deleteStream: BasicStreamResponse;
  /** Re-enables a disabled OutgoingWebhook belonging to the Account and clears its failures. Missed alerts are not resent. */
  enableOutgoingWebhook: BasicOutgoingWebhookResponse;
  /** Create and initializes a DownloadStatus for the given gid and purpose */
  initiateDownloadStatus: BasicDownloadStatusResponse;
  /** Log the specified interaction with an Incident */
  logIncidentInteraction: BasicResponse;
  /** Mark the given EmailTracker as clicked */
  markEmailTrackerClicked: MarkEmailTrackerClickedResponse;
  /**
   * Mark the object identified by gid as read
   * Currently only accepts Incident and WebAlertPost GIDs
   */
  markRead: BasicResponse;
  /** Send notifications for an IncidentResponse */
  notifyIncidentResponse: BasicIncidentResponse;
  /**
   * Resends the invite to one person in the current User's Account
   * @Roles(ADMIN)
   */
  resendAccountInvitation: BasicResponse;
  /** Resolves an IncidentResponse */
  resolveIncidentResponse: BasicIncidentResponse;
  /**
   * @Public()
   * Respond to a PublicIncidentResponseNotification
   */
  respondPublicIncidentResponseNotificationByUUID: BasicPublicIncidentResponseNotificationResponse;
  /**
   * Invite one person to the current User's Account
   * @Roles(ADMIN)
   */
  sendAccountInvitation: BasicResponse;
  /**
   * Bulk invites people to the current User's Account
   * @Roles(ADMIN)
   */
  sendAccountInvitations: SendAccountInvitationsResponse;
  /** Send an Incident to a given ResolverWebhook */
  sendIncidentToResolver: BasicResponse;
  /** Send an Incident to Salesforce */
  sendIncidentToSalesforce: BasicCreateCaseResponse;
  /** Share an Incident by email, SMS, or Slack to the given ContactMethods */
  shareIncident: BasicResponse;
  /**
   * @Public()
   * Sign a Person in using email/password
   */
  signin: BasicPersonResponse;
  /** Sign the currently logged in Person out */
  signout: BasicResponse;
  /**
   * @Public()
   * Creates a new User and UserAccount based on the SignupParams
   */
  signup: BasicPersonResponse;
  /** Sort the DashboardTabs on the currently logged in User's Dashboard */
  sortDashboardTabs: BasicResponse;
  /**
   * @Public()
   * Submits an existing ChangeEmailRequest, updating the currently logged in Person's email
   */
  submitChangeEmailRequest: BasicResponse;
  /** Submit a previously generated MFA code */
  submitMFACode: BasicResponse;
  /**
   * @Public()
   * Submits an existing ResetPasswordRequest and updates the Person's password
   */
  submitResetPasswordRequest: BasicResponse;
  /**
   * @Roles(ADMIN)
   * Update an API Key for the Account
   */
  updateAPIKey: BasicAPIKeyResponse;
  /**
   * Update an Account
   * @Roles(ADMIN)
   */
  updateAccount: UpdateAccountResponse;
  /**
   * Update an AccountMember
   * @Roles(ADMIN)
   */
  updateAccountMember: BasicAccountMemberResponse;
  /** Updates one or more Alerts belonging to the currently logged in User */
  updateAlerts: BasicResponse;
  /** Updates an Alerts pane within a DashboardColumn and returns the containing ColumnsTab */
  updateAlertsPaneInDashboardColumn: BasicColumnsTabResponse;
  /** Updates an existing AnalyticsSearch for the given params */
  updateAnalyticsSearch: BasicAnalyticsSearchResponse;
  /** Updates the given Contact */
  updateContact: BasicContactResponse;
  /** Updates the given ContactGroup */
  updateContactGroup: BasicContactGroupResponse;
  /** Updates a DarkWebStream belonging to the currently logged in User */
  updateDarkWebStream: BasicStreamResponse;
  /** Reorders columns within a ColumnsTab */
  updateDashboardColumnOrderInTab: BasicColumnsTabResponse;
  /** Update a DashboardTab on the currently logged in User's Dashboard */
  updateDashboardTab: BasicDashboardTabResponse;
  /** Updates the order of a DashboardTab on the currently logged in User's Dashboard */
  updateDashboardTabOrder: BasicDashboardResponse;
  /**
   * Updates an existing EverbridgeIntegration if it exists
   * @Roles(ADMIN)
   */
  updateEverbridgeIntegration: BasicEverbridgeIntegrationResponse;
  /** Updates a GenetecIntegration belonging to the Account of the currently logged in User */
  updateGenetecIntegrationByGID: BasicGenetecIntegrationResponse;
  /** Updates the password of a GenetecIntegration belonging to the Account of the currently logged in User */
  updateGenetecIntegrationPasswordByGID: BasicGenetecIntegrationResponse;
  /** Updates an existing ImpactAgent for the current Account */
  updateImpactAgent: BasicImpactAgentResponse;
  /** Updates the review status of Impact Agent feedback */
  updateImpactAgentFeedback: BasicImpactAgentFeedbackResponse;
  /** Updates the review status of multiple Impact Agent feedbacks */
  updateImpactAgentFeedbacks: BasicResponse;
  /** Updates a IncidentStream belonging to the currently logged in User */
  updateIncidentStream: BasicStreamResponse;
  /** Updates the currently logged in Person */
  updatePerson: BasicResponse;
  /**
   * Updates the currently logged in Person's password
   * @deprecated Replaced by updatePerson
   */
  updatePersonPassword: BasicResponse;
  /** Updates the given ProximityAsset */
  updateProximityAsset: BasicProximityAssetResponse;
  /** Updates the given ProximityAssetSet */
  updateProximityAssetSet: BasicProximityAssetSetResponse;
  /** Updates the currently logged in User's preferences */
  updateUserPreferences: BasicUserResponse;
  /** Updates a Stream belonging to the currently logged in User */
  updateWebAlertsStream: BasicStreamResponse;
  /** Completes the upload for the given UploadStatus id */
  uploadComplete: BasicUploadResponse;
  /** Creates an upload for the given gid */
  uploadCreate: UploadCreateResponse;
  /** Upserts the SAML Configuration for a given Account */
  upsertSAMLConfiguration: BasicSAMLConfigurationResponse;
};


export type MutationacknowledgeIncidentResponseArgs = {
  params: AcknowledgeIncidentResponseParams;
};


export type MutationcancelChangeEmailRequestArgs = {
  params: CancelChangeEmailRequestParams;
};


export type MutationcopyStreamArgs = {
  params: CopyStreamParams;
};


export type MutationcreateAPIKeyArgs = {
  params: CreateAPIKeyParams;
};


export type MutationcreateAnalyticsSearchArgs = {
  params: CreateAnalyticsSearchParams;
};


export type MutationcreateChangeEmailRequestArgs = {
  params: CreateChangeEmailRequestParams;
};


export type MutationcreateContactArgs = {
  params: CreateContactParams;
};


export type MutationcreateContactGroupArgs = {
  params: CreateContactGroupParams;
};


export type MutationcreateDarkWebStreamArgs = {
  params: CreateDarkWebStreamParams;
};


export type MutationcreateDashboardColumnWithAlertsPaneArgs = {
  params: CreateDashboardColumnWithAlertsPaneParams;
};


export type MutationcreateDashboardTabArgs = {
  params: CreateDashboardTabParams;
};


export type MutationcreateEverbridgeIntegrationArgs = {
  params: CreateEverbridgeIntegrationParams;
};


export type MutationcreateGenetecIntegrationArgs = {
  params: CreateGenetecIntegrationParams;
};


export type MutationcreateImpactAgentArgs = {
  params: CreateImpactAgentParams;
};


export type MutationcreateImpactAgentCorrectionFeedbackArgs = {
  params: CreateImpactAgentCorrectionFeedbackParams;
};


export type MutationcreateImpactAgentFeedbackArgs = {
  params: CreateImpactAgentFeedbackParams;
};


export type MutationcreateIncidentFlagArgs = {
  params: CreateIncidentFlagParams;
};


export type MutationcreateIncidentStreamArgs = {
  params: CreateIncidentStreamParams;
};


export type MutationcreateMsTeamsWebhookArgs = {
  params: CreateMsTeamsWebhookParams;
};


export type MutationcreateOutgoingWebhookArgs = {
  params: CreateOutgoingWebhookParams;
};


export type MutationcreatePrivateIncidentArgs = {
  params: CreatePrivateIncidentParams;
};


export type MutationcreateProximityAssetSetArgs = {
  params: CreateProximityAssetSetParams;
};


export type MutationcreateProximityAssetsArgs = {
  params: CreateProximityAssetsParams;
};


export type MutationcreateRegionBriefArgs = {
  params: CreateRegionBriefParams;
};


export type MutationcreateResetPasswordRequestArgs = {
  params: CreateResetPasswordRequestParams;
};


export type MutationcreateResolverWebhookArgs = {
  params: CreateResolverWebhookParams;
};


export type MutationcreateWebAlertsStreamArgs = {
  params: CreateWebAlertsStreamParams;
};


export type MutationdeleteAPIKeyArgs = {
  params: DeleteAPIKeyParams;
};


export type MutationdeleteAccountMemberArgs = {
  params: DeleteAccountMemberParams;
};


export type MutationdeleteAnalyticsSearchArgs = {
  params: DeleteAnalyticsSearchParams;
};


export type MutationdeleteContactArgs = {
  params: DeleteContactParams;
};


export type MutationdeleteContactGroupArgs = {
  params: DeleteContactGroupParams;
};


export type MutationdeleteDashboardColumnArgs = {
  params: DeleteDashboardColumnParams;
};


export type MutationdeleteDashboardTabArgs = {
  params: DeleteDashboardTabParams;
};


export type MutationdeleteEverbridgeIntegrationArgs = {
  params: DeleteEverbridgeIntegrationParams;
};


export type MutationdeleteGenetecIntegrationByGIDArgs = {
  params: DeleteGenetecIntegrationByGIDParams;
};


export type MutationdeleteMsTeamsWebhookArgs = {
  params: DeleteMsTeamsWebhookParams;
};


export type MutationdeleteOutgoingWebhookArgs = {
  params: DeleteOutgoingWebhookParams;
};


export type MutationdeleteProximityAssetSetArgs = {
  params: DeleteProximityAssetSetParams;
};


export type MutationdeleteProximityAssetsArgs = {
  params: DeleteProximityAssetsParams;
};


export type MutationdeleteResolverWebhookArgs = {
  params: DeleteResolverWebhookParams;
};


export type MutationdeleteSalesforceIntegrationArgs = {
  params: DeleteSalesforceIntegrationParams;
};


export type MutationdeleteSlackWebhookArgs = {
  params: DeleteSlackWebhookParams;
};


export type MutationdeleteSlackWorkspaceArgs = {
  params: DeleteSlackWorkspaceParams;
};


export type MutationdeleteStreamArgs = {
  params: DeleteStreamParams;
};


export type MutationenableOutgoingWebhookArgs = {
  params: EnableOutgoingWebhookParams;
};


export type MutationinitiateDownloadStatusArgs = {
  params: InitiateDownloadStatusParams;
};


export type MutationlogIncidentInteractionArgs = {
  params: LogIncidentInteractionParams;
};


export type MutationmarkEmailTrackerClickedArgs = {
  params: MarkEmailTrackerClickedParams;
};


export type MutationmarkReadArgs = {
  params: MarkReadParams;
};


export type MutationnotifyIncidentResponseArgs = {
  params: NotifyIncidentResponseParams;
};


export type MutationresendAccountInvitationArgs = {
  params: ResendAccountInvitationParams;
};


export type MutationresolveIncidentResponseArgs = {
  params: ResolveIncidentResponseParams;
};


export type MutationrespondPublicIncidentResponseNotificationByUUIDArgs = {
  params: RespondPublicIncidentResponseNotificationByUUIDParams;
};


export type MutationsendAccountInvitationArgs = {
  params: SendAccountInvitationParams;
};


export type MutationsendAccountInvitationsArgs = {
  params: SendAccountInvitationsParams;
};


export type MutationsendIncidentToResolverArgs = {
  params: SendIncidentToResolverParams;
};


export type MutationsendIncidentToSalesforceArgs = {
  params: SendIncidentToSalesforceParams;
};


export type MutationshareIncidentArgs = {
  params: ShareIncidentParams;
};


export type MutationsigninArgs = {
  params: SigninParams;
};


export type MutationsignupArgs = {
  params: SignupParams;
};


export type MutationsortDashboardTabsArgs = {
  params: SortDashboardTabsParams;
};


export type MutationsubmitChangeEmailRequestArgs = {
  params: SubmitChangeEmailRequestParams;
};


export type MutationsubmitMFACodeArgs = {
  params: SubmitMFACodeParams;
};


export type MutationsubmitResetPasswordRequestArgs = {
  params: SubmitResetPasswordRequestParams;
};


export type MutationupdateAPIKeyArgs = {
  params: UpdateAPIKeyParams;
};


export type MutationupdateAccountArgs = {
  params: UpdateAccountParams;
};


export type MutationupdateAccountMemberArgs = {
  params: UpdateAccountMemberParams;
};


export type MutationupdateAlertsArgs = {
  params: UpdateAlertsParams;
};


export type MutationupdateAlertsPaneInDashboardColumnArgs = {
  params: UpdateAlertsPaneInDashboardColumnParams;
};


export type MutationupdateAnalyticsSearchArgs = {
  params: UpdateAnalyticsSearchParams;
};


export type MutationupdateContactArgs = {
  params: UpdateContactParams;
};


export type MutationupdateContactGroupArgs = {
  params: UpdateContactGroupParams;
};


export type MutationupdateDarkWebStreamArgs = {
  params: UpdateDarkWebStreamParams;
};


export type MutationupdateDashboardColumnOrderInTabArgs = {
  params: UpdateDashboardColumnOrderInTabParams;
};


export type MutationupdateDashboardTabArgs = {
  params: UpdateDashboardTabParams;
};


export type MutationupdateDashboardTabOrderArgs = {
  params: UpdateDashboardTabOrderParams;
};


export type MutationupdateEverbridgeIntegrationArgs = {
  params: UpdateEverbridgeIntegrationParams;
};


export type MutationupdateGenetecIntegrationByGIDArgs = {
  params: UpdateGenetecIntegrationByGIDParams;
};


export type MutationupdateGenetecIntegrationPasswordByGIDArgs = {
  params: UpdateGenetecIntegrationPasswordByGIDParams;
};


export type MutationupdateImpactAgentArgs = {
  params: UpdateImpactAgentParams;
};


export type MutationupdateImpactAgentFeedbackArgs = {
  params: UpdateImpactAgentFeedbackParams;
};


export type MutationupdateImpactAgentFeedbacksArgs = {
  params: UpdateImpactAgentFeedbacksParams;
};


export type MutationupdateIncidentStreamArgs = {
  params: UpdateIncidentStreamParams;
};


export type MutationupdatePersonArgs = {
  params: UpdatePersonParams;
};


export type MutationupdatePersonPasswordArgs = {
  params: UpdatePersonPasswordParams;
};


export type MutationupdateProximityAssetArgs = {
  params: UpdateProximityAssetParams;
};


export type MutationupdateProximityAssetSetArgs = {
  params: UpdateProximityAssetSetParams;
};


export type MutationupdateUserPreferencesArgs = {
  params: UpdateUserPreferencesParams;
};


export type MutationupdateWebAlertsStreamArgs = {
  params: UpdateWebAlertsStreamParams;
};


export type MutationuploadCompleteArgs = {
  params: UploadCompleteParams;
};


export type MutationuploadCreateArgs = {
  params: UploadCreateParams;
};


export type MutationupsertSAMLConfigurationArgs = {
  params: UpsertSAMLConfigurationParams;
};

export type NearbyAssetsContact = ContactMethod & {
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
};

export type NearbyAssetsContactInput = {
  /** The GID of the Incident to notify nearby assets for */
  incidentGID: Scalars['GID'];
};

export type NearbyProximityAsset = {
  asset: ProximityAsset;
  distance: Scalars['Float'];
  is_exact: Scalars['Boolean'];
};

export type NotifyIncidentResponseParams = {
  /** The ContactMethods to send notifications to */
  contactMethods: Array<ContactMethodInput>;
  /** The gid of the Incident to send notifications about */
  incidentGID: Scalars['GID'];
  /** Email only. If true, attach a PDF of the incident to the email */
  includePDF?: InputMaybe<Scalars['Boolean']>;
  /** An optional message to put in the notification. */
  message?: InputMaybe<Scalars['String']>;
  /** Email only. An optional summary to add to the email. */
  summary?: InputMaybe<Scalars['String']>;
};

export type OtherUser = IUser & {
  /** The _id of the IUser */
  _id: Scalars['ObjectId'];
  /** The email of the IUser */
  email: Scalars['String'];
  /** The gid of the IUser */
  gid: Scalars['GID'];
  /** The name of the IUser */
  name: Scalars['String'];
};

export type OutgoingWebhook = {
  /** The _id of the OutgoingWebhook */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the OutgoingWebhook belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the OutgoingWebhook was created */
  created: Scalars['Date'];
  /** If true, this webhook has been disabled */
  disabled: Scalars['Boolean'];
  /** The number of consecutive failed deliveries. Reset to 0 when a delivery succeeds or the webhook is re-enabled. */
  failure_count: Scalars['Int'];
  /**
   * The header key of the OutgoingWebhook
   * @deprecated Replaced by headers
   */
  header_key?: Maybe<Scalars['String']>;
  /**
   * The header value of the OutgoingWebhook
   * @deprecated Replaced by headers
   */
  header_value?: Maybe<Scalars['String']>;
  /** The headers for the outgoing webhook */
  headers?: Maybe<Array<OutgoingWebhookHeader>>;
  /** The most recent failure in the current run of consecutive failures. Null if there are none; failures are cleared when a delivery succeeds or the webhook is re-enabled. */
  last_failure?: Maybe<WebhookFailure>;
  /** The user provided name of the OutgoingWebhook */
  name: Scalars['String'];
  /** The Date the OutgoingWebhook was updated */
  updated: Scalars['Date'];
  /** The url of the OutgoingWebhook */
  url: Scalars['String'];
  /** The _id of the User the OutgoingWebhook belongs to */
  user_id: Scalars['ObjectId'];
};

export type OutgoingWebhookHeader = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type OutgoingWebhookHeaderInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PartialAccount = {
  /** The _id of the PartialAccount */
  _id: Scalars['ObjectId'];
  /** True if the PartialAccount is currently active */
  active: Scalars['Boolean'];
  /** The GID of the PartialAccount */
  gid: Scalars['GID'];
  /** The index of the PartialAccount for the Person */
  index: Scalars['Int'];
  /** True if the PartialAccount has MFA required */
  mfa_required: Scalars['Boolean'];
  /** The name of the PartialAccount */
  name: Scalars['String'];
  /** The current status of the PartialAccount */
  status: AccountStatus;
  /** The _id of the User for this PartialAccount */
  user_id: Scalars['ObjectId'];
};

export type PendingAccountMember = {
  /** The _id of the PendingAccountMember */
  _id: Scalars['ObjectId'];
  /** The Account associated with the PendingAccountMember */
  account: Account;
  /** The _id of the Account the PendingAccountMember is associated with */
  account_id: Scalars['ObjectId'];
  /** The email of the PendingAccountMember */
  email: Scalars['String'];
  /** The role of the PendingAccountMember */
  role: Scalars['String'];
};

export type PendingUserAccount = {
  /** The _id of the PendingUserAccount */
  _id: Scalars['ObjectId'];
  /** The account the PendingUserAccount is linked to */
  account_id: Scalars['ObjectId'];
  /** When the PendingUserAccount was created */
  created: Scalars['Date'];
  /** The email associated with the PendingUserAccount */
  email: Scalars['String'];
  /** The role of the PendingUserAccount */
  role: Scalars['String'];
};

export type Person = {
  /** The _id of the Person */
  _id: Scalars['ObjectId'];
  /** The email of the Person */
  email: Scalars['String'];
  /** Returns true if the Person has completed MFA authentication */
  mfa_authenticated: Scalars['Boolean'];
  /** The name of the Person */
  name: Scalars['String'];
  /** An array of the PartialAccounts that the Person has access to */
  partial_accounts: Array<PartialAccount>;
  /** If true, the Person's password is expired and must be updated */
  password_expired: Scalars['Boolean'];
  /** The combined PasswordPolicy the password of the Person must follow */
  password_policy: AccountPasswordPolicy;
  /** The IANA timezone to present dates in for the Person */
  timezone?: Maybe<Scalars['TimeZone']>;
  /**
   * An array of the UserAccounts that belong to the Person
   * @deprecated replaced by partial_accounts
   */
  user_accounts: Array<UserAccount>;
};

export type PhoneContact = ContactMethod & {
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The phone number to send data to */
  phoneValue: Scalars['PhoneNumber'];
  /**
   * The phone number to send data to
   * @deprecated replaced by phoneValue
   */
  phone_value: Scalars['PhoneNumber'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
};

export type PhoneContactInput = {
  /** The phone_number to send data to */
  value: Scalars['PhoneNumber'];
};

export type Post = {
  /** The _id of the Post */
  _id: Scalars['ObjectId'];
  /** The author of the Post */
  author: PostAuthor;
  /**
   * The date that the Post was created in our system
   * @deprecated Better to use created_at instead
   */
  created: Scalars['Date'];
  /** The date that the Post was created on the source network */
  created_at: Scalars['Date'];
  /** The GID of the Post */
  gid: Scalars['GID'];
  /** True if the Post has one or more medias */
  has_medias: Scalars['Boolean'];
  /** The original language of the Post */
  language: Scalars['String'];
  /** The medias embedded in the Post */
  medias: Array<PostMedia>;
  /** The original subtext of the Post, in the original language, or null if the original language was English */
  original_subtext?: Maybe<Scalars['String']>;
  /** The original text of the Post, in the original language, or null if the original language was English */
  original_text?: Maybe<Scalars['String']>;
  /** The permalink to the Post on the source network */
  permalink: Scalars['String'];
  /** If true, the Post contents might be sensitive */
  possibly_sensitive: Scalars['Boolean'];
  /** The id of the Post on the source network */
  public_id: Scalars['String'];
  /** If true, the Post is considered verified by our system */
  samdesk_verified: Scalars['Boolean'];
  /** The SocialType of the Post */
  social_type: SocialType;
  /** The source label categories applied to this Post (chatter, news, official) */
  source_label_categories: Array<Scalars['String']>;
  /** The underlying source labels applied to this Post (news_agency, fire_dept, etc.) */
  source_labels: Array<Scalars['String']>;
  /** The subtext of the Post */
  subtext: Scalars['String'];
  /** The text of the Post */
  text: Scalars['String'];
};

export type PostAuthor = {
  /** The url of the author avatar image */
  avatar_url: Scalars['String'];
  /** The description of the author */
  description: Scalars['String'];
  /** The handle of the author */
  handle: Scalars['String'];
  /** The id of the author */
  id: Scalars['String'];
  /** The location of the author */
  location: Scalars['String'];
  /** The name of the author */
  name: Scalars['String'];
  /** The permalink to the author on the source network */
  permalink: Scalars['String'];
  /** The SocialType of the PostAuthor */
  social_type?: Maybe<Scalars['String']>;
  /** If true, the author has been verified by the source network */
  verified: Scalars['Boolean'];
};

export type PostMedia = {
  /** The large image url */
  large_url?: Maybe<Scalars['String']>;
  /** The medium image url */
  medium_url?: Maybe<Scalars['String']>;
  /** The small image url */
  small_url?: Maybe<Scalars['String']>;
  /** The type of the media */
  type: PostMediaType;
  /** The duration of the video, in seconds, if there is a video */
  video_duration?: Maybe<Scalars['Float']>;
  /** The video url */
  video_url?: Maybe<Scalars['String']>;
};

export enum PostMediaType {
  IMAGE = 'IMAGE',
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO'
}

export enum PostSortBy {
  CREATED = 'CREATED',
  CREATED_AT = 'CREATED_AT'
}

export type PresignedPostRequest = {
  /** The fields to send as part of the form data for the PresignedPostRequest */
  fields: Array<PresignedPostRequestField>;
  /** The url of the PresignedPostRequest */
  url: Scalars['String'];
};

export type PresignedPostRequestField = {
  /** The key of the PresignedPostRequestField */
  key: Scalars['String'];
  /** The value of the PresignedPostRequestField */
  value: Scalars['String'];
};

export type ProximityAsset = ProximityAssetBase & {
  /** The _id of the ProximityAsset */
  _id: Scalars['ObjectId'];
  /** The _id of the ProximityAssetSet that the ProximityAsset belongs to */
  assetSetGID: Scalars['GID'];
  /** The _id of the ProximityAssetSet that the ProximityAsset belongs to */
  asset_set_id: Scalars['ObjectId'];
  /** The subtype of the ProximityAsset */
  asset_sub_type: Scalars['String'];
  /** The type of the ProximityAsset */
  asset_type: ProximityAssetType;
  /** The contact methods of the ProximityAsset */
  contactMethods: Array<ContactMethod>;
  /** The contact methods of the ProximityAsset */
  contact_methods: Array<ContactMethod>;
  /** The Date that the ProximityAsset was created */
  created: Scalars['Date'];
  /** The Date that the ProximityAsset was deleted */
  deleted_date?: Maybe<Scalars['Date']>;
  /**
   * The email of the ProximityAsset
   * @deprecated Replaced with contact_methods
   */
  email?: Maybe<Scalars['String']>;
  /** The Date that the ProximityAsset became/will become inactive */
  end_date?: Maybe<Scalars['Date']>;
  /** The GeoJSON geometry representing the ProximityAsset on the globe */
  geometry: GeoJSONGeometry;
  /** The gid of the ProximityAsset */
  gid: Scalars['GID'];
  /** The open/close hours for the ProximityAsset. Follows JavaScript day conventions (ie hours at index 0 is Sunday, 1 is Monday...) */
  hours?: Maybe<Array<Maybe<ProximityAssetHours>>>;
  /** The latitude of the ProximityAsset */
  lat: Scalars['Float'];
  /** The longitude of the ProximityAsset */
  lng: Scalars['Float'];
  /** The name of the ProximityAsset */
  name: Scalars['String'];
  /** The external public_id of the ProximityAsset */
  public_id?: Maybe<Scalars['String']>;
  /** The Date that the ProximityAsset became/will become active */
  start_date?: Maybe<Scalars['Date']>;
  /** The timezone the asset lies in. For Polygons or Linestrings is the timezone of the center */
  timezone?: Maybe<Scalars['TimeZone']>;
  /** The TravelFacility associated with the ProximityAsset */
  travel_facility?: Maybe<ProximityAssetTravelFacility>;
  /** The type of the ProximityAsset */
  type: ProximityAssetType;
  /** The unique user defined ID of the ProximityAsset */
  uid: Scalars['String'];
  /** The Date that the ProximityAsset was last updated */
  updated: Scalars['Date'];
};

export type ProximityAssetBase = {
  /** The _id of the ProximityAsset */
  _id: Scalars['ObjectId'];
  /** The _id of the ProximityAssetSet that the ProximityAsset belongs to */
  assetSetGID: Scalars['GID'];
  /** The _id of the ProximityAssetSet that the ProximityAsset belongs to */
  asset_set_id: Scalars['ObjectId'];
  /** The type of the ProximityAsset */
  asset_type: ProximityAssetType;
  /** The contact methods of the ProximityAsset */
  contactMethods: Array<ContactMethod>;
  /** The contact methods of the ProximityAsset */
  contact_methods: Array<ContactMethod>;
  /** The GeoJSON geometry representing the ProximityAsset on the globe */
  geometry: GeoJSONGeometry;
  /** The gid of the ProximityAsset */
  gid: Scalars['GID'];
  /** The name of the ProximityAsset */
  name: Scalars['String'];
  /** The type of the ProximityAsset */
  type: ProximityAssetType;
  /** The unique user defined ID of the ProximityAsset */
  uid: Scalars['String'];
};

export type ProximityAssetHours = {
  /** The close time of the ProximityAsset in format HH:MM, 24 hour clock */
  close: Scalars['String'];
  /** The open time of the ProximityAsset in format HH:MM, 24 hour clock */
  open: Scalars['String'];
};

export type ProximityAssetHoursParams = {
  /** The open time of the ProximityAsset in format HH:MM, 24 hour clock */
  close: Scalars['String'];
  /** The open time of the ProximityAsset in format HH:MM, 24 hour clock */
  open: Scalars['String'];
};

export type ProximityAssetSet = {
  /** The _id of the ProximityAssetSet */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the ProximityAssetSet belongs to */
  account_id: Scalars['ObjectId'];
  /** The number of ProximityAssets in the ProximityAssetSet */
  asset_count: Scalars['Int'];
  /** The Date that the ProximityAssetSet was created */
  created: Scalars['Date'];
  /** The _id of the ProximityAssetSet */
  gid: Scalars['GID'];
  /** The name of the ProximityAssetSet */
  name: Scalars['String'];
  /** The place proximity of the ProximityAssetSet, in meters */
  proximity: Scalars['Int'];
  /** The type of the ProximityAssetSet */
  type: ProximityAssetSetType;
  /** The Date that the ProximityAssetSet was last updated */
  updated: Scalars['Date'];
  /** Whether or not at least one ProximityAsset in the ProximityAssetSet has the hours field populated */
  uses_hours?: Maybe<Scalars['Boolean']>;
};

export type ProximityAssetSetBase = {
  /** The _id of the ProximityAssetSet */
  _id: Scalars['ObjectId'];
  /** The _id of the ProximityAssetSet */
  gid: Scalars['GID'];
  /** The name of the ProximityAssetSet */
  name: Scalars['String'];
  /** The place proximity of the ProximityAssetSet, in meters */
  proximity: Scalars['Int'];
};

export type ProximityAssetSetSnapshot = ProximityAssetSetBase & {
  /** The _id of the ProximityAssetSet */
  _id: Scalars['ObjectId'];
  /** The _id of the ProximityAssetSet */
  gid: Scalars['GID'];
  /** The name of the ProximityAssetSet */
  name: Scalars['String'];
  /** The place proximity of the ProximityAssetSet, in meters */
  proximity: Scalars['Int'];
};

export enum ProximityAssetSetType {
  REALTIME = 'REALTIME',
  STANDARD = 'STANDARD',
  TRAVEL = 'TRAVEL',
  UNKNOWN = 'UNKNOWN'
}

export type ProximityAssetSnapshot = ProximityAssetBase & {
  /** The _id of the ProximityAsset */
  _id: Scalars['ObjectId'];
  /** The _id of the ProximityAssetSet that the ProximityAsset belongs to */
  assetSetGID: Scalars['GID'];
  /** The _id of the ProximityAssetSet that the ProximityAsset belongs to */
  asset_set_id: Scalars['ObjectId'];
  /** The type of the ProximityAsset */
  asset_type: ProximityAssetType;
  /** The contact methods of the ProximityAsset */
  contactMethods: Array<ContactMethod>;
  /** The contact methods of the ProximityAsset */
  contact_methods: Array<ContactMethod>;
  /** The GeoJSON geometry representing the ProximityAsset on the globe */
  geometry: GeoJSONGeometry;
  /** The gid of the ProximityAsset */
  gid: Scalars['GID'];
  /** The name of the ProximityAsset */
  name: Scalars['String'];
  /** The type of the ProximityAsset */
  type: ProximityAssetType;
  /** The unique user defined ID of the ProximityAsset */
  uid: Scalars['String'];
};

export enum ProximityAssetSortBy {
  DISTANCE = 'DISTANCE',
  NAME = 'NAME',
  _ID = '_ID'
}

export type ProximityAssetTravelFacility = {
  /** The name of the TravelFacility associated with the ProximityAsset */
  name: Scalars['String'];
  /** The type of TravelFacility associated with the ProximityAsset */
  type: Scalars['String'];
};

export enum ProximityAssetType {
  EMPLOYEE = 'EMPLOYEE',
  OTHER = 'OTHER',
  PERSON = 'PERSON',
  PLACE = 'PLACE',
  TRAVELLER = 'TRAVELLER'
}

export type ProximityMatch = {
  /** The _id of the ProximityAsset referenced by the given ProximityMatch */
  asset_id: Scalars['ObjectId'];
  /** The _id of the ProximityAssetSet referenced by the given ProximityMatch */
  asset_set_id: Scalars['ObjectId'];
  /** The type of the ProximityAsset referenced by the given ProximityMatch */
  asset_type: ProximityAssetType;
  /** The uid of the ProximityAsset referenced by the given ProximityMatch */
  asset_uid?: Maybe<Scalars['String']>;
  /** The distance to the ProximityAsset referenced by the given ProximityMatch, in meters */
  distance: Scalars['Float'];
  /**
   * If true, distance should be treated as an exact distance
   * Else it should be treated as a fuzzy match
   */
  is_exact_match: Scalars['Boolean'];
  /** The latitude of the ProximityAsset referenced by the given ProximityMatch */
  lat: Scalars['Float'];
  /** The longitude of the ProximityAsset referenced by the given ProximityMatch */
  lng: Scalars['Float'];
  /** The name of the ProximityAsset referenced by the given ProximityMatch */
  name: Scalars['String'];
};

export type PublicIncidentResponseNotification = {
  /** The GID of the PublicIncidentResponseNotification */
  gid: Scalars['GID'];
  /** The publicly available Incident attached to the IncidentResponseNotification */
  incident: Incident;
  /** The last status of the PublicIncidentResponseNotification */
  lastStatus: IncidentResponseNotificationStatus;
  /** The last time the status was updated for the PublicIncidentResponseNotification */
  lastStatusUpdatedAt?: Maybe<Scalars['Date']>;
  /** The URL to the account logo associated with the PublicIncidentResponseNotification */
  logo?: Maybe<Scalars['URL']>;
  /** The IncidentSummarySession associated with this Incident */
  summary?: Maybe<IncidentSummarySession>;
};

export type Query = {
  /** Count Impact Agent feedback for the given Impact Agent */
  countImpactAgentFeedbacks: Scalars['Int'];
  /** Returns the currently logged in Account */
  getAccount?: Maybe<Account>;
  /**
   * @Public()
   * Returns the AccountInvitation for a given verification code if it exists
   */
  getAccountInvitation: AccountInvitation;
  /** Gets an AnalyticsSearch by GID */
  getAnalyticsSearch?: Maybe<AnalyticsSearch>;
  /** Returns the BriefStatus for a given brief_id */
  getBriefStatus?: Maybe<BriefStatus>;
  /**
   * @Public()
   * Returns the ChangeEmailRequest for the currently logged in Person
   */
  getChangeEmailRequest?: Maybe<ChangeEmailRequest>;
  /** Returns a single Contact belonging to the currently logged in user */
  getContact?: Maybe<Contact>;
  /** Returns a single ContactGroup belonging to the currently logged in user */
  getContactGroup?: Maybe<ContactGroup>;
  /** Returns a single DarkWebPost */
  getDarkWebPost?: Maybe<DarkWebPost>;
  /** Returns the Dashboard for the currently logged in User */
  getDashboard: Dashboard;
  /**
   * Returns the default Everbridge Integration
   * @Roles(ADMIN)
   */
  getDefaultEverbridgeIntegration?: Maybe<DefaultEverbridgeIntegration>;
  /** Finds most recent DownloadStatus for the given gid and purpose */
  getDownloadStatus?: Maybe<DownloadStatus>;
  /**
   * Returns the desired EverbridgeIntegration
   * @Roles(ADMIN)
   */
  getEverbridgeIntegration?: Maybe<EverbridgeIntegration>;
  /** Returns a single GenetecIntegration belonging to the account of the currently logged in user */
  getGenetecIntegrationByGID?: Maybe<GenetecIntegration>;
  /** Returns a single ImpactAgent belonging to the current Account */
  getImpactAgent?: Maybe<ImpactAgent>;
  /** Returns a single Incident */
  getIncident?: Maybe<Incident>;
  /** Returns the total post count and media count for the given Incident with account social filters applied. */
  getIncidentCounts: IncidentCounts;
  /** Returns the IncidentFeaturedContent for an Incident */
  getIncidentFeaturedContent: IncidentFeaturedContent;
  /** Returns an IncidentSummarySession for a given Incident */
  getIncidentSummarySession: BasicIncidentSummarySessionResponse;
  /** Returns an IncidentSummarySession for a given Incident referenced by GID */
  getIncidentSummarySessionByGID: BasicIncidentSummarySessionResponse;
  getIncidentSummarySessionFollowup: BasicIncidentSummarySessionFollowupResponse;
  /** Returns a single MsTeamsWebhook belonging to the currently logged in User */
  getMsTeamsWebhook?: Maybe<MsTeamsWebhook>;
  /** Returns a single OutgoingWebhook belonging to the currently logged in User */
  getOutgoingWebhook?: Maybe<OutgoingWebhook>;
  /** Returns the currently logged in Person */
  getPerson: Person;
  /** Returns the PostAuthor for the given URL, or null if none can be found */
  getPostAuthorByUrl?: Maybe<BasicPostAuthorResponse>;
  /** Returns the ProximityAsset with the given _id */
  getProximityAsset?: Maybe<ProximityAsset>;
  /** Returns the ProximityAssetSet with the given _id */
  getProximityAssetSet?: Maybe<ProximityAssetSet>;
  /**
   * @Public()
   * Returns a publicly available IncidentResponseNotification
   */
  getPublicIncidentResponseNotificationByUUID?: Maybe<PublicIncidentResponseNotification>;
  /**
   * @Public()
   * Returns the ResetPasswordRequest for the provided code
   */
  getResetPasswordRequest?: Maybe<ResetPasswordRequest>;
  /** Returns a single ResolverWebhook belonging to the currently logged in User */
  getResolverWebhook?: Maybe<ResolverWebhook>;
  /** Returns the SAML configuration for the currently logged in Person, if it exists */
  getSAMLConfiguration?: Maybe<SAMLConfiguration>;
  /** Returns a SlackTarget from a workspace, if it exists there */
  getSlackContact?: Maybe<SlackContact>;
  /** Returns a single SlackWebhook belonging to the currently logged in User */
  getSlackWebhook?: Maybe<SlackWebhook>;
  /** Returns a single SlackWorkspace belonging to the currently logged in User */
  getSlackWorkspace?: Maybe<SlackWorkspace>;
  /** Returns a single Stream belonging to the currently logged in User */
  getStream?: Maybe<Stream>;
  /** Returns the requested TravelRegionData */
  getTravelRegionData?: Maybe<TravelRegionData>;
  /** Returns the TravelData for the account */
  getTravellerData?: Maybe<TravelData>;
  /** Returns the currently logged in User */
  getUser?: Maybe<User>;
  /** Get weather by lat and lng from weather_service */
  getWeather?: Maybe<Weather>;
  /** Given a longkey returns the Where */
  getWhereByLongkey?: Maybe<FormattedWhere>;
  /** Returns AccountMembers for the currently logged in Account */
  listAccountMembers: AccountMembers;
  /** Returns a list of Alerts */
  listAlerts: Array<BaseAlert>;
  /** Lists AnalyticsSearches for the current User */
  listAnalyticsSearches?: Maybe<Array<AnalyticsSearch>>;
  /** Returns an array of ContactGroups belonging to the currently logged in user */
  listContactGroups: Array<ContactGroup>;
  /** Returns an array of Contacts belonging to the currently logged in user */
  listContacts: Array<Contact>;
  /** List the update counts for the provided DashboardTabs */
  listDashboardTabUpdateCounts: Array<DashboardTabUpdateCount>;
  /**
   * Returns the desired EverbridgeIntegrations
   * @Roles(ADMIN)
   */
  listEverbridgeIntegrations: Array<EverbridgeIntegration>;
  /** Returns all the current Everbridge VCC Categories */
  listEverbridgeVCCCategories: Array<EverbridgeVCCCategory>;
  /** Returns a list of GenetecIntegrations */
  listGenetecIntegrations: Array<GenetecIntegration>;
  /** List impact agent feedback for the given Incident and Impact Agent */
  listImpactAgentFeedbacks: Array<ImpactAgentFeedback>;
  /** Returns a list of ImpactAgents belonging to the current Account */
  listImpactAgents: Array<ImpactAgent>;
  /** Returns all IncidentResponseActions for given params */
  listIncidentResponseActionsByIncidentResponseNotification: IncidentResponseActionRelay;
  /** Returns all IncidentResponseNotifications for IncidentResponse */
  listIncidentResponseNotifications: IncidentResponseNotificationRelay;
  /** Returns all IncidentResponses for Account */
  listIncidentResponses: IncidentResponseRelay;
  /** Returns all active IncidentTypes */
  listIncidentTypes: Array<IncidentType>;
  /** Returns a list of Incidents */
  listIncidents: Array<Incident>;
  /** Returns a list of InputStreamCategories */
  listInputStreamCategories: Array<InputStreamCategory>;
  /** Returns a list of all currently enabled Languages */
  listLanguages: Array<Language>;
  /** List the local accounts for a location */
  listLocalAccounts: Array<LocalAccount>;
  /** Returns a list of MsTeamsWebhooks */
  listMsTeamsWebhooks: Array<MsTeamsWebhook>;
  /** Returns a list of OutgoingWebhooks */
  listOutgoingWebhooks: Array<OutgoingWebhook>;
  /** Returns a list of Posts for the given Incident */
  listPostsForIncident: Array<Post>;
  /** Returns a list of private Incidents created by the given Account */
  listPrivateIncidents: IncidentConnection;
  /** Returns a list of ProximityAssetSets */
  listProximityAssetSets: Array<ProximityAssetSet>;
  /** Returns a list of ProximityAssets */
  listProximityAssets: Array<ProximityAsset>;
  /** Returns a list of ProximityMatches */
  listProximityMatches: Array<ProximityMatch>;
  /** Returns a list of ResolverWebhooks */
  listResolverWebhooks: Array<ResolverWebhook>;
  /** Returns a list of Salesforce integrations for an Account */
  listSalesforceIntegrations: Array<SalesforceIntegration>;
  /** Returns a list of SlackWebhooks */
  listSlackWebhooks: Array<SlackWebhook>;
  /** Returns a list of SlackWorkspaces */
  listSlackWorkspaces: Array<SlackWorkspace>;
  /** Returns a list of Streams */
  listStreams: Array<Stream>;
  /** Returns the IncidentResponseNotifications with the given GIDs that have updated since the given date */
  listUpdatedIncidentResponseNotifications: ListUpdatedIncidentResponseNotificationsResponse;
  /**
   * Returns a single Stream belonging to the currently logged in User
   * @deprecated Replaced by getStream
   */
  newGetStream?: Maybe<Stream>;
  /**
   * Returns a list of Alerts
   * @deprecated Replaced by listAlerts (which has been swapped to return BaseAlert instead of just IncidentAlert)
   */
  newListAlerts: Array<BaseAlert>;
  /**
   * Returns a list of Streams
   * @deprecated Replaced by listStreams
   */
  newListStreams: Array<Stream>;
  /** Returns individual incidents for a table view with the same filters as analytics queries */
  searchIncidentAnalyticsTable: SearchIncidentAnalyticsTableResult;
  /** Returns a list of SearchIncidentsResults for matching Incidents */
  searchIncidents: Array<SearchIncidentsResult>;
  /** Returns a SearchIncidentsAnalyticsResults for the samalytics project */
  searchIncidentsAnalytics: SearchIncidentsAnalyticsResult;
  /** Returns a list of DrilldownElements for Locations within the given Location */
  searchIncidentsAnalyticsDrilldown: SearchIncidentsAnalyticsResult;
  /** Returns a list of HeatmapPoint for matching Incidents */
  searchIncidentsAnalyticsHeatmap: SearchIncidentsAnalyticsHeatmapResult;
  /** Returns a SearchIncidentsResults for matching Incidents */
  searchIncidentsResults: SearchIncidentsResults;
  /** Returns a list of Locations matching the given parameters */
  searchLocations: Array<Location>;
  /** Returns a list of Incidents following the criteria given */
  searchRecentIncidents: Array<Incident>;
  /** Finds most recent upload for the given gid and purpose */
  uploadStatus?: Maybe<UploadStatus>;
  /** Finds uploads for the given gid and purpose */
  uploadStatuses: Array<UploadStatus>;
};


export type QuerycountImpactAgentFeedbacksArgs = {
  params: ListImpactAgentFeedbacksParams;
};


export type QuerygetAccountInvitationArgs = {
  params: GetAccountInvitationParams;
};


export type QuerygetAnalyticsSearchArgs = {
  params: GetAnalyticsSearchParams;
};


export type QuerygetBriefStatusArgs = {
  params: GetBriefStatusParams;
};


export type QuerygetChangeEmailRequestArgs = {
  params: GetChangeEmailRequestParams;
};


export type QuerygetContactArgs = {
  params: GetContactParams;
};


export type QuerygetContactGroupArgs = {
  params: GetContactGroupParams;
};


export type QuerygetDarkWebPostArgs = {
  params: GetDarkWebPostParams;
};


export type QuerygetDownloadStatusArgs = {
  params: GetDownloadStatusParams;
};


export type QuerygetEverbridgeIntegrationArgs = {
  params: GetEverbridgeIntegrationParams;
};


export type QuerygetGenetecIntegrationByGIDArgs = {
  params: GetGenetecIntegrationByGIDParams;
};


export type QuerygetImpactAgentArgs = {
  params: GetImpactAgentParams;
};


export type QuerygetIncidentArgs = {
  params: GetIncidentParams;
};


export type QuerygetIncidentCountsArgs = {
  params: GetIncidentCountsParams;
};


export type QuerygetIncidentFeaturedContentArgs = {
  params: GetIncidentFeaturedContentParams;
};


export type QuerygetIncidentSummarySessionArgs = {
  params: GetIncidentSummarySessionParams;
};


export type QuerygetIncidentSummarySessionByGIDArgs = {
  params: GetIncidentSummarySessionByGIDParams;
};


export type QuerygetIncidentSummarySessionFollowupArgs = {
  params: GetIncidentSummarySessionFollowupParams;
};


export type QuerygetMsTeamsWebhookArgs = {
  params: GetMsTeamsWebhookParams;
};


export type QuerygetOutgoingWebhookArgs = {
  params: GetOutgoingWebhookParams;
};


export type QuerygetPostAuthorByUrlArgs = {
  params: GetPostAuthorByUrlParams;
};


export type QuerygetProximityAssetArgs = {
  params: GetProximityAssetParams;
};


export type QuerygetProximityAssetSetArgs = {
  params: GetProximityAssetSetParams;
};


export type QuerygetPublicIncidentResponseNotificationByUUIDArgs = {
  params: GetPublicIncidentResponseNotificationByUUIDParams;
};


export type QuerygetResetPasswordRequestArgs = {
  params: GetResetPasswordRequestParams;
};


export type QuerygetResolverWebhookArgs = {
  params: GetResolverWebhookParams;
};


export type QuerygetSlackContactArgs = {
  params: GetSlackContactParams;
};


export type QuerygetSlackWebhookArgs = {
  params: GetSlackWebhookParams;
};


export type QuerygetSlackWorkspaceArgs = {
  params: GetSlackWorkspaceParams;
};


export type QuerygetStreamArgs = {
  params: GetStreamParams;
};


export type QuerygetTravelRegionDataArgs = {
  params: GetTravelRegionDataParams;
};


export type QuerygetWeatherArgs = {
  params: GetWeatherParams;
};


export type QuerygetWhereByLongkeyArgs = {
  params: GetWhereByLongkeyParams;
};


export type QuerylistAlertsArgs = {
  params: ListAlertsParams;
};


export type QuerylistAnalyticsSearchesArgs = {
  params: ListAnalyticsSearchesParams;
};


export type QuerylistContactGroupsArgs = {
  params: ListContactGroupsParams;
};


export type QuerylistContactsArgs = {
  params: ListContactsParams;
};


export type QuerylistDashboardTabUpdateCountsArgs = {
  params: ListDashboardTabUpdateCountsParams;
};


export type QuerylistEverbridgeIntegrationsArgs = {
  params: ListEverbridgeIntegrationsParams;
};


export type QuerylistGenetecIntegrationsArgs = {
  params: ListGenetecIntegrationsParams;
};


export type QuerylistImpactAgentFeedbacksArgs = {
  params: ListImpactAgentFeedbacksParams;
};


export type QuerylistImpactAgentsArgs = {
  params: ListImpactAgentsParams;
};


export type QuerylistIncidentResponseActionsByIncidentResponseNotificationArgs = {
  params: ListIncidentResponseActionsByIncidentResponseNotificationParams;
};


export type QuerylistIncidentResponseNotificationsArgs = {
  params: ListIncidentResponseNotificationsParams;
};


export type QuerylistIncidentResponsesArgs = {
  params: ListIncidentResponsesParams;
};


export type QuerylistIncidentsArgs = {
  params: ListIncidentsParams;
};


export type QuerylistInputStreamCategoriesArgs = {
  params: ListInputStreamCategoriesParams;
};


export type QuerylistLocalAccountsArgs = {
  params: ListLocalAccountsParams;
};


export type QuerylistMsTeamsWebhooksArgs = {
  params: ListMsTeamsWebhooksParams;
};


export type QuerylistOutgoingWebhooksArgs = {
  params: ListOutgoingWebhooksParams;
};


export type QuerylistPostsForIncidentArgs = {
  params: ListPostsForIncidentParams;
};


export type QuerylistPrivateIncidentsArgs = {
  params: ListPrivateIncidentsParams;
};


export type QuerylistProximityAssetSetsArgs = {
  params: ListProximityAssetSetsParams;
};


export type QuerylistProximityAssetsArgs = {
  params: ListProximityAssetsParams;
};


export type QuerylistProximityMatchesArgs = {
  params: ListProximityMatchesParams;
};


export type QuerylistResolverWebhooksArgs = {
  params: ListResolverWebhooksParams;
};


export type QuerylistSlackWebhooksArgs = {
  params: ListSlackWebhooksParams;
};


export type QuerylistSlackWorkspacesArgs = {
  params: ListSlackWorkspacesParams;
};


export type QuerylistStreamsArgs = {
  params: ListStreamsParams;
};


export type QuerylistUpdatedIncidentResponseNotificationsArgs = {
  params: ListUpdatedIncidentResponseNotificationsParams;
};


export type QuerynewGetStreamArgs = {
  params: GetStreamParams;
};


export type QuerynewListAlertsArgs = {
  params: ListAlertsParams;
};


export type QuerynewListStreamsArgs = {
  params: ListStreamsParams;
};


export type QuerysearchIncidentAnalyticsTableArgs = {
  params: SearchIncidentsAnalyticsTableParams;
};


export type QuerysearchIncidentsArgs = {
  params: SearchIncidentsParams;
};


export type QuerysearchIncidentsAnalyticsArgs = {
  params: SearchIncidentsAnalyticsParams;
};


export type QuerysearchIncidentsAnalyticsDrilldownArgs = {
  params: SearchIncidentsAnalyticsDrilldownParams;
};


export type QuerysearchIncidentsAnalyticsHeatmapArgs = {
  params: SearchIncidentsAnalyticsHeatmapParams;
};


export type QuerysearchIncidentsResultsArgs = {
  params: SearchIncidentsParams;
};


export type QuerysearchLocationsArgs = {
  params: SearchLocationsParams;
};


export type QuerysearchRecentIncidentsArgs = {
  params: SearchRecentIncidentsParams;
};


export type QueryuploadStatusArgs = {
  params: UploadStatusParams;
};


export type QueryuploadStatusesArgs = {
  params: UploadStatusesParams;
};

export type RTCUpdate = {
  /** The _id of the author of the RTCUpdate */
  author_id: Scalars['ObjectId'];
  /** The name of the author of the RTCUpdate */
  author_name: Scalars['String'];
  /** The text of the RTCUpdate */
  text: Scalars['String'];
};

export type RelativeTimestampInput = {
  offset: RelativeTimestampOffset;
  timezone: Scalars['TimeZone'];
};

export enum RelativeTimestampOffset {
  PAST_MONTH = 'PAST_MONTH',
  PAST_THREE_DAYS = 'PAST_THREE_DAYS',
  PAST_THREE_MONTHS = 'PAST_THREE_MONTHS',
  PAST_WEEK = 'PAST_WEEK',
  PAST_YEAR = 'PAST_YEAR',
  TODAY = 'TODAY'
}

export type ResendAccountInvitationParams = {
  /** The email to resend the account invite to */
  email: Scalars['String'];
};

export type ResetPasswordRequest = {
  /** The PasswordPolicy for the associated Account */
  account_password_policy: AccountPasswordPolicy;
  /** The unique code for the ResetPasswordRequest */
  code: Scalars['String'];
};

export type ResolveIncidentResponseParams = {
  /** The gid of the Incident to resolve an IncidentResponse for */
  incidentGID: Scalars['GID'];
};

export type ResolverWebhook = {
  /** The _id of the ResolverWebhook */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the ResolverWebhook belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the ResolverWebhook was created */
  created: Scalars['Date'];
  /** If the webhook is disabled on Resolver's side */
  disabled: Scalars['Boolean'];
  /** The headers for the resolver webhook */
  headers?: Maybe<Array<ResolverWebhookHeader>>;
  /** The ResolverWebhook name */
  name: Scalars['String'];
  /** The Date the ResolverWebhook was updated */
  updated: Scalars['Date'];
  /** The ResolverWebhook url */
  url: Scalars['String'];
  /** The _id of the User the ResolverWebhook belongs to */
  user_id: Scalars['ObjectId'];
};

export type ResolverWebhookHeader = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ResolverWebhookHeaderInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RespondPublicIncidentResponseNotificationByUUIDParams = {
  /** The IncidentResponseNotificationStatus to respond with */
  status: IncidentResponseNotificationStatus;
  /** The UUID of the IncidentResponseNotification to respond to */
  uuid: Scalars['UUID'];
};

export type SAMLConfiguration = {
  /** The _id of the SAMLConfiguration */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the SAMLConfiguration belongs to */
  account_id: Scalars['ObjectId'];
  /** The certificates associated with this SAMLConfiguration */
  certs: Array<Scalars['String']>;
  /** When this SAMLConfiguration was created */
  created: Scalars['Date'];
  /** The endpoint to use for SAML verification */
  endpoint: Scalars['String'];
  /** Who issued this SAMLConfiguration */
  issuer: Scalars['String'];
};

export type SalesforceIntegration = {
  /** The _id of the SalesforceIntegration */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the SalesforceIntegration belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the SalesforceIntegration was created */
  created: Scalars['Date'];
  /** The Date the SalesforceIntegration was updated */
  updated: Scalars['Date'];
};

export type SearchIncidentAnalyticsTableItem = {
  /** The date of the incident */
  date: Scalars['Date'];
  /** The incident ID */
  incident_id: Scalars['ObjectId'];
  /** The formatted location (e.g., Place, Locality, State) */
  location: Scalars['String'];
  /** The formatted locations (e.g., Place, Locality, State) */
  locations: Array<Scalars['String']>;
  /** The severity of the incident */
  severity: IncidentSeverity;
  /** The incident types */
  types: Array<Scalars['String']>;
};

export type SearchIncidentAnalyticsTableResult = {
  /** The matching incidents */
  incidents: Array<SearchIncidentAnalyticsTableItem>;
  /** The total count of matching incidents */
  total_count: TotalCount;
};

export type SearchIncidentsAnalyticsDimension = {
  /** The name of the dimension: ex time, type */
  name: Scalars['String'];
  /** The value of the dimension: ex: date_string, shooting */
  value: Scalars['String'];
};

export type SearchIncidentsAnalyticsDrilldownParams = {
  /** The date to search for results after */
  after?: InputMaybe<Scalars['Date']>;
  /** The asset set ID to filter search results by */
  asset_set_id?: InputMaybe<Scalars['ObjectId']>;
  /** The date to search for results before */
  before?: InputMaybe<Scalars['Date']>;
  /** The _ids of the categories to filter search results by */
  category_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The geo filter for radius or polygon-based filtering */
  geo_filter?: InputMaybe<GeoFilterInput>;
  /** The incident types to filter search results by */
  incident_types?: InputMaybe<Array<Scalars['String']>>;
  /** The keywords to filter search results by */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** The location to filter search results by */
  longkey?: InputMaybe<Scalars['String']>;
  /** The relative timestamp to use for time based filtering */
  relative_timestamp?: InputMaybe<RelativeTimestampInput>;
  /** The severities to filter search results by */
  severities?: InputMaybe<Array<IncidentSeverity>>;
};

export type SearchIncidentsAnalyticsHeatmapParams = {
  /** The date to search for results after */
  after?: InputMaybe<Scalars['Date']>;
  /** The asset set ID to filter search results by */
  asset_set_id?: InputMaybe<Scalars['ObjectId']>;
  /** The date to search for results before */
  before?: InputMaybe<Scalars['Date']>;
  /** The _ids of the categories to filter search results by */
  category_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The geo filter for radius or polygon-based filtering */
  geo_filter?: InputMaybe<GeoFilterInput>;
  /** The incident types to filter search results by */
  incident_types?: InputMaybe<Array<Scalars['String']>>;
  /** The keywords to filter search results by */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** The location to filter search results by */
  longkey?: InputMaybe<Scalars['String']>;
  /** How precise the aggregations of lat/lngs should be */
  precision: Scalars['Int'];
  /** The relative timestamp to use for time based filtering */
  relative_timestamp?: InputMaybe<RelativeTimestampInput>;
  /** The severities to filter search results by */
  severities?: InputMaybe<Array<IncidentSeverity>>;
};

export type SearchIncidentsAnalyticsHeatmapResult = {
  /** List of heatmap points */
  points: Array<HeatmapPoint>;
  /** The total count */
  total_count: TotalCount;
};

export type SearchIncidentsAnalyticsMetric = {
  /** The dimensions of the analytics metric */
  dimensions: Array<SearchIncidentsAnalyticsDimension>;
  /** The value of the dimension's bucket, for example count (float because could be average or something) */
  value: Scalars['Float'];
};

export type SearchIncidentsAnalyticsParams = {
  /** The date to search for results after */
  after?: InputMaybe<Scalars['Date']>;
  /** Whether we should aggregate by category or not */
  agg_by_category?: InputMaybe<Scalars['Boolean']>;
  /** Whether we should aggregate by event type or not */
  agg_by_event_type?: InputMaybe<Scalars['Boolean']>;
  /** The asset set ID to filter search results by */
  asset_set_id?: InputMaybe<Scalars['ObjectId']>;
  /** The date to search for results before */
  before?: InputMaybe<Scalars['Date']>;
  /** Size of the bucket interval, ex: 1w, 1M, 1d, 1y */
  bucket_interval?: InputMaybe<Scalars['String']>;
  /** The _ids of the categories to filter search results by */
  category_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The geo filter for radius or polygon-based filtering */
  geo_filter?: InputMaybe<GeoFilterInput>;
  /** The incident types to filter search results by */
  incident_types?: InputMaybe<Array<Scalars['String']>>;
  /** The keywords to filter search results by */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** The location to filter search results by */
  longkey?: InputMaybe<Scalars['String']>;
  /** The relative timestamp to use for time based filtering */
  relative_timestamp?: InputMaybe<RelativeTimestampInput>;
  /** The severities to filter search results by */
  severities?: InputMaybe<Array<IncidentSeverity>>;
};

export type SearchIncidentsAnalyticsResult = {
  /** The results of the analytics response */
  metrics: Array<SearchIncidentsAnalyticsMetric>;
  /** The total count */
  total_count: TotalCount;
};

export type SearchIncidentsAnalyticsTableParams = {
  /** The date to search for results after */
  after?: InputMaybe<Scalars['Date']>;
  /** The asset set ID to filter search results by */
  asset_set_id?: InputMaybe<Scalars['ObjectId']>;
  /** The date to search for results before */
  before?: InputMaybe<Scalars['Date']>;
  /** The _ids of the categories to filter search results by */
  category_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The geo filter for radius or polygon-based filtering */
  geo_filter?: InputMaybe<GeoFilterInput>;
  /** The incident types to filter search results by */
  incident_types?: InputMaybe<Array<Scalars['String']>>;
  /** The keywords to filter search results by */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** The location to filter search results by */
  longkey?: InputMaybe<Scalars['String']>;
  /** The relative timestamp to use for time based filtering */
  relative_timestamp?: InputMaybe<RelativeTimestampInput>;
  /** The severities to filter search results by */
  severities?: InputMaybe<Array<IncidentSeverity>>;
};

export type SearchIncidentsLocation = {
  /** The _id of the location to search for */
  _id: Scalars['ObjectId'];
  /** The key of the location to search for */
  key: Scalars['String'];
};

export type SearchIncidentsParams = {
  /** The date to search for results after */
  after?: InputMaybe<Scalars['Date']>;
  /** The date to search for results before */
  before?: InputMaybe<Scalars['Date']>;
  /** The _ids of the categories to filter search results by */
  category_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** False returns only incidents with is_featured: false. True return only incidents with is_featured: true. Null returns everything. */
  is_featured?: InputMaybe<Scalars['Boolean']>;
  /** The keywords to filter search results by */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  /** The the locations to filter search results by */
  locations?: InputMaybe<Array<SearchIncidentsLocation>>;
};

export type SearchIncidentsResult = {
  /** The highlight metadata for the matching text */
  highlight?: Maybe<SearchIncidentsResultHighlight>;
  /** The matching Incident */
  incident: Incident;
  /** The _id of the matching Incident */
  incident_id: Scalars['ObjectId'];
};

export type SearchIncidentsResultHighlight = {
  /** The field where the match was found */
  source?: Maybe<Scalars['String']>;
  /** The matching text to highlight */
  text?: Maybe<Scalars['String']>;
};

export type SearchIncidentsResults = {
  /** The search incident results */
  results: Array<SearchIncidentsResult>;
  /** The total count */
  total_count: TotalCount;
};

export type SearchLocationsParams = {
  /** The maximum number of locations to return */
  count?: InputMaybe<Scalars['Int']>;
  /** The string query to use in the search */
  query: Scalars['String'];
};

export type SearchRecentIncidentsParams = {
  /** How many Incidents to return at most */
  count?: InputMaybe<Scalars['Int']>;
  /** Which Incident to exclude from the results */
  exclude_incident_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The Incident to find nearby Incidents for */
  incident_ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Longkeys to get Incidents in same area as */
  longkeys?: InputMaybe<Array<Scalars['String']>>;
  /** Type of Incidents to retrieve */
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type SendAccountInvitationParams = {
  /** The email to send the account invite to */
  email: Scalars['String'];
};

export type SendAccountInvitationsParams = {
  /** The emails to send the account invites to */
  emails: Array<Scalars['String']>;
};

export type SendAccountInvitationsResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The emails invitations failed to be sent to */
  failed_emails: Array<SendAccountInvitationsResponseFailedEmails>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The emails invitations were successfully sent to */
  successful_emails: Array<Scalars['String']>;
};

export type SendAccountInvitationsResponseFailedEmails = {
  /** The email that failed */
  email: Scalars['String'];
  /** Why the invitation failed to send */
  failed_reason: Scalars['String'];
};

export type SendIncidentToResolverParams = {
  /** The id of the Incident to share */
  incident_id: Scalars['ObjectId'];
  /** An optional summary to add to the webhook */
  summary?: InputMaybe<Scalars['String']>;
  /** The _id of the ResolverWebhook to use */
  webhook_id: Scalars['ObjectId'];
};

export type SendIncidentToSalesforceParams = {
  /** The id of the Incident to share */
  incident_id: Scalars['ObjectId'];
  /** The Salesforce Integration to send to */
  integration_id: Scalars['ObjectId'];
};

export type SettingsTab = DashboardTab & {
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export type ShareIncidentParams = {
  /** The id of the Incident to share */
  contacts: Array<ContactMethodInput>;
  /** The gid of the Incident to share */
  incidentGID?: InputMaybe<Scalars['GID']>;
  /** The id of the Incident to share */
  incident_id?: InputMaybe<Scalars['ObjectId']>;
  /** Email only. If true, attach a PDF of the incident to the email */
  include_pdf?: InputMaybe<Scalars['Boolean']>;
  /** Email only. An optional summary to add to the email. */
  summary?: InputMaybe<Scalars['String']>;
};

export type SigninParams = {
  /** The email to sign in with */
  email: Scalars['String'];
  /** The password to sign in with */
  password: Scalars['String'];
  /** If true, the response will include a remember_me cookie */
  remember_me?: InputMaybe<Scalars['Boolean']>;
};

export type SignupParams = {
  /** The confirm password value if the Person did not previously exist */
  confirm_password?: InputMaybe<Scalars['String']>;
  /** The email to sign up with */
  email: Scalars['String'];
  /** The name of the Person if they did not previously exist */
  name?: InputMaybe<Scalars['String']>;
  /** The password to sign up with */
  password: Scalars['String'];
  /** The verification code sent to the user as the invitation */
  verification_code: Scalars['String'];
};

export type SlackContact = ContactMethod & {
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The email of the target */
  targetEmail: Scalars['EmailAddress'];
  /** The slack id of the target */
  targetID: Scalars['String'];
  /** The name of the target */
  targetName: Scalars['String'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
  /** The slack id of the workspace */
  workspaceID: Scalars['String'];
  /** The name of the workspace */
  workspaceName: Scalars['String'];
};

export type SlackContactInput = {
  /** The email of the target in Slack to send data to. */
  targetEmail?: InputMaybe<Scalars['EmailAddress']>;
  /** The Slack ID of the target to send data to. */
  targetID?: InputMaybe<Scalars['String']>;
  /** The Slack ID of the workspace of the target to send data to. */
  workspaceID?: InputMaybe<Scalars['String']>;
  /** The name of the workspace of the target to send data to. */
  workspaceName?: InputMaybe<Scalars['String']>;
};

export type SlackWebhook = {
  /** The _id of the SlackWebhook */
  _id: Scalars['ObjectId'];
  /** The _id of the Account the SlackWebhook belongs to */
  account_id: Scalars['ObjectId'];
  /** The name of the Slack channel the SlackWebhook is for */
  channel_name: Scalars['String'];
  /** The configuration url of the SlackWebhook */
  configuration_url: Scalars['String'];
  /** The Date the SlackWebhook was created */
  created: Scalars['Date'];
  /** If true, this webhook has been disabled on Slack's end */
  disabled: Scalars['Boolean'];
  /** The name of the Slack team the SlackWebhook is for */
  team_name: Scalars['String'];
  /** The Date the SlackWebhook was updated */
  updated: Scalars['Date'];
  /** The _id of the User the SlackWebhook belongs to */
  user_id: Scalars['ObjectId'];
};

export type SlackWorkspace = {
  /** The _id of the SlackWorkspace */
  _id: Scalars['ObjectId'];
  /** The GID of the Account that owns the SlackWorkspace */
  accountGID: Scalars['GID'];
  /** The _id of the Account the SlackWorkspace belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the SlackWorkspace was created */
  created: Scalars['Date'];
  /** If true, this Workspace has been disabled on Slack's end */
  disabled: Scalars['Boolean'];
  /** The GID of the SlackWorkspace */
  gid: Scalars['GID'];
  /** The name of SlackWorkspace */
  name: Scalars['String'];
  /** The Date the SlackWorkspace was updated */
  updated: Scalars['Date'];
  /** The GID of the User that owns the SlackWorkspace */
  userGID: Scalars['GID'];
  /** The _id of the User the SlackWorkspace belongs to */
  user_id: Scalars['ObjectId'];
  /** The id of SlackWorkspace in Slack */
  workspaceID: Scalars['String'];
  /** The slack id of SlackWorkspace */
  workspace_id: Scalars['String'];
};

export enum SocialType {
  bluesky = 'bluesky',
  broadcastify = 'broadcastify',
  citizen = 'citizen',
  darkowl = 'darkowl',
  earthquake = 'earthquake',
  facebook = 'facebook',
  instagram = 'instagram',
  nextdoor = 'nextdoor',
  promed = 'promed',
  reddit = 'reddit',
  snap = 'snap',
  telegram = 'telegram',
  twitter = 'twitter',
  unknown = 'unknown',
  vk = 'vk',
  weather = 'weather',
  web = 'web',
  weibo = 'weibo'
}

export type SortDashboardTabsParams = {
  /** The keys of the DashboardTabs in the desired sort order */
  keys: Array<Scalars['String']>;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StandardStream = Stream & {
  /** The _id of the Stream */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Stream belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Stream was created */
  created: Scalars['Date'];
  /** The filter criterion for the given IncidentStream */
  criterion: IncidentStreamCriterion;
  /** The Date the Stream criterion was last changed */
  criterion_updated: Scalars['Date'];
  /** The Date the Stream was deleted */
  deleted_date?: Maybe<Scalars['Date']>;
  /** The GID of the Stream */
  gid: Scalars['GID'];
  /** The ImpactAgent configuration linked to this Stream */
  impact_agent_stream_configuration?: Maybe<ImpactAgentStreamConfiguration>;
  /** True if the current User is the owner of the Stream */
  is_owner: Scalars['Boolean'];
  /** The name of the Stream */
  name: Scalars['String'];
  notifications: IncidentStreamNotifications;
  /** The owner of the Stream */
  owner?: Maybe<OtherUser>;
  /** If and how the Stream is shared */
  share_type: StreamShareType;
  /** The Date the Stream was transferred to the current owner */
  transferred_date?: Maybe<Scalars['Date']>;
  /** The type of the Stream */
  type: StreamType;
  /** The number of unread Alerts in the Stream */
  unread_count: Scalars['Int'];
  /** The Date the Stream was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Stream belongs to */
  user_id: Scalars['ObjectId'];
};

export type StandardStreamLuceneStringCriterionInput = {
  /** True if the LuceneString is advanced */
  advanced: Scalars['Boolean'];
  /** The value of the LuceneString filter */
  value: Scalars['LuceneString'];
};

export type Stream = {
  /** The _id of the Stream */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Stream belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Stream was created */
  created: Scalars['Date'];
  /** The Date the Stream criterion was last changed */
  criterion_updated: Scalars['Date'];
  /** The Date the Stream was deleted */
  deleted_date?: Maybe<Scalars['Date']>;
  /** The GID of the Stream */
  gid: Scalars['GID'];
  /** True if the current User is the owner of the Stream */
  is_owner: Scalars['Boolean'];
  /** The name of the Stream */
  name: Scalars['String'];
  /** The owner of the Stream */
  owner?: Maybe<OtherUser>;
  /** If and how the Stream is shared */
  share_type: StreamShareType;
  /** The Date the Stream was transferred to the current owner */
  transferred_date?: Maybe<Scalars['Date']>;
  /** The type of the Stream */
  type: StreamType;
  /** The number of unread Alerts in the Stream */
  unread_count: Scalars['Int'];
  /** The Date the Stream was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Stream belongs to */
  user_id: Scalars['ObjectId'];
};

export type StreamManagerTab = DashboardTab & {
  /** The unique key of the DashboardTab */
  key: Scalars['String'];
  /** The type of the DashboardTab */
  type: DashboardTabType;
};

export enum StreamShareType {
  NONE = 'NONE',
  READ = 'READ',
  WRITE = 'WRITE'
}

export enum StreamType {
  DARK_WEB = 'DARK_WEB',
  INCIDENT = 'INCIDENT',
  STANDARD = 'STANDARD',
  WEB_ALERTS = 'WEB_ALERTS'
}

export type SubmitChangeEmailRequestParams = {
  /** The unique code for the ChangeEmailRequest */
  code: Scalars['String'];
};

export type SubmitMFACodeParams = {
  /** The MFA code to be verified */
  code: Scalars['String'];
};

export type SubmitResetPasswordRequestParams = {
  /** The unique code for the ResetPasswordRequest */
  code: Scalars['String'];
  /** The new password to set */
  password: Scalars['String'];
};

export type TextHighlight = {
  /** The end index of the highlight */
  end: Scalars['Int'];
  /** The start index of the highlight */
  start: Scalars['Int'];
};

export type TextSnippet = {
  /** The TextSnippet highlights */
  highlights: Array<TextHighlight>;
  /** The TextSnippet text */
  text: Scalars['String'];
  /** True if the TextSnippet is truncated at the end */
  truncatedEnd: Scalars['Boolean'];
  /** True if the TextSnippet is truncated at the start */
  truncatedStart: Scalars['Boolean'];
};

export type TextSnippetRelay = {
  /** The TextSnippet nodes */
  nodes: Array<TextSnippet>;
};

export type TotalCount = {
  /** The total count relation: eq, gt, gte, lt, lte */
  relation: Scalars['String'];
  /** The total count value */
  value: Scalars['Float'];
};

export type TravelData = {
  /** List of all travellers for this account */
  all_travellers: Array<TravellerData>;
  /** List of all regions and how many travellers this account has in each region */
  region_data: Array<TravellerRegionData>;
  /** The time of last polling of data */
  time: Scalars['Date'];
};

export type TravelRegionData = {
  /** All the travellers currently in the provided region */
  travel_region_details: Array<TravellerData>;
};

export type TravellerData = {
  /** Which province/state etc. the traveller is in */
  admin_1?: Maybe<Scalars['String']>;
  /** Which country the traveller is in */
  country: Scalars['String'];
  /** Email of the traveller */
  email?: Maybe<Scalars['String']>;
  /** The end date of the traveller being in the region */
  end_date: Scalars['Date'];
  /** Which locality the traveller is in */
  locality?: Maybe<Scalars['String']>;
  /** Name of the traveller */
  name: Scalars['String'];
  /** The start date of the traveller being in the region */
  start_date: Scalars['Date'];
  /** Whether the traveller is active or pending */
  status: Scalars['String'];
};

export type TravellerRegionData = {
  /** How many travellers are currently confirmed in the region. */
  active_count: Scalars['Int'];
  /** Which country the data represents */
  country: Scalars['String'];
  /** How many travellers are in the process of being added to this region */
  pending_count: Scalars['Int'];
};

export type UpdateAPIKeyParams = {
  /** True if the API key is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The GID of the API Key to update */
  gid: Scalars['GID'];
  /** The name of the API Key */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountMemberParams = {
  /** The _id of the AccountMember to update */
  _id: Scalars['ObjectId'];
  /** The role to update to */
  role: UserAccountRole;
};

export type UpdateAccountParams = {
  /** The _id of the Account */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The list of domains that User emails are allowed to have */
  email_domains?: InputMaybe<Array<Scalars['String']>>;
  /** The logo of the Account */
  logo?: InputMaybe<Scalars['String']>;
  /** The name of the Account */
  name?: InputMaybe<Scalars['String']>;
  /** The Account's password policy */
  password_policy?: InputMaybe<AccountPasswordPolicyParams>;
  /** The Account's preferences, set by an Account admin */
  preferences?: InputMaybe<AccountPreferencesParams>;
};

export type UpdateAccountResponse = {
  /** The Account that was updated, if successful */
  account?: Maybe<Account>;
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
};

export type UpdateAlertsData = {
  /** Whether the Alert should be considered read or not */
  read?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAlertsPaneDataInput = {
  /** Optional name for this Alerts pane */
  name?: InputMaybe<Scalars['String']>;
  /** Notification sound for this Alerts pane */
  sound?: InputMaybe<AlertsTabDataSoundInput>;
  /** Streams to show in this Alerts pane */
  streamIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Time window in seconds */
  timeWindowSeconds?: InputMaybe<Scalars['Int']>;
  /** If true, only unread items are shown */
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAlertsPaneInDashboardColumnParams = {
  /** Data specific to the Alerts pane */
  alertsPaneData: UpdateAlertsPaneDataInput;
  /** The _id of the DashboardColumn */
  columnId: Scalars['ObjectId'];
  /** Key of the Alerts pane to update within the DashboardColumn */
  paneKey: Scalars['String'];
  /** Key of the ColumnsTab that owns this DashboardColumn */
  tabKey: Scalars['String'];
};

export type UpdateAlertsParams = {
  /** The _ids of the Alerts to update */
  alert_ids: Array<Scalars['ObjectId']>;
  /** The data to update the Alerts with */
  data: UpdateAlertsData;
  /** The _ids of the Streams to update Alerts for */
  stream_ids: Array<Scalars['ObjectId']>;
};

export type UpdateAlertsTabDataInput = {
  /** The list of Streams in the bottom pane of the AlertsTab */
  bottom?: InputMaybe<Array<AlertsTabDataStreamInput>>;
  /** The notification sound data for the bottom pane of the AlertsTab */
  bottom_sound?: InputMaybe<AlertsTabDataSoundInput>;
  /** Map width set by sliding the resizer */
  map_width?: InputMaybe<Scalars['Float']>;
  /** The name of the AlertsTab */
  name?: InputMaybe<Scalars['String']>;
  /** Pane height set by sliding the resizer */
  pane_height?: InputMaybe<Scalars['Float']>;
  /** AssetSets excluded to show on this tab */
  selected_asset_sets?: InputMaybe<Array<AlertsTabDataAssetSetInput>>;
  /** The list of Streams in the top pane of the AlertsTab */
  top?: InputMaybe<Array<AlertsTabDataStreamInput>>;
  /** The notification sound data for the top pane of the AlertsTab */
  top_sound?: InputMaybe<AlertsTabDataSoundInput>;
};

export type UpdateAnalyticsSearchParams = {
  /** The data to apply to the AnalyticsSearch */
  data?: InputMaybe<AnalyticsSearchData>;
  /** The GID of the AnalyticsSearch to update */
  gid: Scalars['GID'];
};

export type UpdateColumnsTabDataInput = {
  /** The name of the ColumnsTab */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateContactGroupParams = {
  /** The data to use to create the ContactGroup */
  data: ContactGroupData;
  /** The gid of the ContactGroup to update */
  gid: Scalars['GID'];
};

export type UpdateContactParams = {
  /** The data to use to update the Contact */
  data: ContactData;
  /** The gid of the Contact to update */
  gid: Scalars['GID'];
};

export type UpdateDarkWebStreamParams = {
  /** The _id of the Stream to update */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The filter criterion for a DarkWebStream */
  criterion?: InputMaybe<DarkWebStreamCriterionInput>;
  /** The GID of the Stream to update */
  gid?: InputMaybe<Scalars['GID']>;
  /** The name of the Stream */
  name?: InputMaybe<Scalars['String']>;
  /** The notification configuration for a DarkWebStream */
  notifications?: InputMaybe<DarkWebStreamNotificationsInput>;
  /** If and how the Stream should be shared */
  share_type?: InputMaybe<StreamShareType>;
};

export type UpdateDarkWebTabDataInput = {
  /** The _id of the DarkWebPost referenced by this tab */
  dark_web_post_id?: InputMaybe<Scalars['ObjectId']>;
};

export type UpdateDashboardColumnOrderInTabParams = {
  /** The destination index of the dashboard column */
  destinationIndex: Scalars['Int'];
  /** The original index of the dashboard column */
  originIndex: Scalars['Int'];
  /** The key of the ColumnsTab containing the columns to reorder */
  tabKey: Scalars['String'];
};

export type UpdateDashboardTabInput = {
  /** The data specific to an AlertsTab */
  alerts_tab_data?: InputMaybe<UpdateAlertsTabDataInput>;
  /** The data specific to a ColumnsTab */
  columns_tab_data?: InputMaybe<UpdateColumnsTabDataInput>;
  /** The data specific to a DarkWebTab */
  dark_web_tab_data?: InputMaybe<UpdateDarkWebTabDataInput>;
  /** The data specific to an IncidentTab */
  incident_tab_data?: InputMaybe<UpdateIncidentTabDataInput>;
  /** The type of DashboardTab */
  type: DashboardTabType;
};

export type UpdateDashboardTabOrderParams = {
  /** The destination index of the dashboard tab */
  destinationIndex: Scalars['Int'];
  /** The original index of the dashboard tab */
  originIndex: Scalars['Int'];
};

export type UpdateDashboardTabParams = {
  /** The key of the DashboardTab to update */
  key: Scalars['String'];
  /** The DashboardTab to update to */
  tab: UpdateDashboardTabInput;
};

export type UpdateEverbridgeIntegrationFields = {
  /** API key provided by Everbridge */
  api_key?: InputMaybe<Scalars['String']>;
  /** Default category mapping for this Everbridge Integration */
  default_vcc_category?: InputMaybe<Scalars['String']>;
  /** Whether or not to send updates to this Everbridge Integration */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The mappings to use when sending updates to Everbridge. V1 Only. */
  event_mapping?: InputMaybe<Array<EverbridgeIntegrationEventMappingInput>>;
  /** Whether or not to format the location for granularity. V1 Only. */
  granularity_format?: InputMaybe<Scalars['Boolean']>;
  /** Name of the Everbridge Integration */
  name?: InputMaybe<Scalars['String']>;
  /** Which datas to send or skip sending for this Everbridge Integration. */
  social_types?: InputMaybe<EverbridgeIntegrationSocialTypesInput>;
  /** URL to the Everbridge Integration */
  url?: InputMaybe<Scalars['String']>;
  /** Which version this Everbridge Integration is. Currently only V1 or V2. */
  version?: InputMaybe<Scalars['Int']>;
};

export type UpdateEverbridgeIntegrationParams = {
  /** _id of the EverbridgeIntegration to update */
  _id: Scalars['ObjectId'];
  /** Fields to update on the EverbridgeIntegration */
  fields: UpdateEverbridgeIntegrationFields;
};

export type UpdateGenetecIntegrationByGIDParams = {
  /** The gid of the GenetecIntegration to update */
  gid: Scalars['GID'];
  /** The map ID to use when sending messages to Genetec for the GenetecIntegration. If null will be unset. */
  mapID?: InputMaybe<Scalars['String']>;
  /** The name to give to the GenetecIntegration */
  name: Scalars['String'];
  /** The server to give to the GenetecIntegration */
  server: Scalars['URL'];
  /** The username to use for the GenetecIntegration */
  username: Scalars['String'];
};

export type UpdateGenetecIntegrationPasswordByGIDParams = {
  /** The gid of the GenetecIntegration to update */
  gid: Scalars['GID'];
  /** The new password of the GenetecIntegration */
  password: Scalars['String'];
};

export type UpdateImpactAgentFeedbackParams = {
  /** The _id of the Impact Agent feedback to update */
  _id: Scalars['ObjectId'];
  /** The review status to set on the feedback */
  feedback_status: ImpactAgentFeedbackStatus;
};

export type UpdateImpactAgentFeedbacksParams = {
  /** The _ids of the Impact Agent feedbacks to update */
  feedback_ids: Array<Scalars['ObjectId']>;
  /** The review status to set on the feedbacks */
  feedback_status: ImpactAgentFeedbackStatus;
};

export type UpdateImpactAgentFields = {
  /** The prompt used to filter impact agent matches */
  agent_filter_prompt: Scalars['String'];
  /** The prompt used to format the impact agent presentation output */
  agent_presentation_prompt?: InputMaybe<Scalars['String']>;
  /** The allowed impact agent categories used to build the response schema */
  categories: Array<ImpactAgentCategoryInput>;
  /** The display name of the ImpactAgent */
  name: Scalars['String'];
};

export type UpdateImpactAgentParams = {
  /** The _id of the ImpactAgent to update */
  _id: Scalars['ObjectId'];
  /** The fields to update on the ImpactAgent */
  fields: UpdateImpactAgentFields;
};

export type UpdateIncidentStreamParams = {
  /** The _id of the Stream to update */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The filter criterion for a IncidentStream */
  criterion?: InputMaybe<IncidentStreamCriterionInput>;
  /** The GID of the Stream to update */
  gid?: InputMaybe<Scalars['GID']>;
  /** The ImpactAgentStream configuration to couple to this IncidentStream */
  impact_agent_stream?: InputMaybe<ImpactAgentStreamConfigurationInput>;
  /** The name of the Stream */
  name?: InputMaybe<Scalars['String']>;
  /** The notification configuration for a IncidentStream */
  notifications?: InputMaybe<IncidentStreamNotificationsInput>;
  /** If and how the Stream should be shared */
  share_type?: InputMaybe<StreamShareType>;
};

export type UpdateIncidentTabDataInput = {
  /** The _id of the Incident referenced by this tab */
  incident_id?: InputMaybe<Scalars['ObjectId']>;
};

export type UpdatePersonParams = {
  /** The name to update to */
  name?: InputMaybe<Scalars['String']>;
  /** The information to update the password to */
  password_data?: InputMaybe<UpdatePersonPasswordParams>;
  /** The timezone to update to */
  timezone?: InputMaybe<Scalars['TimeZone']>;
};

export type UpdatePersonPasswordParams = {
  /** The new password to update to */
  new_password: Scalars['String'];
  /** The old password for reference */
  old_password: Scalars['String'];
};

export type UpdateProximityAssetParams = {
  /** The _id of the ProximityAsset to update */
  _id: Scalars['ObjectId'];
  /** The type of the ProximityAsset */
  asset_type?: InputMaybe<ProximityAssetType>;
  /** The contact_methods of the ProximityAsset */
  contact_methods?: InputMaybe<Array<ContactMethodInput>>;
  /** The email of the ProximityAsset */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** The end date of the ProximityAsset. */
  end_date?: InputMaybe<Scalars['Date']>;
  /** The geometry representing the ProximityAsset on the globe */
  geometry?: InputMaybe<GeoJSONGeometryParams>;
  /** The open/close hours for the ProximityAsset. Follows JavaScript day conventions (ie hours at index 0 is Sunday, 1 is Monday...) */
  hours?: InputMaybe<Array<InputMaybe<ProximityAssetHoursParams>>>;
  /** The latitude of the ProximityAsset */
  lat?: InputMaybe<Scalars['Float']>;
  /** The longitude of the ProximityAsset */
  lng?: InputMaybe<Scalars['Float']>;
  /** The name of the ProximityAsset */
  name?: InputMaybe<Scalars['String']>;
  /** The start date of the ProximityAsset. */
  start_date?: InputMaybe<Scalars['Date']>;
  /** The unique user defined ID of the ProximityAsset */
  uid?: InputMaybe<Scalars['String']>;
};

export type UpdateProximityAssetSetParams = {
  /** The _id of the ProximityAssetSet to update */
  _id: Scalars['ObjectId'];
  /** The name of the ProximityAssetSet */
  name?: InputMaybe<Scalars['String']>;
  /** The place level proximity of the ProximityAssetSet, in meters */
  proximity?: InputMaybe<Scalars['Int']>;
};

export type UpdateUserPreferencesParams = {
  /** The list of language codes to disable translations for */
  disabled_translations?: InputMaybe<Array<Scalars['String']>>;
  /** Either metric or imperial (kilometers or miles) */
  distance_unit?: InputMaybe<DisplayUnit>;
  /** The User's preferred notification sound */
  notification_sound?: InputMaybe<Scalars['String']>;
  /** Either metric or imperial (celcius or fahrenheit) */
  temperature_unit?: InputMaybe<DisplayUnit>;
};

export type UpdateWebAlertsStreamParams = {
  /** The _id of the Stream to update */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The filter criterion for a WebAlertsStream */
  criterion?: InputMaybe<WebAlertsStreamCriterionInput>;
  /** The GID of the Stream to update */
  gid?: InputMaybe<Scalars['GID']>;
  /** The name of the Stream */
  name?: InputMaybe<Scalars['String']>;
  /** The notification configuration for a WebAlertsStream */
  notifications?: InputMaybe<WebAlertsStreamNotificationsInput>;
  /** If and how the Stream should be shared */
  share_type?: InputMaybe<StreamShareType>;
};

export type UploadCompleteParams = {
  /** The _id of the UploadStatus to mark completed */
  gid: Scalars['GID'];
};

export type UploadCreateParams = {
  /** The user provided file_name given to identify the Upload */
  file_name?: InputMaybe<Scalars['String']>;
  /** The purpose of the Upload to create an UploadStatus for */
  purpose: UploadStatusPurpose;
  /** The gid of the object to create an UploadStatus for */
  target_gid: Scalars['GID'];
};

export type UploadCreateResponse = {
  /** The error from the operation, if there was one */
  error?: Maybe<BasicError>;
  /** The S3 destination initialized for this Upload */
  s3_data?: Maybe<PresignedPostRequest>;
  /** True if the operation was successful, false otherwise */
  success: Scalars['Boolean'];
  /** The UploadStatus affected by the operation */
  upload_status?: Maybe<UploadStatus>;
};

export type UploadStatus = {
  /** The Date that the UploadStatus was created */
  created: Scalars['Date'];
  /** The User who initiated the upload */
  created_by: User;
  /** Any errors that happened during the upload represented by this UploadStatus */
  errors: Array<BasicError>;
  /** The key of the CSV uploaded to S3 for the upload referenced by the given ProximityAssetUploadStatus */
  file_name?: Maybe<Scalars['String']>;
  /** The GID of the upload represented by this UploadStatus */
  gid: Scalars['GID'];
  /** The current progress of this UploadStatus */
  progress: UploadStatusProgress;
  /** The purpose of this UploadStatus */
  purpose: UploadStatusPurpose;
  /** The status of this UploadStatus */
  status: UploadStatusStatus;
  /** The GID of the object affected by this UploadStatus */
  target_gid: Scalars['GID'];
  /** The Date that the UploadStatus was last updated */
  updated: Scalars['Date'];
};

export type UploadStatusParams = {
  /** The purpose of the Upload to create */
  purpose: UploadStatusPurpose;
  /** The gid of the object to retrieve UploadStatuses for */
  target_gid: Scalars['GID'];
};

export type UploadStatusProgress = {
  /** The current number of items impacted so far by the upload represented by this UploadStatus */
  count: Scalars['Int'];
  /** The percent of items impacted so far by the upload represented by this UploadStatus */
  percent: Scalars['Float'];
  /** The total number of items being impacted by the upload represented by this UploadStatus */
  total: Scalars['Int'];
};

export enum UploadStatusPurpose {
  Account_Logo = 'Account_Logo',
  Account_Members = 'Account_Members',
  ProximityAssetSet_Assets = 'ProximityAssetSet_Assets'
}

export enum UploadStatusStatus {
  /** The Upload completed and the target was changed to some degree. */
  COMPLETED = 'COMPLETED',
  /** The Upload failed and the target was returned to its original state. */
  FAILED = 'FAILED',
  /** The Upload has been received by the server and is queued for processing. */
  PENDING = 'PENDING',
  /** The Upload has been is being processed by the browser before the data changes begin. */
  PREUPLOAD = 'PREUPLOAD',
  /** The Upload is being processed by the server. */
  PROCESSING = 'PROCESSING',
  /** The Upload is in the process of being uploaded by the browser. */
  UPLOADING = 'UPLOADING'
}

export type UploadStatusesParams = {
  /** The purpose of the Upload to create */
  purpose: UploadStatusPurpose;
  /** The gid of the object to retrieve UploadStatuses for */
  target_gid: Scalars['GID'];
};

export type UpsertSAMLConfigurationParams = {
  /** The certificates associated with the SAMLConfiguration */
  certs: Array<Scalars['String']>;
  /** The endpoint to use for SAML verification */
  endpoint: Scalars['String'];
  /** Who issued the SAMLConfiguration */
  issuer: Scalars['String'];
};

export type User = IUser & {
  /** The _id of the IUser */
  _id: Scalars['ObjectId'];
  /** The Account the User belongs to */
  account: Account;
  /** The _id of the Account the User belongs to */
  account_id: Scalars['ObjectId'];
  /** The User's synced client settings */
  client_settings: Array<ClientSetting>;
  /** When the User was created */
  created: Scalars['Date'];
  /** True if the User has been removed from the Account */
  disabled: Scalars['Boolean'];
  /** The email of the IUser */
  email: Scalars['String'];
  /** The gid of the IUser */
  gid: Scalars['GID'];
  /** The index of the User in the Person's users array */
  index: Scalars['Int'];
  /** The IntercomConfig for the User */
  intercom: IntercomConfig;
  /** The date of the last recorded activity for the User */
  last_activity?: Maybe<Scalars['Date']>;
  /** The name of the IUser */
  name: Scalars['String'];
  /** The Person that the User belongs to */
  person: Person;
  /** The User's preferences, set by a user (replacing client settings) */
  preferences: UserPreferences;
  /** The role of the User in the Account */
  role: UserAccountRole;
  /** The User's settings */
  settings: UserSettings;
};

export type UserAccount = {
  /** The referenced Account */
  account: Account;
  /** The _id of the referenced Account */
  account_id: Scalars['ObjectId'];
  /** True if the User has been removed from the Account */
  disabled: Scalars['Boolean'];
  /** The Intercom config for the referenced User */
  intercom: IntercomConfig;
  /** The role of the User in the Account */
  role: UserAccountRole;
  /** The referenced User */
  user: User;
  /** The _id of the referenced User */
  user_id: Scalars['ObjectId'];
};

export enum UserAccountRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export type UserContact = ContactMethod & {
  /** Whether data is deliverable to the ContactMethods value */
  deliverable: Scalars['Boolean'];
  /** The type of the ContactMethod */
  type: ContactMethodType;
  /** The name of the UserContact */
  userValue: Scalars['String'];
};

export type UserPreferences = {
  /** The list of language codes to disable translations for */
  disabled_translations: Array<Scalars['String']>;
  /** Either metric or imperial (kilometers or miles) */
  distance_unit: DisplayUnit;
  /** The User's preferred notification sound */
  notification_sound: Scalars['String'];
  /** Either metric or imperial (celcius or fahrenheit) */
  temperature_unit: DisplayUnit;
};

export type UserSettings = {
  /** The maximum number of Dark Web Streams that a User is allowed to have */
  max_dark_web_streams: Scalars['Int'];
  /** The maximum number of columns in a single columns tab the User is allowed to have */
  max_dashboard_columns_tab_columns: Scalars['Int'];
  /** The maximum number of columns tabs the User is allowed to have */
  max_dashboard_columns_tabs: Scalars['Int'];
  /** The maximum number of search tabs that the User is allowed to have */
  max_dashboard_search_tabs: Scalars['Int'];
  /**
   * The maximum number of dashboard tabs that the User is allowed to have
   * @deprecated replaced by max_dashboard_search_tabs and max_dashboard_tracked_tabs
   */
  max_dashboard_tabs: Scalars['Int'];
  /** The maximum number of tracked event tabs that the User is allowed to have */
  max_dashboard_tracked_tabs: Scalars['Int'];
  /** The maximum number of search streams that the User is allowed to have */
  max_search_streams: Scalars['Int'];
  /** The maximum number of Sources that a User is allowed to have in a single Web Alert Stream */
  max_web_alert_stream_sources: Scalars['Int'];
  /** The maximum number of Web Alert Streams that the User is allowed to have */
  max_web_alert_streams: Scalars['Int'];
};

export type Weather = {
  /** Cloudiness percentage */
  cloud_percentage: Scalars['Int'];
  /** Weather condition code */
  code: Scalars['String'];
  /** Humidity percentage */
  humidity: Scalars['Int'];
  /** Weather icon identifier */
  icon: Scalars['String'];
  /** Long description of the weather condition */
  long_description: Scalars['String'];
  /** Atmospheric pressure in hPa */
  pressure: Scalars['Int'];
  /** Rain volume for the last 1 hour in mm */
  rain_1h: Scalars['Float'];
  /** Rain volume for the last 3 hours in mm */
  rain_3h: Scalars['Float'];
  /** Short description of the weather condition */
  short_description: Scalars['String'];
  /** Snow volume for the last 1 hour in mm */
  snow_1h: Scalars['Float'];
  /** Snow volume for the last 3 hours in mm */
  snow_3h: Scalars['Float'];
  /** Sunrise time in milliseconds since Unix epoch */
  sunrise: Scalars['Float'];
  /** Sunset time in milliseconds since Unix epoch */
  sunset: Scalars['Float'];
  /** Temperature in Celsius */
  temp: Scalars['Float'];
  /** Compass wind direction */
  wind_direction?: Maybe<Scalars['String']>;
  /** Wind speed in meters per second */
  wind_speed: Scalars['Float'];
};

export type WebAlert = BaseAlert & {
  /** The _id of the Alert */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Alert belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Alert was created */
  created: Scalars['Date'];
  /** The GID of the Alert */
  gid: Scalars['GID'];
  /** The Post the Alert is based on */
  post: Post;
  /** True if the Alert has been read by the User */
  read: Scalars['Boolean'];
  /** The _id of the Stream that the Alert was generated for */
  stream_id: Scalars['ObjectId'];
  /** The Date the Alert was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Alert was generated for */
  user_id: Scalars['ObjectId'];
};

export type WebAlertsStream = Stream & {
  /** The _id of the Stream */
  _id: Scalars['ObjectId'];
  /** The _id of the Account that the Stream belongs to */
  account_id: Scalars['ObjectId'];
  /** The Date the Stream was created */
  created: Scalars['Date'];
  /** The filter criterion for the given WebAlertsStream */
  criterion: WebAlertsStreamCriterion;
  /** The Date the Stream criterion was last changed */
  criterion_updated: Scalars['Date'];
  /** The Date the Stream was deleted */
  deleted_date?: Maybe<Scalars['Date']>;
  /** The GID of the Stream */
  gid: Scalars['GID'];
  /** True if the current User is the owner of the Stream */
  is_owner: Scalars['Boolean'];
  /** The name of the Stream */
  name: Scalars['String'];
  /** The notification configurations for the given WebAlertsStream */
  notifications: WebAlertsStreamNotifications;
  /** The owner of the Stream */
  owner?: Maybe<OtherUser>;
  /** If and how the Stream is shared */
  share_type: StreamShareType;
  /** The Date the Stream was transferred to the current owner */
  transferred_date?: Maybe<Scalars['Date']>;
  /** The type of the Stream */
  type: StreamType;
  /** The number of unread Alerts in the Stream */
  unread_count: Scalars['Int'];
  /** The Date the Stream was last updated */
  updated: Scalars['Date'];
  /** The _id of the User that the Stream belongs to */
  user_id: Scalars['ObjectId'];
};

export type WebAlertsStreamCriterion = {
  /** The Lucene string to filter the WebAlertsStream Alerts by */
  lucene_string?: Maybe<IncidentStreamLuceneStringCriterion>;
  /** The number of sources the WebAlertsStream is tracking */
  source_count: Scalars['Float'];
  /** The sources the WebAlertsStream is tracking */
  sources: Array<WebAlertsStreamSource>;
};

export type WebAlertsStreamCriterionInput = {
  /** The Lucene string to filter the WebAlertsStream Alerts by */
  lucene_string?: InputMaybe<StandardStreamLuceneStringCriterionInput>;
  /** The list of source urls for the WebAlertsStream to track */
  source_urls: Array<Scalars['URL']>;
};

export type WebAlertsStreamNotifications = {
  /** The email notification configuration for the given IncidentStream */
  email: IncidentStreamEmailNotifications;
  /** The ms teams notification configuration for the given IncidentStream */
  ms_teams: IncidentStreamMsTeamsNotifications;
  /** The slack notification configuration for the given IncidentStream */
  slack: IncidentStreamSlackNotifications;
};

export type WebAlertsStreamNotificationsInput = {
  /** The email notification configuration for a IncidentStream */
  email: IncidentStreamEmailNotificationsInput;
  /** The ms_teams notification configuration for a IncidentStream */
  ms_teams: IncidentStreamMsTeamsNotificationsInput;
  /** The slack notification configuration for a IncidentStream */
  slack: IncidentStreamSlackNotificationsInput;
};

export type WebAlertsStreamSource = {
  /** Whether or not the source is currently disabled */
  disabled: Scalars['Boolean'];
  /** The post author represented by the source */
  post_author: PostAuthor;
};

export type WebhookFailure = {
  /** The error code of the failed delivery (the HTTP status code for OutgoingWebhooks, e.g. "404") */
  code: Scalars['String'];
  /** The Date the delivery failed */
  date: Scalars['Date'];
};

export type Where = {
  /** The _id of the Where, this is the same as the Where's _id from TweetEventService. Null if where is implicit. */
  _id?: Maybe<Scalars['String']>;
  /** The compact display name of the referenced location */
  compact_display: Scalars['String'];
  /** The full display name of the referenced location */
  display: Scalars['String'];
  /** The lat/lng of the referenced location */
  geo?: Maybe<GeoPoint>;
  /** The longkey of the referenced location */
  longkey: Scalars['String'];
};

export type UpdateImpactAgentFeedbacksMutationVariables = Exact<{
  params: UpdateImpactAgentFeedbacksParams;
}>;


export type UpdateImpactAgentFeedbacksMutation = { updateImpactAgentFeedbacks: { success: boolean, error?: { code: string, message: string } | null } };

export type copyStreamMutationVariables = Exact<{
  params: CopyStreamParams;
}>;


export type copyStreamMutation = { copyStream: { success: boolean, error?: { code: string, message: string } | null, stream?: { _id: string } | { _id: string } | { _id: string } | { _id: string } | null } };

export type CreateAnalyticsSearchMutationVariables = Exact<{
  params: CreateAnalyticsSearchParams;
}>;


export type CreateAnalyticsSearchMutation = { createAnalyticsSearch: { success: boolean, analytics_search?: { gid: GID, location_name?: string | null, updated: string, search_params: { after?: string | null, asset_set_id?: string | null, before?: string | null, incident_types?: Array<string> | null, keywords: Array<string>, longkey?: string | null, severities?: Array<IncidentSeverity> | null, relative_timestamp?: { offset: RelativeTimestampOffset, timezone: TimeZone } | null, geo_filter?: { radius_km?: number | null, geometry: { type: GeoJSONType, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null } } | null } } | null, error?: { code: string, message: string } | null } };

export type CreateContactMutationVariables = Exact<{
  params: CreateContactParams;
}>;


export type CreateContactMutation = { createContact: { success: boolean, error?: { code: string, message: string } | null } };

export type CreateContactGroupMutationVariables = Exact<{
  params: CreateContactGroupParams;
}>;


export type CreateContactGroupMutation = { createContactGroup: { success: boolean, error?: { code: string, message: string } | null, contactGroup?: { gid: GID } | null } };

export type CreateDarkWebStreamMutationVariables = Exact<{
  params: CreateDarkWebStreamParams;
}>;


export type CreateDarkWebStreamMutation = { createDarkWebStream: { success: boolean, error?: { code: string, message: string } | null } };

export type createImpactAgentCorrectionFeedbackMutationVariables = Exact<{
  params: CreateImpactAgentCorrectionFeedbackParams;
}>;


export type createImpactAgentCorrectionFeedbackMutation = { createImpactAgentCorrectionFeedback: { success: boolean, error?: { code: string, message: string } | null } };

export type CreateWebAlertsStreamMutationVariables = Exact<{
  params: CreateWebAlertsStreamParams;
}>;


export type CreateWebAlertsStreamMutation = { createWebAlertsStream: { success: boolean, error?: { code: string, message: string } | null } };

export type DeleteContactMutationVariables = Exact<{
  params: DeleteContactParams;
}>;


export type DeleteContactMutation = { deleteContact: { success: boolean, error?: { code: string, message: string } | null } };

export type DeleteContactGroupMutationVariables = Exact<{
  params: DeleteContactGroupParams;
}>;


export type DeleteContactGroupMutation = { deleteContactGroup: { success: boolean, error?: { code: string, message: string } | null } };

export type DeleteStreamMutationVariables = Exact<{
  params: DeleteStreamParams;
}>;


export type DeleteStreamMutation = { deleteStream: { success: boolean, error?: { code: string, message: string } | null } };

export type EnableOutgoingWebhookMutationVariables = Exact<{
  params: EnableOutgoingWebhookParams;
}>;


export type EnableOutgoingWebhookMutation = { enableOutgoingWebhook: { success: boolean, error?: { code: string, message: string } | null } };

export type InitiateDownloadStatusMutationVariables = Exact<{
  params: InitiateDownloadStatusParams;
}>;


export type InitiateDownloadStatusMutation = { initiateDownloadStatus: { success: boolean, error?: { message: string, code: string } | null } };

export type listSalesforceIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type listSalesforceIntegrationsQuery = { listSalesforceIntegrations: Array<{ _id: string }> };

export type sendIncidentToSalesforceMutationVariables = Exact<{
  params: SendIncidentToSalesforceParams;
}>;


export type sendIncidentToSalesforceMutation = { sendIncidentToSalesforce: { success: boolean, error?: { code: string, message: string } | null } };

export type UpdateAnalyticsSearchMutationVariables = Exact<{
  params: UpdateAnalyticsSearchParams;
}>;


export type UpdateAnalyticsSearchMutation = { updateAnalyticsSearch: { success: boolean, error?: { code: string, message: string } | null } };

export type UpdateContactMutationVariables = Exact<{
  params: UpdateContactParams;
}>;


export type UpdateContactMutation = { updateContact: { success: boolean, error?: { code: string, message: string } | null } };

export type UpdateContactGroupMutationVariables = Exact<{
  params: UpdateContactGroupParams;
}>;


export type UpdateContactGroupMutation = { updateContactGroup: { success: boolean, error?: { code: string, message: string } | null } };

export type UpdateDarkWebStreamMutationVariables = Exact<{
  params: UpdateDarkWebStreamParams;
}>;


export type UpdateDarkWebStreamMutation = { updateDarkWebStream: { success: boolean, error?: { code: string, message: string } | null } };

export type UpdateImpactAgentFeedbackMutationVariables = Exact<{
  params: UpdateImpactAgentFeedbackParams;
}>;


export type UpdateImpactAgentFeedbackMutation = { updateImpactAgentFeedback: { success: boolean, error?: { code: string, message: string } | null } };

export type UpdateWebAlertsStreamMutationVariables = Exact<{
  params: UpdateWebAlertsStreamParams;
}>;


export type UpdateWebAlertsStreamMutation = { updateWebAlertsStream: { success: boolean, error?: { code: string, message: string } | null } };

export type CountImpactAgentFeedbacksQueryVariables = Exact<{
  params: ListImpactAgentFeedbacksParams;
}>;


export type CountImpactAgentFeedbacksQuery = { countImpactAgentFeedbacks: number };

export type GetContactGroupQueryVariables = Exact<{
  params: GetContactGroupParams;
}>;


export type GetContactGroupQuery = { getContactGroup?: { name: string } | null };

export type GetDarkWebPostQueryVariables = Exact<{
  params: GetDarkWebPostParams;
}>;


export type GetDarkWebPostQuery = { getDarkWebPost?: { _id: string, gid: GID, crawlDate: string, flattenedHeadline: string, snippets: { nodes: Array<{ text: string, truncatedEnd: boolean, truncatedStart: boolean, highlights: Array<{ end: number, start: number }> }> }, summary?: { text?: string | null } | null } | null };

export type getDownloadStatusQueryVariables = Exact<{
  params: GetDownloadStatusParams;
}>;


export type getDownloadStatusQuery = { getDownloadStatus?: { file_url?: string | null, status: DownloadStatusStatus, updated: string, download_errors: Array<{ message: string }>, progress: { percent: number } } | null };

export type GetImpactAgentQueryVariables = Exact<{
  params: GetImpactAgentParams;
}>;


export type GetImpactAgentQuery = { getImpactAgent?: { _id: string, name: string, agent_filter_prompt: string, categories: Array<{ value: number, description: string }> } | null };

export type getStreamApolloQueryVariables = Exact<{
  params: GetStreamParams;
}>;


export type getStreamApolloQuery = { newGetStream?: { __typename: 'DarkWebStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean } } } | { __typename: 'IncidentStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { severities: Array<IncidentSeverity>, asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }>, lucene_string?: { advanced: boolean, value: string } | null }, impact_agent_stream_configuration?: { impact_agent_id: string, match_config: { match_categories: Array<number> } } | null, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } } | { __typename: 'StandardStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, lucene_string?: { advanced: boolean, value: string } | null, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }> }, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } } | { __typename: 'WebAlertsStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { source_count: number, sources: Array<{ disabled: boolean, postAuthor: { name: string, description: string, permalink: string, avatarUrl: string } }>, lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, slack: { active: boolean, slack_webhook_id?: string | null } } } | null };

export type ListAnalyticsSearchesQueryVariables = Exact<{
  params: ListAnalyticsSearchesParams;
}>;


export type ListAnalyticsSearchesQuery = { listAnalyticsSearches?: Array<{ gid: GID, location_name?: string | null, updated: string, search_params: { after?: string | null, asset_set_id?: string | null, before?: string | null, incident_types?: Array<string> | null, keywords: Array<string>, longkey?: string | null, severities?: Array<IncidentSeverity> | null, relative_timestamp?: { offset: RelativeTimestampOffset, timezone: TimeZone } | null, geo_filter?: { radius_km?: number | null, geometry: { type: GeoJSONType, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null } } | null } }> | null };

export type contactGroupFieldsFragment = { gid: GID, name: string, contactCount: number, created: string, updated: string };

export type listContactGroupsQueryVariables = Exact<{
  params: ListContactGroupsParams;
}>;


export type listContactGroupsQuery = { listContactGroups: Array<{ gid: GID, name: string, contactCount: number, created: string, updated: string }> };

export type emailContactMethodsFragment = { gid: GID, name: string, contactMethods: Array<{ emailValue: EmailAddress } | {}> };

export type ListContactsQueryVariables = Exact<{
  params: ListContactsParams;
}>;


export type ListContactsQuery = { listContacts: Array<{ gid: GID, name: string, contactMethods: Array<{ emailValue: EmailAddress } | {}> }> };

export type ListImpactAgentFeedbacksQueryVariables = Exact<{
  params: ListImpactAgentFeedbacksParams;
}>;


export type ListImpactAgentFeedbacksQuery = { listImpactAgentFeedbacks: Array<{ _id: string, agent_assigned_category: number, author?: string | null, correct_category: number, feedback_text?: string | null, incident_title?: string | null, is_correction?: boolean | null, location?: string | null, submitting_analyst: string }> };

export type ListImpactAgentsQueryVariables = Exact<{
  params: ListImpactAgentsParams;
}>;


export type ListImpactAgentsQuery = { listImpactAgents: Array<{ _id: string, name: string, agent_filter_prompt: string, categories: Array<{ value: number, description: string }> }> };

export type proximityAssetForMapFieldsFragment = { _id: string, gid: GID, asset_type: ProximityAssetType, name: string, start_date?: string | null, end_date?: string | null, geometry: { point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, line_string?: Array<GeoJSONLngLat> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null };

export type listProximityAssetsForMapQueryVariables = Exact<{
  params: ListProximityAssetsParams;
}>;


export type listProximityAssetsForMapQuery = { listProximityAssets: Array<{ _id: string, gid: GID, asset_type: ProximityAssetType, name: string, start_date?: string | null, end_date?: string | null, geometry: { point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, line_string?: Array<GeoJSONLngLat> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null }> };

export type listStreamsApolloQueryVariables = Exact<{
  params: ListStreamsParams;
}>;


export type listStreamsApolloQuery = { newListStreams: Array<{ __typename: 'DarkWebStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean } } } | { __typename: 'IncidentStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { severities: Array<IncidentSeverity>, asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }>, lucene_string?: { advanced: boolean, value: string } | null }, impact_agent_stream_configuration?: { impact_agent_id: string, match_config: { match_categories: Array<number> } } | null, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } } | { __typename: 'StandardStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, lucene_string?: { advanced: boolean, value: string } | null, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }> }, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } } | { __typename: 'WebAlertsStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, transferred_date?: string | null, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { source_count: number, sources: Array<{ disabled: boolean, postAuthor: { name: string, description: string, permalink: string, avatarUrl: string } }>, lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, slack: { active: boolean, slack_webhook_id?: string | null } } }> };

export type nearbyAssetCountQueryVariables = Exact<{
  params: GetIncidentCountsParams;
}>;


export type nearbyAssetCountQuery = { getIncidentCounts: { nearby_asset_count: number } };

export type accountFieldsFragment = { _id: string, active: boolean, gid: GID, logo?: string | null, name: string, status: AccountStatus, api_keys: Array<{ _id: string, active: boolean, created: string, gid: GID, name: string, value: string }>, flags: Array<{ key: string, value: string }>, password_policy: { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean }, preferences: { authentic8: boolean, password_authentication: boolean, saml_authentication: boolean, two_factor_authentication: boolean }, settings: { authentic8: boolean, allow_webhooks: boolean, api_access: boolean, eb_integration: boolean, everbridge_v2: boolean, is_sam: boolean, copy_stream: boolean, csv_asset_upload: boolean, max_asset_sets: number, ms_teams: boolean, resolver: boolean, samalytics: boolean, samalytics_tab: boolean, sammerizer: boolean, saml: boolean, shared_streams: boolean, show_proximity: boolean, travel_integration: boolean, max_contact_group_contacts: number, max_contact_groups: number, max_web_alert_streams: number, max_asset_set_locations: number, max_search_streams: number, max_dark_web_streams: number, max_dashboard_columns_tabs: number, max_samalytics_exportable_incidents: number } };

export type accountPasswordPolicyFieldsFragment = { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean };

type alertFields_DarkWebAlert_Fragment = { __typename: 'DarkWebAlert', _id: string, created: string, updated: string, read: boolean, stream_id: string, post: { _id: string, gid: GID, crawlDate: string, flattenedHeadline: string, snippets: { nodes: Array<{ text: string, truncatedEnd: boolean, truncatedStart: boolean, highlights: Array<{ end: number, start: number }> }> }, summary?: { text?: string | null } | null } };

type alertFields_IncidentAlert_Fragment = { __typename: 'IncidentAlert', _id: string, read: boolean, incident_gid: GID, incident_id: string, created: string, stream_id: string, closest_proximity?: { name: string, distance: number } | null, proximity_matches: Array<{ asset_id: string }>, recent_headlines: Array<{ date: string, text: string }>, incident_update?: { completed_date?: string | null, detected_date?: string | null, isPrivate: boolean, new: { headline: string, headline_source?: string | null, polygons: Array<string>, severity: IncidentSeverity, types: Array<string>, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> }, rtc_update?: { text: string } | null } | null };

type alertFields_WebAlert_Fragment = { __typename: 'WebAlert', _id: string, created: string, updated: string, read: boolean, stream_id: string, post: { _id: string, gid: GID, text: string, permalink: string, author: { id: string, handle: string, avatar_url: string, name: string, description: string, permalink: string } } };

export type alertFieldsFragment = alertFields_DarkWebAlert_Fragment | alertFields_IncidentAlert_Fragment | alertFields_WebAlert_Fragment;

export type apiKeyFieldsFragment = { _id: string, active: boolean, created: string, gid: GID, name: string, value: string };

export type assetContactFieldsFragment = { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } };

export type assetSetContactFieldsFragment = { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } };

type contactMethodWithAssetFields_AssetContact_Fragment = { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } };

type contactMethodWithAssetFields_AssetSetContact_Fragment = { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } };

type contactMethodWithAssetFields_EmailContact_Fragment = { __typename: 'EmailContact', emailValue: EmailAddress };

type contactMethodWithAssetFields_NearbyAssetsContact_Fragment = { __typename: 'NearbyAssetsContact' };

type contactMethodWithAssetFields_PhoneContact_Fragment = { __typename: 'PhoneContact', phoneValue: PhoneNumber };

type contactMethodWithAssetFields_SlackContact_Fragment = { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string };

type contactMethodWithAssetFields_UserContact_Fragment = { __typename: 'UserContact', userValue: string };

export type contactMethodWithAssetFieldsFragment = contactMethodWithAssetFields_AssetContact_Fragment | contactMethodWithAssetFields_AssetSetContact_Fragment | contactMethodWithAssetFields_EmailContact_Fragment | contactMethodWithAssetFields_NearbyAssetsContact_Fragment | contactMethodWithAssetFields_PhoneContact_Fragment | contactMethodWithAssetFields_SlackContact_Fragment | contactMethodWithAssetFields_UserContact_Fragment;

type contactMethodsWithoutAssetFields_AssetContact_Fragment = { __typename: 'AssetContact' };

type contactMethodsWithoutAssetFields_AssetSetContact_Fragment = { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } };

type contactMethodsWithoutAssetFields_EmailContact_Fragment = { __typename: 'EmailContact', emailValue: EmailAddress };

type contactMethodsWithoutAssetFields_NearbyAssetsContact_Fragment = { __typename: 'NearbyAssetsContact' };

type contactMethodsWithoutAssetFields_PhoneContact_Fragment = { __typename: 'PhoneContact', phoneValue: PhoneNumber };

type contactMethodsWithoutAssetFields_SlackContact_Fragment = { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string };

type contactMethodsWithoutAssetFields_UserContact_Fragment = { __typename: 'UserContact', userValue: string };

export type contactMethodsWithoutAssetFieldsFragment = contactMethodsWithoutAssetFields_AssetContact_Fragment | contactMethodsWithoutAssetFields_AssetSetContact_Fragment | contactMethodsWithoutAssetFields_EmailContact_Fragment | contactMethodsWithoutAssetFields_NearbyAssetsContact_Fragment | contactMethodsWithoutAssetFields_PhoneContact_Fragment | contactMethodsWithoutAssetFields_SlackContact_Fragment | contactMethodsWithoutAssetFields_UserContact_Fragment;

export type darkWebAlertFieldsFragment = { __typename: 'DarkWebAlert', _id: string, created: string, updated: string, read: boolean, stream_id: string, post: { _id: string, gid: GID, crawlDate: string, flattenedHeadline: string, snippets: { nodes: Array<{ text: string, truncatedEnd: boolean, truncatedStart: boolean, highlights: Array<{ end: number, start: number }> }> }, summary?: { text?: string | null } | null } };

export type darkWebPostFieldsFragment = { _id: string, gid: GID, crawlDate: string, flattenedHeadline: string, snippets: { nodes: Array<{ text: string, truncatedEnd: boolean, truncatedStart: boolean, highlights: Array<{ end: number, start: number }> }> }, summary?: { text?: string | null } | null };

export type darkWebStreamFieldsFragment = { __typename: 'DarkWebStream', criterion: { lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean } } };

export type emailContactFieldsFragment = { __typename: 'EmailContact', emailValue: EmailAddress };

export type geometryFieldsFragment = { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType };

export type heatmapPointFieldsFragment = { count: number, lat: number, lng: number };

export type impactAgentFeedbackFieldsFragment = { _id: string, agent_assigned_category: number, author?: string | null, correct_category: number, feedback_text?: string | null, incident_title?: string | null, is_correction?: boolean | null, location?: string | null, submitting_analyst: string };

export type impactAgentFieldsFragment = { _id: string, name: string, agent_filter_prompt: string, categories: Array<{ value: number, description: string }> };

export type incidentAlertFieldsFragment = { __typename: 'IncidentAlert', _id: string, read: boolean, incident_gid: GID, incident_id: string, created: string, stream_id: string, closest_proximity?: { name: string, distance: number } | null, proximity_matches: Array<{ asset_id: string }>, recent_headlines: Array<{ date: string, text: string }>, incident_update?: { completed_date?: string | null, detected_date?: string | null, isPrivate: boolean, new: { headline: string, headline_source?: string | null, polygons: Array<string>, severity: IncidentSeverity, types: Array<string>, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> }, rtc_update?: { text: string } | null } | null };

export type incidentFieldsFragment = { _id: string, gid: GID, detected_date?: string | null, polygons: Array<string>, severity: IncidentSeverity, total_posts: number, types: Array<string>, has_featured_content: boolean, status: IncidentStatus, timezone: Array<string>, private: boolean, headline: { source?: string | null, text?: string | null }, incident_response?: { gid: GID } | null, impact?: { reason: string, type: string } | null, impact_agent?: { category: number, impact_agent_id: string } | null, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ _id?: string | null, compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> };

type incidentResponseActionFields_IncidentResponseActionAcknowledged_Fragment = { __typename: 'IncidentResponseActionAcknowledged', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotificationCompleted_Fragment = { __typename: 'IncidentResponseActionNotificationCompleted', gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotificationProcessed_Fragment = { __typename: 'IncidentResponseActionNotificationProcessed', gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotificationQueued_Fragment = { __typename: 'IncidentResponseActionNotificationQueued', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotified_Fragment = { __typename: 'IncidentResponseActionNotified', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotifiedResponded_Fragment = { __typename: 'IncidentResponseActionNotifiedResponded', createdAt: string, gid: GID, status: IncidentResponseNotificationStatus, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotifiedViewed_Fragment = { __typename: 'IncidentResponseActionNotifiedViewed', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionNotifyInitiated_Fragment = { __typename: 'IncidentResponseActionNotifyInitiated', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

type incidentResponseActionFields_IncidentResponseActionResolved_Fragment = { __typename: 'IncidentResponseActionResolved', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } };

export type incidentResponseActionFieldsFragment = incidentResponseActionFields_IncidentResponseActionAcknowledged_Fragment | incidentResponseActionFields_IncidentResponseActionNotificationCompleted_Fragment | incidentResponseActionFields_IncidentResponseActionNotificationProcessed_Fragment | incidentResponseActionFields_IncidentResponseActionNotificationQueued_Fragment | incidentResponseActionFields_IncidentResponseActionNotified_Fragment | incidentResponseActionFields_IncidentResponseActionNotifiedResponded_Fragment | incidentResponseActionFields_IncidentResponseActionNotifiedViewed_Fragment | incidentResponseActionFields_IncidentResponseActionNotifyInitiated_Fragment | incidentResponseActionFields_IncidentResponseActionResolved_Fragment;

export type incidentResponseFieldsFragment = { gid: GID, acknowledgedAt?: string | null, resolvedAt?: string | null, actions: { nodes: Array<{ __typename: 'IncidentResponseActionAcknowledged', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotificationCompleted', gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotificationProcessed', gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotificationQueued', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotified', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotifiedResponded', createdAt: string, gid: GID, status: IncidentResponseNotificationStatus, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotifiedViewed', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionNotifyInitiated', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } } | { __typename: 'IncidentResponseActionResolved', createdAt: string, gid: GID, newCreatedBy: { __typename: 'AssetContact', asset: { _id: string, gid: GID, name: string, asset_type: ProximityAssetType, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }> } } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string } }> }, incident?: { _id: string, headline: { text?: string | null } } | null };

export type incidentStreamFieldsFragment = { __typename: 'IncidentStream', criterion: { severities: Array<IncidentSeverity>, asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }>, lucene_string?: { advanced: boolean, value: string } | null }, impact_agent_stream_configuration?: { impact_agent_id: string, match_config: { match_categories: Array<number> } } | null, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } };

export type incidentTypeFieldsFragment = { category: string, category_name: string, name: string, type: string };

export type languageFieldsFragment = { key: string, name: string };

export type localAccountFieldsFragment = { concepts: Array<string>, name: string, alt_names: Array<{ type: string, value: string }> };

export type msTeamsWebhookFieldsFragment = { _id: string, account_id: string, name: string, url: string, created: string, updated: string, user_id: string, disabled: boolean };

export type nearbyAssetsContactFieldsFragment = { __typename: 'NearbyAssetsContact' };

export type nearbyAssetsFieldsFragment = { nearby_assets: Array<{ distance: number, is_exact: boolean, asset: { _id: string, gid: GID, asset_type: ProximityAssetType, lat: number, lng: number, name: string, start_date?: string | null, end_date?: string | null, timezone?: TimeZone | null, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }>, geometry: { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null, travel_facility?: { name: string, type: string } | null } }> };

export type outgoingWebhookFieldsFragment = { _id: string, account_id: string, disabled: boolean, failure_count: number, name: string, url: string, created: string, updated: string, user_id: string, last_failure?: { code: string, date: string } | null, headers?: Array<{ key: string, value: string }> | null };

export type partialAccountFieldsFragment = { _id: string, gid: GID, name: string, index: number, active: boolean, mfaRequired: boolean, userId: string };

export type personFieldsFragment = { name: string, email: string, timezone?: TimeZone | null, mfaAuthenticated: boolean, partialAccounts: Array<{ _id: string, gid: GID, name: string, index: number, active: boolean, mfaRequired: boolean, userId: string }> };

export type phoneContactFieldsFragment = { __typename: 'PhoneContact', phoneValue: PhoneNumber };

export type privateIncidentFieldsFragment = { _id: string, detected_date?: string | null, headline: { text?: string | null }, wheres: Array<{ display: string }> };

export type proximityAssetFieldsFragment = { _id: string, gid: GID, asset_type: ProximityAssetType, lat: number, lng: number, name: string, start_date?: string | null, end_date?: string | null, timezone?: TimeZone | null, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }>, geometry: { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null, travel_facility?: { name: string, type: string } | null };

export type proximityAssetSetFieldsFragment = { _id: string, gid: GID, account_id: string, asset_count: number, created: string, name: string, proximity: number, updated: string, uses_hours?: boolean | null };

export type publicIncidentResponseNotificationFieldsFragment = { gid: GID, lastStatus: IncidentResponseNotificationStatus, incident: { _id: string, gid: GID, detected_date?: string | null, types: Array<string>, severity: IncidentSeverity, headline: { source?: string | null, text?: string | null }, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ _id?: string | null, compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> } };

export type resolverWebhookFieldsFragment = { _id: string, account_id: string, name: string, url: string, created: string, updated: string, user_id: string, disabled: boolean, headers?: Array<{ key: string, value: string }> | null };

export type searchIncidentAnalyticsTableItemFieldsFragment = { incident_id: string, date: string, types: Array<string>, locations: Array<string>, severity: IncidentSeverity };

export type slackContactFieldsFragment = { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string };

export type slackWebhookFieldsFragment = { _id: string, account_id: string, user_id: string, team_name: string, channel_name: string, configuration_url: string, disabled: boolean, created: string, updated: string };

export type slackWorkspaceFieldsFragment = { _id: string, created: string, disabled: boolean, gid: GID, name: string };

export type standardStreamFieldsFragment = { __typename: 'StandardStream', criterion: { asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, lucene_string?: { advanced: boolean, value: string } | null, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }> }, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } };

type streamFields_DarkWebStream_Fragment = { __typename: 'DarkWebStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean } } };

type streamFields_IncidentStream_Fragment = { __typename: 'IncidentStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { severities: Array<IncidentSeverity>, asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }>, lucene_string?: { advanced: boolean, value: string } | null }, impact_agent_stream_configuration?: { impact_agent_id: string, match_config: { match_categories: Array<number> } } | null, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } };

type streamFields_StandardStream_Fragment = { __typename: 'StandardStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, lucene_string?: { advanced: boolean, value: string } | null, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }> }, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } };

type streamFields_WebAlertsStream_Fragment = { __typename: 'WebAlertsStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { source_count: number, sources: Array<{ disabled: boolean, postAuthor: { name: string, description: string, permalink: string, avatarUrl: string } }>, lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, slack: { active: boolean, slack_webhook_id?: string | null } } };

export type streamFieldsFragment = streamFields_DarkWebStream_Fragment | streamFields_IncidentStream_Fragment | streamFields_StandardStream_Fragment | streamFields_WebAlertsStream_Fragment;

export type uploadStatusFieldsFragment = { gid: GID, file_name?: string | null, status: UploadStatusStatus, target_gid: GID, purpose: UploadStatusPurpose, created: string, progress: { percent: number, count: number, total: number }, errors: Array<{ message: string }> };

export type userContactFieldsFragment = { __typename: 'UserContact', userValue: string };

export type userFieldsFragment = { _id: string, gid: GID, index: number, created: string, role: UserAccountRole, person: { _id: string, name: string, email: string, timezone?: TimeZone | null }, client_settings: Array<{ key: string, value: string }>, preferences: { disabled_translations: Array<string>, distance_unit: DisplayUnit, notification_sound: string, temperature_unit: DisplayUnit }, account: { _id: string, active: boolean, gid: GID, logo?: string | null, name: string, status: AccountStatus, api_keys: Array<{ _id: string, active: boolean, created: string, gid: GID, name: string, value: string }>, flags: Array<{ key: string, value: string }>, password_policy: { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean }, preferences: { authentic8: boolean, password_authentication: boolean, saml_authentication: boolean, two_factor_authentication: boolean }, settings: { authentic8: boolean, allow_webhooks: boolean, api_access: boolean, eb_integration: boolean, everbridge_v2: boolean, is_sam: boolean, copy_stream: boolean, csv_asset_upload: boolean, max_asset_sets: number, ms_teams: boolean, resolver: boolean, samalytics: boolean, samalytics_tab: boolean, sammerizer: boolean, saml: boolean, shared_streams: boolean, show_proximity: boolean, travel_integration: boolean, max_contact_group_contacts: number, max_contact_groups: number, max_web_alert_streams: number, max_asset_set_locations: number, max_search_streams: number, max_dark_web_streams: number, max_dashboard_columns_tabs: number, max_samalytics_exportable_incidents: number } }, intercom: { user_hash: string }, settings: { max_search_streams: number, max_web_alert_stream_sources: number } };

export type webAlertFieldsFragment = { __typename: 'WebAlert', _id: string, created: string, updated: string, read: boolean, stream_id: string, post: { _id: string, gid: GID, text: string, permalink: string, author: { id: string, handle: string, avatar_url: string, name: string, description: string, permalink: string } } };

export type webAlertsStreamFieldsFragment = { __typename: 'WebAlertsStream', criterion: { source_count: number, sources: Array<{ disabled: boolean, postAuthor: { name: string, description: string, permalink: string, avatarUrl: string } }>, lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, slack: { active: boolean, slack_webhook_id?: string | null } } };

export type uploadCompleteMutationVariables = Exact<{
  params: UploadCompleteParams;
}>;


export type uploadCompleteMutation = { uploadComplete: { success: boolean, error?: { code: string, message: string } | null, upload_status?: { gid: GID, file_name?: string | null, status: UploadStatusStatus, target_gid: GID, purpose: UploadStatusPurpose, created: string, progress: { percent: number, count: number, total: number }, errors: Array<{ message: string }> } | null } };

export type uploadCreateMutationVariables = Exact<{
  params: UploadCreateParams;
}>;


export type uploadCreateMutation = { uploadCreate: { success: boolean, s3_data?: { url: string, fields: Array<{ key: string, value: string }> } | null, upload_status?: { gid: GID, file_name?: string | null, status: UploadStatusStatus, target_gid: GID, purpose: UploadStatusPurpose, created: string, progress: { percent: number, count: number, total: number }, errors: Array<{ message: string }> } | null, error?: { code: string, message: string } | null } };

export type cancelChangeEmailRequestMutationVariables = Exact<{
  params: CancelChangeEmailRequestParams;
}>;


export type cancelChangeEmailRequestMutation = { cancelChangeEmailRequest: { success: boolean, error?: { code: string, message: string } | null } };

export type createAPIKeyMutationVariables = Exact<{
  params: CreateAPIKeyParams;
}>;


export type createAPIKeyMutation = { createAPIKey: { success: boolean, error?: { code: string, message: string } | null } };

export type createChangeEmailRequestMutationVariables = Exact<{
  params: CreateChangeEmailRequestParams;
}>;


export type createChangeEmailRequestMutation = { createChangeEmailRequest: { success: boolean, error?: { code: string, message: string } | null } };

export type createDashboardTabMutationVariables = Exact<{
  params: CreateDashboardTabParams;
}>;


export type createDashboardTabMutation = { createDashboardTab: { success: boolean, error?: { code: string, message: string } | null, tab?: { __typename: 'AlertsTab', key: string, type: DashboardTabType } | { __typename: 'BaseDashboardTab', key: string, type: DashboardTabType } | { __typename: 'ColumnsTab', key: string, type: DashboardTabType, columns_tab_data: { name: string } } | { __typename: 'DarkWebTab', key: string, type: DashboardTabType, dark_web_tab_data: { dark_web_post_id: string } } | { __typename: 'HistoricalSearchTab', key: string, type: DashboardTabType } | { __typename: 'IncidentTab', key: string, type: DashboardTabType, incident_tab_data: { incident_id: string } } | { __typename: 'SettingsTab', key: string, type: DashboardTabType } | { __typename: 'StreamManagerTab', key: string, type: DashboardTabType } | null } };

export type createEverbridgeIntegrationMutationVariables = Exact<{
  params: CreateEverbridgeIntegrationParams;
}>;


export type createEverbridgeIntegrationMutation = { createEverbridgeIntegration: { success: boolean, error?: { code: string, message: string } | null } };

export type createIncidentFlagMutationVariables = Exact<{
  params: CreateIncidentFlagParams;
}>;


export type createIncidentFlagMutation = { createIncidentFlag: { success: boolean, error?: { code: string, message: string } | null } };

export type createMFACodeMutationVariables = Exact<{ [key: string]: never; }>;


export type createMFACodeMutation = { createMFACode: { success: boolean, error?: { code: string, message: string } | null } };

export type createMsTeamsWebhookMutationVariables = Exact<{
  params: CreateMsTeamsWebhookParams;
}>;


export type createMsTeamsWebhookMutation = { createMsTeamsWebhook: { success: boolean, ms_teams_webhook?: { _id: string, account_id: string, url: string, name: string, created: string, updated: string, user_id: string, disabled: boolean } | null, error?: { code: string, message: string } | null } };

export type createOutgoingWebhookMutationVariables = Exact<{
  params: CreateOutgoingWebhookParams;
}>;


export type createOutgoingWebhookMutation = { createOutgoingWebhook: { success: boolean, outgoing_webhook?: { _id: string, account_id: string, disabled: boolean, url: string, created: string, updated: string, user_id: string, name: string, headers?: Array<{ key: string, value: string }> | null } | null, error?: { code: string, message: string } | null } };

export type createProximityAssetSetMutationVariables = Exact<{
  params: CreateProximityAssetSetParams;
}>;


export type createProximityAssetSetMutation = { createProximityAssetSet: { success: boolean, error?: { code: string, message: string } | null, asset_set?: { _id: string } | null } };

export type createProximityAssetsMutationVariables = Exact<{
  params: CreateProximityAssetsParams;
}>;


export type createProximityAssetsMutation = { createProximityAssets: { success: boolean, error?: { code: string, message: string } | null, assets?: Array<{ asset_set_id: string, _id: string, gid: GID, asset_type: ProximityAssetType, lat: number, lng: number, name: string, start_date?: string | null, end_date?: string | null, timezone?: TimeZone | null, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }>, geometry: { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null, travel_facility?: { name: string, type: string } | null }> | null } };

export type CreateRegionBriefMutationVariables = Exact<{
  params: CreateRegionBriefParams;
}>;


export type CreateRegionBriefMutation = { createRegionBrief: { success: boolean, error?: { code: string, message: string } | null } };

export type createResetPasswordRequestMutationVariables = Exact<{
  params: CreateResetPasswordRequestParams;
}>;


export type createResetPasswordRequestMutation = { createResetPasswordRequest: { success: boolean, error?: { code: string, message: string } | null } };

export type createResolverWebhookMutationVariables = Exact<{
  params: CreateResolverWebhookParams;
}>;


export type createResolverWebhookMutation = { createResolverWebhook: { success: boolean, resolver_webhook?: { _id: string, account_id: string, url: string, name: string, created: string, updated: string, user_id: string, disabled: boolean, headers?: Array<{ key: string, value: string }> | null } | null, error?: { code: string, message: string } | null } };

export type deleteAPIKeyMutationVariables = Exact<{
  params: DeleteAPIKeyParams;
}>;


export type deleteAPIKeyMutation = { deleteAPIKey: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteAccountMemberMutationVariables = Exact<{
  params: DeleteAccountMemberParams;
}>;


export type deleteAccountMemberMutation = { deleteAccountMember: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteDashboardTabMutationVariables = Exact<{
  params: DeleteDashboardTabParams;
}>;


export type deleteDashboardTabMutation = { deleteDashboardTab: { success: boolean, error?: { code: string, message: string } | null, tab?: { __typename: 'AlertsTab', type: DashboardTabType } | { __typename: 'BaseDashboardTab', type: DashboardTabType } | { __typename: 'ColumnsTab', type: DashboardTabType } | { __typename: 'DarkWebTab', type: DashboardTabType } | { __typename: 'HistoricalSearchTab', type: DashboardTabType } | { __typename: 'IncidentTab', type: DashboardTabType, incident_tab_data: { incident_id: string } } | { __typename: 'SettingsTab', type: DashboardTabType } | { __typename: 'StreamManagerTab', type: DashboardTabType } | null } };

export type deleteEverbridgeIntegrationMutationVariables = Exact<{
  params: DeleteEverbridgeIntegrationParams;
}>;


export type deleteEverbridgeIntegrationMutation = { deleteEverbridgeIntegration: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteMsTeamsWebhookMutationVariables = Exact<{
  params: DeleteMsTeamsWebhookParams;
}>;


export type deleteMsTeamsWebhookMutation = { deleteMsTeamsWebhook: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteOutgoingWebhookMutationVariables = Exact<{
  params: DeleteOutgoingWebhookParams;
}>;


export type deleteOutgoingWebhookMutation = { deleteOutgoingWebhook: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteProximityAssetSetMutationVariables = Exact<{
  params: DeleteProximityAssetSetParams;
}>;


export type deleteProximityAssetSetMutation = { deleteProximityAssetSet: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteProximityAssetsMutationVariables = Exact<{
  params: DeleteProximityAssetsParams;
}>;


export type deleteProximityAssetsMutation = { deleteProximityAssets: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteResolverWebhookMutationVariables = Exact<{
  params: DeleteResolverWebhookParams;
}>;


export type deleteResolverWebhookMutation = { deleteResolverWebhook: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteSlackWebhookMutationVariables = Exact<{
  params: DeleteSlackWebhookParams;
}>;


export type deleteSlackWebhookMutation = { deleteSlackWebhook: { success: boolean, error?: { code: string, message: string } | null } };

export type deleteSlackWorkspaceMutationVariables = Exact<{
  params: DeleteSlackWorkspaceParams;
}>;


export type deleteSlackWorkspaceMutation = { deleteSlackWorkspace: { success: boolean, error?: { code: string, message: string } | null } };

export type logIncidentInteractionMutationVariables = Exact<{
  params: LogIncidentInteractionParams;
}>;


export type logIncidentInteractionMutation = { logIncidentInteraction: { success: boolean, error?: { code: string, message: string } | null } };

export type markEmailTrackerClickedMutationVariables = Exact<{
  params: MarkEmailTrackerClickedParams;
}>;


export type markEmailTrackerClickedMutation = { markEmailTrackerClicked: { success: boolean, error?: { code: string, message: string } | null, deep_link_data?: { source: string, alert_type: string, stream_id?: string | null } | null } };

export type MarkReadMutationVariables = Exact<{
  params: MarkReadParams;
}>;


export type MarkReadMutation = { markRead: { success: boolean, error?: { code: string, message: string } | null } };

export type resendAccountInvitationMutationVariables = Exact<{
  params: ResendAccountInvitationParams;
}>;


export type resendAccountInvitationMutation = { resendAccountInvitation: { success: boolean, error?: { code: string, message: string } | null } };

export type RespondPublicIncidentResponseNotificationByUUIDParamsMutationVariables = Exact<{
  params: RespondPublicIncidentResponseNotificationByUUIDParams;
}>;


export type RespondPublicIncidentResponseNotificationByUUIDParamsMutation = { respondPublicIncidentResponseNotificationByUUID: { success: boolean, error?: { code: string, message: string } | null } };

export type sendAccountInvitationMutationVariables = Exact<{
  params: SendAccountInvitationParams;
}>;


export type sendAccountInvitationMutation = { sendAccountInvitation: { success: boolean, error?: { code: string, message: string } | null } };

export type sendAccountInvitationsMutationVariables = Exact<{
  params: SendAccountInvitationsParams;
}>;


export type sendAccountInvitationsMutation = { sendAccountInvitations: { success: boolean, error?: { code: string, message: string } | null } };

export type sendIncidentToResolverMutationVariables = Exact<{
  params: SendIncidentToResolverParams;
}>;


export type sendIncidentToResolverMutation = { sendIncidentToResolver: { success: boolean, error?: { code: string, message: string } | null } };

export type shareIncidentMutationVariables = Exact<{
  params: ShareIncidentParams;
}>;


export type shareIncidentMutation = { shareIncident: { success: boolean, error?: { code: string, message: string } | null } };

export type signinMutationVariables = Exact<{
  params: SigninParams;
}>;


export type signinMutation = { signin: { success: boolean, person?: { name: string, email: string, timezone?: TimeZone | null, mfaAuthenticated: boolean, partialAccounts: Array<{ _id: string, gid: GID, name: string, index: number, active: boolean, mfaRequired: boolean, userId: string }> } | null, error?: { code: string, message: string } | null } };

export type signoutMutationVariables = Exact<{ [key: string]: never; }>;


export type signoutMutation = { signout: { success: boolean, error?: { code: string, message: string } | null } };

export type signupMutationVariables = Exact<{
  params: SignupParams;
}>;


export type signupMutation = { signup: { success: boolean, error?: { code: string, message: string } | null } };

export type submitChangeEmailRequestMutationVariables = Exact<{
  params: SubmitChangeEmailRequestParams;
}>;


export type submitChangeEmailRequestMutation = { submitChangeEmailRequest: { success: boolean, error?: { code: string, message: string } | null } };

export type submitMFACodeMutationVariables = Exact<{
  params: SubmitMFACodeParams;
}>;


export type submitMFACodeMutation = { submitMFACode: { success: boolean, error?: { code: string, message: string } | null } };

export type submitResetPasswordRequestMutationVariables = Exact<{
  params: SubmitResetPasswordRequestParams;
}>;


export type submitResetPasswordRequestMutation = { submitResetPasswordRequest: { success: boolean, error?: { code: string, message: string } | null } };

export type updateAPIKeyMutationVariables = Exact<{
  params: UpdateAPIKeyParams;
}>;


export type updateAPIKeyMutation = { updateAPIKey: { success: boolean, error?: { code: string, message: string } | null } };

export type updateAccountMutationVariables = Exact<{
  params: UpdateAccountParams;
}>;


export type updateAccountMutation = { updateAccount: { success: boolean, error?: { code: string, message: string } | null } };

export type updateAccountMemberMutationVariables = Exact<{
  params: UpdateAccountMemberParams;
}>;


export type updateAccountMemberMutation = { updateAccountMember: { success: boolean, error?: { code: string, message: string } | null } };

export type updateDashboardTabMutationVariables = Exact<{
  params: UpdateDashboardTabParams;
}>;


export type updateDashboardTabMutation = { updateDashboardTab: { success: boolean, error?: { code: string, message: string } | null, tab?: { __typename: 'AlertsTab', alerts_tab_data: { name: string, bottom: Array<{ stream_id: string }>, top: Array<{ stream_id: string }> } } | { __typename: 'BaseDashboardTab' } | { __typename: 'ColumnsTab' } | { __typename: 'DarkWebTab' } | { __typename: 'HistoricalSearchTab' } | { __typename: 'IncidentTab' } | { __typename: 'SettingsTab' } | { __typename: 'StreamManagerTab' } | null } };

export type updateEverbridgeIntegrationMutationVariables = Exact<{
  params: UpdateEverbridgeIntegrationParams;
}>;


export type updateEverbridgeIntegrationMutation = { updateEverbridgeIntegration: { success: boolean, error?: { code: string, message: string } | null, everbridge_integration?: { _id: string } | null } };

export type updatePersonMutationVariables = Exact<{
  params: UpdatePersonParams;
}>;


export type updatePersonMutation = { updatePerson: { success: boolean, error?: { code: string, message: string } | null } };

export type updateProximityAssetMutationVariables = Exact<{
  params: UpdateProximityAssetParams;
}>;


export type updateProximityAssetMutation = { updateProximityAsset: { success: boolean, error?: { code: string, message: string } | null, asset?: { _id: string, gid: GID, asset_type: ProximityAssetType, lat: number, lng: number, name: string, start_date?: string | null, end_date?: string | null, timezone?: TimeZone | null, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }>, geometry: { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null, travel_facility?: { name: string, type: string } | null } | null } };

export type updateProximityAssetSetMutationVariables = Exact<{
  params: UpdateProximityAssetSetParams;
}>;


export type updateProximityAssetSetMutation = { updateProximityAssetSet: { success: boolean, error?: { code: string, message: string } | null, asset_set?: { _id: string } | null } };

export type updateUserPreferencesMutationVariables = Exact<{
  params: UpdateUserPreferencesParams;
}>;


export type updateUserPreferencesMutation = { updateUserPreferences: { success: boolean, error?: { code: string, message: string } | null } };

export type upsertSAMLConfigurationMutationVariables = Exact<{
  params: UpsertSAMLConfigurationParams;
}>;


export type upsertSAMLConfigurationMutation = { upsertSAMLConfiguration: { success: boolean, error?: { code: string, message: string } | null } };

export type GetPostAuthorByUrlQueryVariables = Exact<{
  params: GetPostAuthorByUrlParams;
}>;


export type GetPostAuthorByUrlQuery = { getPostAuthorByUrl?: { postAuthor?: { name: string, description: string, permalink: string, avatarUrl: string } | null, error?: { message: string } | null } | null };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { getAccount?: { _id: string, active: boolean, gid: GID, logo?: string | null, name: string, status: AccountStatus, api_keys: Array<{ _id: string, active: boolean, created: string, gid: GID, name: string, value: string }>, flags: Array<{ key: string, value: string }>, password_policy: { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean }, preferences: { authentic8: boolean, password_authentication: boolean, saml_authentication: boolean, two_factor_authentication: boolean }, settings: { authentic8: boolean, allow_webhooks: boolean, api_access: boolean, eb_integration: boolean, everbridge_v2: boolean, is_sam: boolean, copy_stream: boolean, csv_asset_upload: boolean, max_asset_sets: number, ms_teams: boolean, resolver: boolean, samalytics: boolean, samalytics_tab: boolean, sammerizer: boolean, saml: boolean, shared_streams: boolean, show_proximity: boolean, travel_integration: boolean, max_contact_group_contacts: number, max_contact_groups: number, max_web_alert_streams: number, max_asset_set_locations: number, max_search_streams: number, max_dark_web_streams: number, max_dashboard_columns_tabs: number, max_samalytics_exportable_incidents: number } } | null };

export type getAccountInvitationQueryVariables = Exact<{
  params: GetAccountInvitationParams;
}>;


export type getAccountInvitationQuery = { getAccountInvitation: { personName?: string | null, accountName?: string | null, samlIssuer?: string | null, passwordPolicy?: { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean } | null, pending_user_account?: { email: string } | null } };

export type getDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type getDashboardQuery = { getDashboard: { tabs: Array<{ __typename: 'AlertsTab', key: string, alerts_tab_data: { name: string, map_width: number, pane_height: number, bottom: Array<{ stream_id: string }>, bottom_sound: { enabled: boolean, name: string }, selected_asset_sets: Array<{ asset_set_id: string, include: boolean }>, top: Array<{ stream_id: string }>, top_sound: { enabled: boolean, name: string } } } | { __typename: 'BaseDashboardTab', key: string } | { __typename: 'ColumnsTab', key: string, columns_tab_data: { name: string, columns: Array<{ _id: string, panes: Array<{ key: string, name?: string | null, streamIds: Array<string>, timeWindowSeconds: number, unreadOnly: boolean, sound: { name: string, enabled: boolean } }> }> } } | { __typename: 'DarkWebTab', key: string, dark_web_tab_data: { dark_web_post_id: string } } | { __typename: 'HistoricalSearchTab', key: string } | { __typename: 'IncidentTab', key: string, incident_tab_data: { incident_id: string } } | { __typename: 'SettingsTab', key: string } | { __typename: 'StreamManagerTab', key: string }> } };

export type getDefaultEverbridgeIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type getDefaultEverbridgeIntegrationQuery = { getDefaultEverbridgeIntegration?: { url: string } | null };

export type getEverbridgeIntegrationQueryVariables = Exact<{
  params: GetEverbridgeIntegrationParams;
}>;


export type getEverbridgeIntegrationQuery = { getEverbridgeIntegration?: { api_key: string, disabled: boolean, default_vcc_category?: string | null, name: string, url: string, version: number, event_mapping?: Array<{ event_type: string, severity_level: string, vcc_category: string }> | null, social_types?: { twitter: boolean, web: boolean } | null } | null };

export type getIncidentQueryVariables = Exact<{
  params: GetIncidentParams;
}>;


export type getIncidentQuery = { getIncident?: { _id: string, gid: GID, detected_date?: string | null, polygons: Array<string>, severity: IncidentSeverity, total_posts: number, types: Array<string>, has_featured_content: boolean, status: IncidentStatus, timezone: Array<string>, private: boolean, headline: { source?: string | null, text?: string | null }, incident_response?: { gid: GID } | null, impact?: { reason: string, type: string } | null, impact_agent?: { category: number, impact_agent_id: string } | null, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ _id?: string | null, compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> } | null };

export type getIncidentNearbyAssetsQueryVariables = Exact<{
  params: GetIncidentParams;
}>;


export type getIncidentNearbyAssetsQuery = { getIncident?: { nearby_assets: Array<{ distance: number, is_exact: boolean, asset: { _id: string, gid: GID, asset_type: ProximityAssetType, lat: number, lng: number, name: string, start_date?: string | null, end_date?: string | null, timezone?: TimeZone | null, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }>, geometry: { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null, travel_facility?: { name: string, type: string } | null } }> } | null };

export type getIncidentSummarySessionQueryVariables = Exact<{
  params: GetIncidentSummarySessionParams;
}>;


export type getIncidentSummarySessionQuery = { getIncidentSummarySession: { error?: { code: string, message: string } | null, incident_summary_session?: { incident_id: string, gid: GID, text_plain: string, text_markdown: string, followup_questions: Array<{ gid: GID, label: string, type: FollowupQuestionType }> } | null } };

export type getIncidentSummarySessionFollowupQueryVariables = Exact<{
  params: GetIncidentSummarySessionFollowupParams;
}>;


export type getIncidentSummarySessionFollowupQuery = { getIncidentSummarySessionFollowup: { success: boolean, text?: string | null, error?: { code: string, message: string } | null } };

export type getPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type getPersonQuery = { getPerson: { name: string, email: string, timezone?: TimeZone | null, mfaAuthenticated: boolean, partialAccounts: Array<{ _id: string, gid: GID, name: string, index: number, active: boolean, mfaRequired: boolean, userId: string }> } };

export type getProximityAssetSetQueryVariables = Exact<{
  params: GetProximityAssetSetParams;
}>;


export type getProximityAssetSetQuery = { getProximityAssetSet?: { _id: string, gid: GID, account_id: string, asset_count: number, created: string, name: string, proximity: number, updated: string } | null };

export type getResetPasswordRequestQueryVariables = Exact<{
  params: GetResetPasswordRequestParams;
}>;


export type getResetPasswordRequestQuery = { getResetPasswordRequest?: { code: string, account_password_policy: { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean } } | null };

export type getSAMLConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type getSAMLConfigurationQuery = { getSAMLConfiguration?: { certs: Array<string>, endpoint: string, issuer: string } | null };

export type getTravellerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type getTravellerDataQuery = { getTravellerData?: { time: string, all_travellers: Array<{ admin_1?: string | null, country: string, email?: string | null, end_date: string, locality?: string | null, name: string, start_date: string, status: string }>, region_data: Array<{ active_count: number, country: string, pending_count: number }> } | null };

export type getUserQueryVariables = Exact<{ [key: string]: never; }>;


export type getUserQuery = { getUser?: { _id: string, gid: GID, index: number, created: string, role: UserAccountRole, person: { _id: string, name: string, email: string, timezone?: TimeZone | null }, client_settings: Array<{ key: string, value: string }>, preferences: { disabled_translations: Array<string>, distance_unit: DisplayUnit, notification_sound: string, temperature_unit: DisplayUnit }, account: { _id: string, active: boolean, gid: GID, logo?: string | null, name: string, status: AccountStatus, api_keys: Array<{ _id: string, active: boolean, created: string, gid: GID, name: string, value: string }>, flags: Array<{ key: string, value: string }>, password_policy: { min_length: number, require_lowercase: boolean, require_number: boolean, require_special: boolean, require_uppercase: boolean }, preferences: { authentic8: boolean, password_authentication: boolean, saml_authentication: boolean, two_factor_authentication: boolean }, settings: { authentic8: boolean, allow_webhooks: boolean, api_access: boolean, eb_integration: boolean, everbridge_v2: boolean, is_sam: boolean, copy_stream: boolean, csv_asset_upload: boolean, max_asset_sets: number, ms_teams: boolean, resolver: boolean, samalytics: boolean, samalytics_tab: boolean, sammerizer: boolean, saml: boolean, shared_streams: boolean, show_proximity: boolean, travel_integration: boolean, max_contact_group_contacts: number, max_contact_groups: number, max_web_alert_streams: number, max_asset_set_locations: number, max_search_streams: number, max_dark_web_streams: number, max_dashboard_columns_tabs: number, max_samalytics_exportable_incidents: number } }, intercom: { user_hash: string }, settings: { max_search_streams: number, max_web_alert_stream_sources: number } } | null };

export type getWeatherQueryVariables = Exact<{
  params: GetWeatherParams;
}>;


export type getWeatherQuery = { getWeather?: { icon: string, long_description: string, short_description: string, sunrise: number, sunset: number, temp: number, wind_direction?: string | null, wind_speed: number } | null };

export type getWhereByLongkeyQueryVariables = Exact<{
  params: GetWhereByLongkeyParams;
}>;


export type getWhereByLongkeyQuery = { getWhereByLongkey?: { compact_display: string, display: string, geo?: { lat: number, lng: number } | null } | null };

export type listAccountMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type listAccountMembersQuery = { listAccountMembers: { pending: Array<{ _id: string, email: string, role: string, account: { name: string } }>, active: Array<{ _id: string, account_id: string, role: string, user: { _id: string, email: string, name: string, last_activity?: string | null } }> } };

export type listAlertsQueryVariables = Exact<{
  params: ListAlertsParams;
}>;


export type listAlertsQuery = { listAlerts: Array<{ __typename: 'DarkWebAlert', _id: string, created: string, updated: string, read: boolean, stream_id: string, post: { _id: string, gid: GID, crawlDate: string, flattenedHeadline: string, snippets: { nodes: Array<{ text: string, truncatedEnd: boolean, truncatedStart: boolean, highlights: Array<{ end: number, start: number }> }> }, summary?: { text?: string | null } | null } } | { __typename: 'IncidentAlert', _id: string, read: boolean, incident_gid: GID, incident_id: string, created: string, stream_id: string, closest_proximity?: { name: string, distance: number } | null, proximity_matches: Array<{ asset_id: string }>, recent_headlines: Array<{ date: string, text: string }>, incident_update?: { completed_date?: string | null, detected_date?: string | null, isPrivate: boolean, new: { headline: string, headline_source?: string | null, polygons: Array<string>, severity: IncidentSeverity, types: Array<string>, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> }, rtc_update?: { text: string } | null } | null } | { __typename: 'WebAlert', _id: string, created: string, updated: string, read: boolean, stream_id: string, post: { _id: string, gid: GID, text: string, permalink: string, author: { id: string, handle: string, avatar_url: string, name: string, description: string, permalink: string } } }> };

export type listAlertsSummaryQueryVariables = Exact<{
  params: ListAlertsParams;
}>;


export type listAlertsSummaryQuery = { listAlerts: Array<{ __typename: 'DarkWebAlert', _id: string, created: string, stream_id: string } | { __typename: 'IncidentAlert', _id: string, created: string, stream_id: string } | { __typename: 'WebAlert', _id: string, created: string, stream_id: string }> };

export type listEverbridgeIntegrationsQueryVariables = Exact<{
  params: ListEverbridgeIntegrationsParams;
}>;


export type listEverbridgeIntegrationsQuery = { listEverbridgeIntegrations: Array<{ _id: string, api_key: string, created?: string | null, default_vcc_category?: string | null, disabled: boolean, name: string, updated?: string | null }> };

export type listEverbridgeVCCCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type listEverbridgeVCCCategoriesQuery = { listEverbridgeVCCCategories: Array<{ _id: string, category: string }> };

export type listIncidentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type listIncidentTypesQuery = { listIncidentTypes: Array<{ category: string, category_name: string, name: string, type: string }> };

export type listInputStreamCategoriesQueryVariables = Exact<{
  params: ListInputStreamCategoriesParams;
}>;


export type listInputStreamCategoriesQuery = { listInputStreamCategories: Array<{ _id: string, color: HexColorCode, created: string, description?: string | null, name: string, type: string, children: Array<{ _id: string, category_id?: string | null, name: string, description?: string | null, tooltip?: string | null }> }> };

export type listLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type listLanguagesQuery = { listLanguages: Array<{ key: string, name: string }> };

export type listLocalAccountsQueryVariables = Exact<{
  params: ListLocalAccountsParams;
}>;


export type listLocalAccountsQuery = { listLocalAccounts: Array<{ concepts: Array<string>, name: string, alt_names: Array<{ type: string, value: string }> }> };

export type listMsTeamsWebhooksQueryVariables = Exact<{
  params: ListMsTeamsWebhooksParams;
}>;


export type listMsTeamsWebhooksQuery = { listMsTeamsWebhooks: Array<{ _id: string, account_id: string, name: string, url: string, created: string, updated: string, user_id: string, disabled: boolean }> };

export type listOutgoingWebhooksQueryVariables = Exact<{
  params: ListOutgoingWebhooksParams;
}>;


export type listOutgoingWebhooksQuery = { listOutgoingWebhooks: Array<{ _id: string, account_id: string, disabled: boolean, failure_count: number, name: string, url: string, created: string, updated: string, user_id: string, last_failure?: { code: string, date: string } | null, headers?: Array<{ key: string, value: string }> | null }> };

export type listPrivateIncidentsQueryVariables = Exact<{
  params: ListPrivateIncidentsParams;
}>;


export type listPrivateIncidentsQuery = { listPrivateIncidents: { nodes: Array<{ _id: string, detected_date?: string | null, headline: { text?: string | null }, wheres: Array<{ display: string }> }> } };

export type listProximityAssetSetsQueryVariables = Exact<{
  params: ListProximityAssetSetsParams;
}>;


export type listProximityAssetSetsQuery = { listProximityAssetSets: Array<{ _id: string, gid: GID, account_id: string, asset_count: number, created: string, name: string, proximity: number, updated: string, uses_hours?: boolean | null }> };

export type listProximityAssetsQueryVariables = Exact<{
  params: ListProximityAssetsParams;
}>;


export type listProximityAssetsQuery = { listProximityAssets: Array<{ _id: string, gid: GID, asset_type: ProximityAssetType, lat: number, lng: number, name: string, start_date?: string | null, end_date?: string | null, timezone?: TimeZone | null, contactMethods: Array<{ __typename: 'AssetContact' } | { __typename: 'AssetSetContact', assetSet: { gid: GID, name: string } } | { __typename: 'EmailContact', emailValue: EmailAddress } | { __typename: 'NearbyAssetsContact' } | { __typename: 'PhoneContact', phoneValue: PhoneNumber } | { __typename: 'SlackContact', targetEmail: EmailAddress, targetID: string, targetName: string, workspaceID: string, workspaceName: string } | { __typename: 'UserContact', userValue: string }>, geometry: { line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }, hours?: Array<{ open: string, close: string } | null> | null, travel_facility?: { name: string, type: string } | null }> };

export type listResolverWebhooksQueryVariables = Exact<{
  params: ListResolverWebhooksParams;
}>;


export type listResolverWebhooksQuery = { listResolverWebhooks: Array<{ _id: string, account_id: string, name: string, url: string, created: string, updated: string, user_id: string, disabled: boolean, headers?: Array<{ key: string, value: string }> | null }> };

export type listSlackWebhooksQueryVariables = Exact<{
  params: ListSlackWebhooksParams;
}>;


export type listSlackWebhooksQuery = { listSlackWebhooks: Array<{ _id: string, account_id: string, user_id: string, team_name: string, channel_name: string, configuration_url: string, disabled: boolean, created: string, updated: string }> };

export type listSlackWorkspacesQueryVariables = Exact<{
  params: ListSlackWorkspacesParams;
}>;


export type listSlackWorkspacesQuery = { listSlackWorkspaces: Array<{ _id: string, created: string, disabled: boolean, gid: GID, name: string }> };

export type listStreamsQueryVariables = Exact<{
  params: ListStreamsParams;
}>;


export type listStreamsQuery = { listStreams: Array<{ __typename: 'DarkWebStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean } } } | { __typename: 'IncidentStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { severities: Array<IncidentSeverity>, asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }>, lucene_string?: { advanced: boolean, value: string } | null }, impact_agent_stream_configuration?: { impact_agent_id: string, match_config: { match_categories: Array<number> } } | null, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } } | { __typename: 'StandardStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { asset_sets: Array<{ asset_set_id: string, configuration?: { radius: number, use_hours_of_operation: boolean } | null }>, coverage: { input_stream_ids: Array<string>, type: string }, keywords: Array<{ include: boolean, keyword: string }>, lucene_string?: { advanced: boolean, value: string } | null, locations: Array<{ geo_id: string, longkey: string, name: string, type: string }> }, notifications: { audio: { active: boolean, severities: Array<IncidentSeverity> }, email: { active: boolean, stream_owner: boolean, nearby_assets: boolean, emails: Array<string>, severities: Array<IncidentSeverity> }, scheduledBrief: { active: boolean, time?: LocalTime | null }, mobile: { active: boolean, severities: Array<IncidentSeverity> }, everbridge: { active: boolean }, slack: { active: boolean, nearby_assets: boolean, slack_webhook_id?: string | null }, outgoing_webhook: { active: boolean, outgoing_webhook_id?: string | null }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, resolver: { active: boolean, resolver_webhook_id?: string | null }, genetec: { active: boolean, genetec_integration_gid?: GID | null } } } | { __typename: 'WebAlertsStream', _id: string, gid: GID, name: string, share_type: StreamShareType, is_owner: boolean, type: StreamType, criterion_updated: string, owner?: { gid: GID, name: string } | null, criterion: { source_count: number, sources: Array<{ disabled: boolean, postAuthor: { name: string, description: string, permalink: string, avatarUrl: string } }>, lucene_string?: { advanced: boolean, value: string } | null }, notifications: { email: { active: boolean, emails: Array<string>, severities: Array<IncidentSeverity>, stream_owner: boolean }, ms_teams: { active: boolean, ms_teams_webhook_id?: string | null }, slack: { active: boolean, slack_webhook_id?: string | null } } }> };

export type searchIncidentAnalyticsTableQueryVariables = Exact<{
  params: SearchIncidentsAnalyticsTableParams;
}>;


export type searchIncidentAnalyticsTableQuery = { searchIncidentAnalyticsTable: { total_count: { value: number }, incidents: Array<{ incident_id: string, date: string, types: Array<string>, locations: Array<string>, severity: IncidentSeverity }> } };

export type searchIncidentsQueryVariables = Exact<{
  params: SearchIncidentsParams;
}>;


export type searchIncidentsQuery = { searchIncidents: Array<{ highlight?: { source?: string | null, text?: string | null } | null, incident: { _id: string, detected_date?: string | null, is_featured: boolean, severity: IncidentSeverity, types: Array<string>, headline: { source?: string | null, text?: string | null, type?: IncidentHeadlineType | null }, wheres: Array<{ compact_display: string }> } }> };

export type searchIncidentsAnalyticsQueryVariables = Exact<{
  params: SearchIncidentsAnalyticsParams;
}>;


export type searchIncidentsAnalyticsQuery = { searchIncidentsAnalytics: { metrics: Array<{ value: number, dimensions: Array<{ value: string }> }>, total_count: { value: number } } };

export type searchIncidentsAnalyticsDrilldownQueryVariables = Exact<{
  params: SearchIncidentsAnalyticsDrilldownParams;
}>;


export type searchIncidentsAnalyticsDrilldownQuery = { searchIncidentsAnalyticsDrilldown: { metrics: Array<{ value: number, dimensions: Array<{ value: string }> }>, total_count: { value: number } } };

export type searchIncidentsAnalyticsHeatmapQueryVariables = Exact<{
  params: SearchIncidentsAnalyticsHeatmapParams;
}>;


export type searchIncidentsAnalyticsHeatmapQuery = { searchIncidentsAnalyticsHeatmap: { points: Array<{ count: number, lat: number, lng: number }>, total_count: { value: number } } };

export type searchIncidentsResultsQueryVariables = Exact<{
  params: SearchIncidentsParams;
}>;


export type searchIncidentsResultsQuery = { searchIncidentsResults: { results: Array<{ highlight?: { source?: string | null, text?: string | null } | null, incident: { _id: string, gid: GID, detected_date?: string | null, severity: IncidentSeverity, types: Array<string>, headline: { source?: string | null, text?: string | null, type?: IncidentHeadlineType | null }, wheres: Array<{ compact_display: string }> } }>, total_count: { value: number, relation: string } } };

export type searchLocationsQueryVariables = Exact<{
  params: SearchLocationsParams;
}>;


export type searchLocationsQuery = { searchLocations: Array<{ __typename: 'Location', _id: string, key: string, label: string, longkey: string, name: string, type: string }> };

export type searchRecentIncidentsQueryVariables = Exact<{
  params: SearchRecentIncidentsParams;
}>;


export type searchRecentIncidentsQuery = { searchRecentIncidents: Array<{ _id: string, gid: GID, completed_date?: string | null, detected_date?: string | null, polygons: Array<string>, severity: IncidentSeverity, status: IncidentStatus, types: Array<string>, headline: { source?: string | null, text?: string | null }, geometries: Array<{ line_string?: Array<GeoJSONLngLat> | null, point?: GeoJSONLngLat | null, polygon?: Array<Array<GeoJSONLngLat>> | null, type: GeoJSONType }>, wheres: Array<{ compact_display: string, display: string, longkey: string, geo?: { lat: number, lng: number } | null }> }> };

export type uploadStatusQueryVariables = Exact<{
  params: UploadStatusParams;
}>;


export type uploadStatusQuery = { uploadStatus?: { gid: GID, file_name?: string | null, status: UploadStatusStatus, target_gid: GID, purpose: UploadStatusPurpose, created: string, progress: { percent: number, count: number, total: number }, errors: Array<{ message: string }> } | null };

export const contactGroupFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contactGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContactGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contactCount"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]} as unknown as DocumentNode<contactGroupFieldsFragment, unknown>;
export const emailContactMethodsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"emailContactMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<emailContactMethodsFragment, unknown>;
export const proximityAssetForMapFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"proximityAssetForMapFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProximityAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"point"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"}},{"kind":"Field","name":{"kind":"Name","value":"line_string"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"close"}}]}}]}}]} as unknown as DocumentNode<proximityAssetForMapFieldsFragment, unknown>;
export const geometryFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"geometryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeoJSONGeometry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line_string"}},{"kind":"Field","name":{"kind":"Name","value":"point"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<geometryFieldsFragment, unknown>;
export const incidentAlertFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"incidentAlertFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"closest_proximity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proximity_matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recent_headlines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"incident_gid"}},{"kind":"Field","name":{"kind":"Name","value":"incident_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"stream_id"}},{"kind":"Field","name":{"kind":"Name","value":"incident_update"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed_date"}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}},{"kind":"Field","alias":{"kind":"Name","value":"isPrivate"},"name":{"kind":"Name","value":"private"}},{"kind":"Field","name":{"kind":"Name","value":"new"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"headline_source"}},{"kind":"Field","name":{"kind":"Name","value":"polygons"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"geometries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"geometryFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compact_display"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"geo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rtc_update"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<incidentAlertFieldsFragment, unknown>;
export const webAlertFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"webAlertFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"stream_id"}},{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permalink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permalink"}}]}}]}}]} as unknown as DocumentNode<webAlertFieldsFragment, unknown>;
export const darkWebPostFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"darkWebPostFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebPost"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"crawlDate"}},{"kind":"Field","name":{"kind":"Name","value":"flattenedHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"snippets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"truncatedEnd"}},{"kind":"Field","name":{"kind":"Name","value":"truncatedStart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<darkWebPostFieldsFragment, unknown>;
export const darkWebAlertFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"darkWebAlertFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"stream_id"}},{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"darkWebPostFields"}}]}}]}}]} as unknown as DocumentNode<darkWebAlertFieldsFragment, unknown>;
export const alertFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"alertFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentAlertFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"webAlertFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"darkWebAlertFields"}}]}}]}}]} as unknown as DocumentNode<alertFieldsFragment, unknown>;
export const heatmapPointFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"heatmapPointFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeatmapPoint"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<heatmapPointFieldsFragment, unknown>;
export const impactAgentFeedbackFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"impactAgentFeedbackFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImpactAgentFeedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"agent_assigned_category"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"correct_category"}},{"kind":"Field","name":{"kind":"Name","value":"feedback_text"}},{"kind":"Field","name":{"kind":"Name","value":"incident_title"}},{"kind":"Field","name":{"kind":"Name","value":"is_correction"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"submitting_analyst"}}]}}]} as unknown as DocumentNode<impactAgentFeedbackFieldsFragment, unknown>;
export const impactAgentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"impactAgentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImpactAgent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_filter_prompt"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<impactAgentFieldsFragment, unknown>;
export const incidentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"incidentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident_response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"polygons"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"total_posts"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"has_featured_content"}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact_agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"impact_agent_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geometries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"geometryFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"compact_display"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"geo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"private"}}]}}]} as unknown as DocumentNode<incidentFieldsFragment, unknown>;
export const emailContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"emailContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}}]}}]} as unknown as DocumentNode<emailContactFieldsFragment, unknown>;
export const phoneContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoneContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"phoneValue"}}]}}]} as unknown as DocumentNode<phoneContactFieldsFragment, unknown>;
export const userContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"userContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"userValue"}}]}}]} as unknown as DocumentNode<userContactFieldsFragment, unknown>;
export const slackContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"slackContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SlackContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"targetEmail"}},{"kind":"Field","name":{"kind":"Name","value":"targetID"}},{"kind":"Field","name":{"kind":"Name","value":"targetName"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceName"}}]}}]} as unknown as DocumentNode<slackContactFieldsFragment, unknown>;
export const assetSetContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assetSetContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetSetContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"assetSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<assetSetContactFieldsFragment, unknown>;
export const contactMethodsWithoutAssetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contactMethodsWithoutAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContactMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"emailContactFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoneContactFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userContactFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SlackContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"slackContactFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetSetContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assetSetContactFields"}}]}}]}}]} as unknown as DocumentNode<contactMethodsWithoutAssetFieldsFragment, unknown>;
export const assetContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assetContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type"}},{"kind":"Field","alias":{"kind":"Name","value":"contactMethods"},"name":{"kind":"Name","value":"contact_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactMethodsWithoutAssetFields"}}]}}]}}]}}]} as unknown as DocumentNode<assetContactFieldsFragment, unknown>;
export const contactMethodWithAssetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contactMethodWithAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContactMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactMethodsWithoutAssetFields"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assetContactFields"}}]}}]}}]} as unknown as DocumentNode<contactMethodWithAssetFieldsFragment, unknown>;
export const incidentResponseActionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"incidentResponseActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"newCreatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactMethodWithAssetFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionAcknowledged"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionResolved"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionNotified"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionNotifiedResponded"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionNotifiedViewed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionNotificationQueued"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponseActionNotifyInitiated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}}]}}]} as unknown as DocumentNode<incidentResponseActionFieldsFragment, unknown>;
export const incidentResponseFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"incidentResponseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentResponseActionFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<incidentResponseFieldsFragment, unknown>;
export const incidentTypeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"incidentTypeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"category_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<incidentTypeFieldsFragment, unknown>;
export const languageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"languageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<languageFieldsFragment, unknown>;
export const localAccountFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"localAccountFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocalAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt_names"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"concepts"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<localAccountFieldsFragment, unknown>;
export const msTeamsWebhookFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"msTeamsWebhookFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MsTeamsWebhook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}}]} as unknown as DocumentNode<msTeamsWebhookFieldsFragment, unknown>;
export const nearbyAssetsContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"nearbyAssetsContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NearbyAssetsContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<nearbyAssetsContactFieldsFragment, unknown>;
export const proximityAssetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"proximityAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProximityAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type"}},{"kind":"Field","alias":{"kind":"Name","value":"contactMethods"},"name":{"kind":"Name","value":"contact_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactMethodsWithoutAssetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line_string"}},{"kind":"Field","name":{"kind":"Name","value":"point"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"close"}}]}},{"kind":"Field","name":{"kind":"Name","value":"travel_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<proximityAssetFieldsFragment, unknown>;
export const nearbyAssetsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"nearbyAssetsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearby_assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"is_exact"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"proximityAssetFields"}}]}}]}}]}}]} as unknown as DocumentNode<nearbyAssetsFieldsFragment, unknown>;
export const outgoingWebhookFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"outgoingWebhookFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OutgoingWebhook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"failure_count"}},{"kind":"Field","name":{"kind":"Name","value":"last_failure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<outgoingWebhookFieldsFragment, unknown>;
export const partialAccountFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"partialAccountFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PartialAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"mfaRequired"},"name":{"kind":"Name","value":"mfa_required"}},{"kind":"Field","alias":{"kind":"Name","value":"userId"},"name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<partialAccountFieldsFragment, unknown>;
export const personFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","alias":{"kind":"Name","value":"mfaAuthenticated"},"name":{"kind":"Name","value":"mfa_authenticated"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","alias":{"kind":"Name","value":"partialAccounts"},"name":{"kind":"Name","value":"partial_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"partialAccountFields"}}]}}]}}]} as unknown as DocumentNode<personFieldsFragment, unknown>;
export const privateIncidentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"privateIncidentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}}]}}]} as unknown as DocumentNode<privateIncidentFieldsFragment, unknown>;
export const proximityAssetSetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"proximityAssetSetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProximityAssetSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_count"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"proximity"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"uses_hours"}}]}}]} as unknown as DocumentNode<proximityAssetSetFieldsFragment, unknown>;
export const publicIncidentResponseNotificationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"publicIncidentResponseNotificationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicIncidentResponseNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatus"}},{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geometries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"geometryFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"compact_display"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"geo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}}]}}]}}]}}]} as unknown as DocumentNode<publicIncidentResponseNotificationFieldsFragment, unknown>;
export const resolverWebhookFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"resolverWebhookFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResolverWebhook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}}]} as unknown as DocumentNode<resolverWebhookFieldsFragment, unknown>;
export const searchIncidentAnalyticsTableItemFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"searchIncidentAnalyticsTableItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentAnalyticsTableItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"locations"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}}]}}]} as unknown as DocumentNode<searchIncidentAnalyticsTableItemFieldsFragment, unknown>;
export const slackWebhookFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"slackWebhookFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SlackWebhook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_name"}},{"kind":"Field","name":{"kind":"Name","value":"channel_name"}},{"kind":"Field","name":{"kind":"Name","value":"configuration_url"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]} as unknown as DocumentNode<slackWebhookFieldsFragment, unknown>;
export const slackWorkspaceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"slackWorkspaceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SlackWorkspace"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<slackWorkspaceFieldsFragment, unknown>;
export const standardStreamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"standardStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"criterion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_set_id"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"use_hours_of_operation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_stream_ids"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lucene_string"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advanced"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geo_id"}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"stream_owner"}},{"kind":"Field","name":{"kind":"Name","value":"nearby_assets"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"scheduledBrief"},"name":{"kind":"Name","value":"scheduled_brief"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"everbridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"nearby_assets"}},{"kind":"Field","name":{"kind":"Name","value":"slack_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outgoing_webhook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"outgoing_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"resolver_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"genetec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"genetec_integration_gid"}}]}}]}}]}}]} as unknown as DocumentNode<standardStreamFieldsFragment, unknown>;
export const incidentStreamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"incidentStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"criterion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_set_id"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"use_hours_of_operation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_stream_ids"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geo_id"}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lucene_string"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advanced"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact_agent_stream_configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_agent_id"}},{"kind":"Field","name":{"kind":"Name","value":"match_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"match_categories"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"stream_owner"}},{"kind":"Field","name":{"kind":"Name","value":"nearby_assets"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"scheduledBrief"},"name":{"kind":"Name","value":"scheduled_brief"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"everbridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"nearby_assets"}},{"kind":"Field","name":{"kind":"Name","value":"slack_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outgoing_webhook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"outgoing_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"resolver_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"genetec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"genetec_integration_gid"}}]}}]}}]}}]} as unknown as DocumentNode<incidentStreamFieldsFragment, unknown>;
export const webAlertsStreamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"webAlertsStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebAlertsStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"criterion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source_count"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","alias":{"kind":"Name","value":"postAuthor"},"name":{"kind":"Name","value":"post_author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"avatarUrl"},"name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permalink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lucene_string"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advanced"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}},{"kind":"Field","name":{"kind":"Name","value":"stream_owner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams_webhook_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slack_webhook_id"}}]}}]}}]}}]} as unknown as DocumentNode<webAlertsStreamFieldsFragment, unknown>;
export const darkWebStreamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"darkWebStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"criterion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lucene_string"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advanced"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}},{"kind":"Field","name":{"kind":"Name","value":"stream_owner"}}]}}]}}]}}]} as unknown as DocumentNode<darkWebStreamFieldsFragment, unknown>;
export const streamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"streamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"share_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"criterion_updated"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"standardStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebAlertsStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"webAlertsStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"darkWebStreamFields"}}]}}]}}]} as unknown as DocumentNode<streamFieldsFragment, unknown>;
export const uploadStatusFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"uploadStatusFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"target_gid"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<uploadStatusFieldsFragment, unknown>;
export const apiKeyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"apiKeyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"APIKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<apiKeyFieldsFragment, unknown>;
export const accountPasswordPolicyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"accountPasswordPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountPasswordPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_length"}},{"kind":"Field","name":{"kind":"Name","value":"require_lowercase"}},{"kind":"Field","name":{"kind":"Name","value":"require_number"}},{"kind":"Field","name":{"kind":"Name","value":"require_special"}},{"kind":"Field","name":{"kind":"Name","value":"require_uppercase"}}]}}]} as unknown as DocumentNode<accountPasswordPolicyFieldsFragment, unknown>;
export const accountFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"accountFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"api_keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"apiKeyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"password_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accountPasswordPolicyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authentic8"}},{"kind":"Field","name":{"kind":"Name","value":"password_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"saml_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"two_factor_authentication"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authentic8"}},{"kind":"Field","name":{"kind":"Name","value":"allow_webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"api_access"}},{"kind":"Field","name":{"kind":"Name","value":"eb_integration"}},{"kind":"Field","name":{"kind":"Name","value":"everbridge_v2"}},{"kind":"Field","name":{"kind":"Name","value":"is_sam"}},{"kind":"Field","name":{"kind":"Name","value":"copy_stream"}},{"kind":"Field","name":{"kind":"Name","value":"csv_asset_upload"}},{"kind":"Field","name":{"kind":"Name","value":"max_asset_sets"}},{"kind":"Field","name":{"kind":"Name","value":"ms_teams"}},{"kind":"Field","name":{"kind":"Name","value":"resolver"}},{"kind":"Field","name":{"kind":"Name","value":"samalytics"}},{"kind":"Field","name":{"kind":"Name","value":"samalytics_tab"}},{"kind":"Field","name":{"kind":"Name","value":"sammerizer"}},{"kind":"Field","name":{"kind":"Name","value":"saml"}},{"kind":"Field","name":{"kind":"Name","value":"shared_streams"}},{"kind":"Field","name":{"kind":"Name","value":"show_proximity"}},{"kind":"Field","name":{"kind":"Name","value":"travel_integration"}},{"kind":"Field","name":{"kind":"Name","value":"max_contact_group_contacts"}},{"kind":"Field","name":{"kind":"Name","value":"max_contact_groups"}},{"kind":"Field","name":{"kind":"Name","value":"max_web_alert_streams"}},{"kind":"Field","name":{"kind":"Name","value":"max_asset_set_locations"}},{"kind":"Field","name":{"kind":"Name","value":"max_search_streams"}},{"kind":"Field","name":{"kind":"Name","value":"max_dark_web_streams"}},{"kind":"Field","name":{"kind":"Name","value":"max_dashboard_columns_tabs"}},{"kind":"Field","name":{"kind":"Name","value":"max_samalytics_exportable_incidents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<accountFieldsFragment, unknown>;
export const userFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"userFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client_settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disabled_translations"}},{"kind":"Field","name":{"kind":"Name","value":"distance_unit"}},{"kind":"Field","name":{"kind":"Name","value":"notification_sound"}},{"kind":"Field","name":{"kind":"Name","value":"temperature_unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accountFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intercom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_search_streams"}},{"kind":"Field","name":{"kind":"Name","value":"max_web_alert_stream_sources"}}]}}]}}]} as unknown as DocumentNode<userFieldsFragment, unknown>;
export const UpdateImpactAgentFeedbacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImpactAgentFeedbacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImpactAgentFeedbacksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImpactAgentFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateImpactAgentFeedbacksMutation, UpdateImpactAgentFeedbacksMutationVariables>;
export const copyStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"stream"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<copyStreamMutation, copyStreamMutationVariables>;
export const CreateAnalyticsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnalyticsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAnalyticsSearchParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnalyticsSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analytics_search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"search_params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"after"}},{"kind":"Field","name":{"kind":"Name","value":"asset_set_id"}},{"kind":"Field","name":{"kind":"Name","value":"before"}},{"kind":"Field","name":{"kind":"Name","value":"relative_timestamp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident_types"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}},{"kind":"Field","name":{"kind":"Name","value":"geo_filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"radius_km"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"point"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateAnalyticsSearchMutation, CreateAnalyticsSearchMutationVariables>;
export const CreateContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContactParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateContactMutation, CreateContactMutationVariables>;
export const CreateContactGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContactGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContactGroupParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContactGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}}]}}]}}]}}]} as unknown as DocumentNode<CreateContactGroupMutation, CreateContactGroupMutationVariables>;
export const CreateDarkWebStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDarkWebStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDarkWebStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDarkWebStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateDarkWebStreamMutation, CreateDarkWebStreamMutationVariables>;
export const createImpactAgentCorrectionFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createImpactAgentCorrectionFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateImpactAgentCorrectionFeedbackParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImpactAgentCorrectionFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<createImpactAgentCorrectionFeedbackMutation, createImpactAgentCorrectionFeedbackMutationVariables>;
export const CreateWebAlertsStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWebAlertsStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWebAlertsStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWebAlertsStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateWebAlertsStreamMutation, CreateWebAlertsStreamMutationVariables>;
export const DeleteContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteContactParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteContactMutation, DeleteContactMutationVariables>;
export const DeleteContactGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteContactGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteContactGroupParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteContactGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>;
export const DeleteStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteStreamMutation, DeleteStreamMutationVariables>;
export const EnableOutgoingWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableOutgoingWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnableOutgoingWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableOutgoingWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<EnableOutgoingWebhookMutation, EnableOutgoingWebhookMutationVariables>;
export const InitiateDownloadStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateDownloadStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateDownloadStatusParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateDownloadStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateDownloadStatusMutation, InitiateDownloadStatusMutationVariables>;
export const listSalesforceIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listSalesforceIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listSalesforceIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<listSalesforceIntegrationsQuery, listSalesforceIntegrationsQueryVariables>;
export const sendIncidentToSalesforceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendIncidentToSalesforce"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendIncidentToSalesforceParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendIncidentToSalesforce"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<sendIncidentToSalesforceMutation, sendIncidentToSalesforceMutationVariables>;
export const UpdateAnalyticsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAnalyticsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAnalyticsSearchParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnalyticsSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAnalyticsSearchMutation, UpdateAnalyticsSearchMutationVariables>;
export const UpdateContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateContactMutation, UpdateContactMutationVariables>;
export const UpdateContactGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContactGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactGroupParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContactGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateContactGroupMutation, UpdateContactGroupMutationVariables>;
export const UpdateDarkWebStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDarkWebStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDarkWebStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDarkWebStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateDarkWebStreamMutation, UpdateDarkWebStreamMutationVariables>;
export const UpdateImpactAgentFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImpactAgentFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImpactAgentFeedbackParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImpactAgentFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateImpactAgentFeedbackMutation, UpdateImpactAgentFeedbackMutationVariables>;
export const UpdateWebAlertsStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWebAlertsStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWebAlertsStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWebAlertsStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateWebAlertsStreamMutation, UpdateWebAlertsStreamMutationVariables>;
export const CountImpactAgentFeedbacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountImpactAgentFeedbacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListImpactAgentFeedbacksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countImpactAgentFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}]}]}}]} as unknown as DocumentNode<CountImpactAgentFeedbacksQuery, CountImpactAgentFeedbacksQueryVariables>;
export const GetContactGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContactGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetContactGroupParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContactGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetContactGroupQuery, GetContactGroupQueryVariables>;
export const GetDarkWebPostDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDarkWebPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDarkWebPostParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDarkWebPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"darkWebPostFields"}}]}}]}},...darkWebPostFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetDarkWebPostQuery, GetDarkWebPostQueryVariables>;
export const getDownloadStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDownloadStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDownloadStatusParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDownloadStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_url"}},{"kind":"Field","name":{"kind":"Name","value":"download_errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]}}]} as unknown as DocumentNode<getDownloadStatusQuery, getDownloadStatusQueryVariables>;
export const GetImpactAgentDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImpactAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetImpactAgentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getImpactAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"impactAgentFields"}}]}}]}},...impactAgentFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetImpactAgentQuery, GetImpactAgentQueryVariables>;
export const getStreamApolloDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStreamApollo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetStreamParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newGetStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"share_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"transferred_date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"criterion_updated"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"standardStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebAlertsStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"webAlertsStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"darkWebStreamFields"}}]}}]}}]}},...standardStreamFieldsFragmentDoc.definitions,...incidentStreamFieldsFragmentDoc.definitions,...webAlertsStreamFieldsFragmentDoc.definitions,...darkWebStreamFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getStreamApolloQuery, getStreamApolloQueryVariables>;
export const ListAnalyticsSearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListAnalyticsSearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAnalyticsSearchesParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAnalyticsSearches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"search_params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"after"}},{"kind":"Field","name":{"kind":"Name","value":"asset_set_id"}},{"kind":"Field","name":{"kind":"Name","value":"before"}},{"kind":"Field","name":{"kind":"Name","value":"relative_timestamp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident_types"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}},{"kind":"Field","name":{"kind":"Name","value":"severities"}},{"kind":"Field","name":{"kind":"Name","value":"geo_filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"radius_km"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"point"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListAnalyticsSearchesQuery, ListAnalyticsSearchesQueryVariables>;
export const listContactGroupsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listContactGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListContactGroupsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContactGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactGroupFields"}}]}}]}},...contactGroupFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listContactGroupsQuery, listContactGroupsQueryVariables>;
export const ListContactsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListContactsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"emailContactMethods"}}]}}]}},...emailContactMethodsFragmentDoc.definitions]} as unknown as DocumentNode<ListContactsQuery, ListContactsQueryVariables>;
export const ListImpactAgentFeedbacksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListImpactAgentFeedbacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListImpactAgentFeedbacksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listImpactAgentFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"impactAgentFeedbackFields"}}]}}]}},...impactAgentFeedbackFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ListImpactAgentFeedbacksQuery, ListImpactAgentFeedbacksQueryVariables>;
export const ListImpactAgentsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListImpactAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListImpactAgentsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listImpactAgents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"impactAgentFields"}}]}}]}},...impactAgentFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ListImpactAgentsQuery, ListImpactAgentsQueryVariables>;
export const listProximityAssetsForMapDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProximityAssetsForMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProximityAssetsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProximityAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"proximityAssetForMapFields"}}]}}]}},...proximityAssetForMapFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listProximityAssetsForMapQuery, listProximityAssetsForMapQueryVariables>;
export const listStreamsApolloDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listStreamsApollo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListStreamsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newListStreams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"share_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"transferred_date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"criterion_updated"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"standardStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebAlertsStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"webAlertsStreamFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"darkWebStreamFields"}}]}}]}}]}},...standardStreamFieldsFragmentDoc.definitions,...incidentStreamFieldsFragmentDoc.definitions,...webAlertsStreamFieldsFragmentDoc.definitions,...darkWebStreamFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listStreamsApolloQuery, listStreamsApolloQueryVariables>;
export const nearbyAssetCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nearbyAssetCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetIncidentCountsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIncidentCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearby_asset_count"}}]}}]}}]} as unknown as DocumentNode<nearbyAssetCountQuery, nearbyAssetCountQueryVariables>;
export const uploadCompleteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadCompleteParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"upload_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"uploadStatusFields"}}]}}]}}]}},...uploadStatusFieldsFragmentDoc.definitions]} as unknown as DocumentNode<uploadCompleteMutation, uploadCompleteMutationVariables>;
export const uploadCreateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadCreateParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"s3_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"upload_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"uploadStatusFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},...uploadStatusFieldsFragmentDoc.definitions]} as unknown as DocumentNode<uploadCreateMutation, uploadCreateMutationVariables>;
export const cancelChangeEmailRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelChangeEmailRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelChangeEmailRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelChangeEmailRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<cancelChangeEmailRequestMutation, cancelChangeEmailRequestMutationVariables>;
export const createAPIKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAPIKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAPIKeyParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAPIKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createAPIKeyMutation, createAPIKeyMutationVariables>;
export const createChangeEmailRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChangeEmailRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChangeEmailRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChangeEmailRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createChangeEmailRequestMutation, createChangeEmailRequestMutationVariables>;
export const createDashboardTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDashboardTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDashboardTabParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDashboardTab"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dark_web_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dark_web_post_id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ColumnsTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columns_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<createDashboardTabMutation, createDashboardTabMutationVariables>;
export const createEverbridgeIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEverbridgeIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEverbridgeIntegrationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEverbridgeIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createEverbridgeIntegrationMutation, createEverbridgeIntegrationMutationVariables>;
export const createIncidentFlagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createIncidentFlag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIncidentFlagParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIncidentFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createIncidentFlagMutation, createIncidentFlagMutationVariables>;
export const createMFACodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMFACode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMFACode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createMFACodeMutation, createMFACodeMutationVariables>;
export const createMsTeamsWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMsTeamsWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMsTeamsWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMsTeamsWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ms_teams_webhook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createMsTeamsWebhookMutation, createMsTeamsWebhookMutationVariables>;
export const createOutgoingWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOutgoingWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOutgoingWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOutgoingWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outgoing_webhook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<createOutgoingWebhookMutation, createOutgoingWebhookMutationVariables>;
export const createProximityAssetSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProximityAssetSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProximityAssetSetParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProximityAssetSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createProximityAssetSetMutation, createProximityAssetSetMutationVariables>;
export const createProximityAssetsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProximityAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProximityAssetsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProximityAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_set_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"proximityAssetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}},...proximityAssetFieldsFragmentDoc.definitions,...contactMethodsWithoutAssetFieldsFragmentDoc.definitions,...emailContactFieldsFragmentDoc.definitions,...phoneContactFieldsFragmentDoc.definitions,...userContactFieldsFragmentDoc.definitions,...slackContactFieldsFragmentDoc.definitions,...assetSetContactFieldsFragmentDoc.definitions]} as unknown as DocumentNode<createProximityAssetsMutation, createProximityAssetsMutationVariables>;
export const CreateRegionBriefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRegionBrief"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRegionBriefParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRegionBrief"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateRegionBriefMutation, CreateRegionBriefMutationVariables>;
export const createResetPasswordRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createResetPasswordRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateResetPasswordRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResetPasswordRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createResetPasswordRequestMutation, createResetPasswordRequestMutationVariables>;
export const createResolverWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createResolverWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateResolverWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResolverWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolver_webhook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<createResolverWebhookMutation, createResolverWebhookMutationVariables>;
export const deleteAPIKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAPIKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAPIKeyParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAPIKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteAPIKeyMutation, deleteAPIKeyMutationVariables>;
export const deleteAccountMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAccountMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAccountMemberParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAccountMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteAccountMemberMutation, deleteAccountMemberMutationVariables>;
export const deleteDashboardTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDashboardTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteDashboardTabParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDashboardTab"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"incident_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<deleteDashboardTabMutation, deleteDashboardTabMutationVariables>;
export const deleteEverbridgeIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEverbridgeIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteEverbridgeIntegrationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEverbridgeIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteEverbridgeIntegrationMutation, deleteEverbridgeIntegrationMutationVariables>;
export const deleteMsTeamsWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteMsTeamsWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMsTeamsWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMsTeamsWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteMsTeamsWebhookMutation, deleteMsTeamsWebhookMutationVariables>;
export const deleteOutgoingWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOutgoingWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOutgoingWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOutgoingWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteOutgoingWebhookMutation, deleteOutgoingWebhookMutationVariables>;
export const deleteProximityAssetSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProximityAssetSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProximityAssetSetParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProximityAssetSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteProximityAssetSetMutation, deleteProximityAssetSetMutationVariables>;
export const deleteProximityAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProximityAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProximityAssetsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProximityAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteProximityAssetsMutation, deleteProximityAssetsMutationVariables>;
export const deleteResolverWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteResolverWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteResolverWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteResolverWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteResolverWebhookMutation, deleteResolverWebhookMutationVariables>;
export const deleteSlackWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSlackWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSlackWebhookParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSlackWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteSlackWebhookMutation, deleteSlackWebhookMutationVariables>;
export const deleteSlackWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSlackWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSlackWorkspaceParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSlackWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteSlackWorkspaceMutation, deleteSlackWorkspaceMutationVariables>;
export const logIncidentInteractionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"logIncidentInteraction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogIncidentInteractionParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logIncidentInteraction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<logIncidentInteractionMutation, logIncidentInteractionMutationVariables>;
export const markEmailTrackerClickedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markEmailTrackerClicked"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkEmailTrackerClickedParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markEmailTrackerClicked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"deep_link_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"alert_type"}},{"kind":"Field","name":{"kind":"Name","value":"stream_id"}}]}}]}}]}}]} as unknown as DocumentNode<markEmailTrackerClickedMutation, markEmailTrackerClickedMutationVariables>;
export const MarkReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkReadParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<MarkReadMutation, MarkReadMutationVariables>;
export const resendAccountInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resendAccountInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendAccountInvitationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendAccountInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<resendAccountInvitationMutation, resendAccountInvitationMutationVariables>;
export const RespondPublicIncidentResponseNotificationByUUIDParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RespondPublicIncidentResponseNotificationByUUIDParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RespondPublicIncidentResponseNotificationByUUIDParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"respondPublicIncidentResponseNotificationByUUID"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RespondPublicIncidentResponseNotificationByUUIDParamsMutation, RespondPublicIncidentResponseNotificationByUUIDParamsMutationVariables>;
export const sendAccountInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendAccountInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendAccountInvitationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAccountInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<sendAccountInvitationMutation, sendAccountInvitationMutationVariables>;
export const sendAccountInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendAccountInvitations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendAccountInvitationsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAccountInvitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<sendAccountInvitationsMutation, sendAccountInvitationsMutationVariables>;
export const sendIncidentToResolverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendIncidentToResolver"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendIncidentToResolverParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendIncidentToResolver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<sendIncidentToResolverMutation, sendIncidentToResolverMutationVariables>;
export const shareIncidentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"shareIncident"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareIncidentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareIncident"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<shareIncidentMutation, shareIncidentMutationVariables>;
export const signinDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SigninParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"personFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},...personFieldsFragmentDoc.definitions,...partialAccountFieldsFragmentDoc.definitions]} as unknown as DocumentNode<signinMutation, signinMutationVariables>;
export const signoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<signoutMutation, signoutMutationVariables>;
export const signupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<signupMutation, signupMutationVariables>;
export const submitChangeEmailRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitChangeEmailRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitChangeEmailRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitChangeEmailRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<submitChangeEmailRequestMutation, submitChangeEmailRequestMutationVariables>;
export const submitMFACodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitMFACode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitMFACodeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitMFACode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<submitMFACodeMutation, submitMFACodeMutationVariables>;
export const submitResetPasswordRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitResetPasswordRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitResetPasswordRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitResetPasswordRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<submitResetPasswordRequestMutation, submitResetPasswordRequestMutationVariables>;
export const updateAPIKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAPIKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAPIKeyParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAPIKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAPIKeyMutation, updateAPIKeyMutationVariables>;
export const updateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAccountMutation, updateAccountMutationVariables>;
export const updateAccountMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountMemberParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAccountMemberMutation, updateAccountMemberMutationVariables>;
export const updateDashboardTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDashboardTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDashboardTabParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboardTab"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlertsTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"alerts_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stream_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"top"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stream_id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<updateDashboardTabMutation, updateDashboardTabMutationVariables>;
export const updateEverbridgeIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEverbridgeIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEverbridgeIntegrationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEverbridgeIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"everbridge_integration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateEverbridgeIntegrationMutation, updateEverbridgeIntegrationMutationVariables>;
export const updatePersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updatePersonMutation, updatePersonMutationVariables>;
export const updateProximityAssetDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProximityAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProximityAssetParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProximityAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"proximityAssetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}},...proximityAssetFieldsFragmentDoc.definitions,...contactMethodsWithoutAssetFieldsFragmentDoc.definitions,...emailContactFieldsFragmentDoc.definitions,...phoneContactFieldsFragmentDoc.definitions,...userContactFieldsFragmentDoc.definitions,...slackContactFieldsFragmentDoc.definitions,...assetSetContactFieldsFragmentDoc.definitions]} as unknown as DocumentNode<updateProximityAssetMutation, updateProximityAssetMutationVariables>;
export const updateProximityAssetSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProximityAssetSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProximityAssetSetParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProximityAssetSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateProximityAssetSetMutation, updateProximityAssetSetMutationVariables>;
export const updateUserPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserPreferencesParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateUserPreferencesMutation, updateUserPreferencesMutationVariables>;
export const upsertSAMLConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertSAMLConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertSAMLConfigurationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertSAMLConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<upsertSAMLConfigurationMutation, upsertSAMLConfigurationMutationVariables>;
export const GetPostAuthorByUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostAuthorByUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPostAuthorByUrlParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPostAuthorByUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"postAuthor"},"name":{"kind":"Name","value":"post_author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"avatarUrl"},"name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permalink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetPostAuthorByUrlQuery, GetPostAuthorByUrlQueryVariables>;
export const GetAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accountFields"}}]}}]}},...accountFieldsFragmentDoc.definitions,...apiKeyFieldsFragmentDoc.definitions,...accountPasswordPolicyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetAccountQuery, GetAccountQueryVariables>;
export const getAccountInvitationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAccountInvitationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personName"},"name":{"kind":"Name","value":"person_name"}},{"kind":"Field","alias":{"kind":"Name","value":"accountName"},"name":{"kind":"Name","value":"account_name"}},{"kind":"Field","alias":{"kind":"Name","value":"passwordPolicy"},"name":{"kind":"Name","value":"password_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accountPasswordPolicyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pending_user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"samlIssuer"},"name":{"kind":"Name","value":"saml_issuer"}}]}}]}},...accountPasswordPolicyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getAccountInvitationQuery, getAccountInvitationQueryVariables>;
export const getDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlertsTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"alerts_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stream_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottom_sound"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selected_asset_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_set_id"}},{"kind":"Field","name":{"kind":"Name","value":"include"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"top"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stream_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"top_sound"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"map_width"}},{"kind":"Field","name":{"kind":"Name","value":"pane_height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DarkWebTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dark_web_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dark_web_post_id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ColumnsTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columns_tab_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"columns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"panes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlertsPane"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streamIds"}},{"kind":"Field","name":{"kind":"Name","value":"sound"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeWindowSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"unreadOnly"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<getDashboardQuery, getDashboardQueryVariables>;
export const getDefaultEverbridgeIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDefaultEverbridgeIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDefaultEverbridgeIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<getDefaultEverbridgeIntegrationQuery, getDefaultEverbridgeIntegrationQueryVariables>;
export const getEverbridgeIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEverbridgeIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEverbridgeIntegrationParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEverbridgeIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"api_key"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"default_vcc_category"}},{"kind":"Field","name":{"kind":"Name","value":"event_mapping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"severity_level"}},{"kind":"Field","name":{"kind":"Name","value":"vcc_category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"social_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"web"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<getEverbridgeIntegrationQuery, getEverbridgeIntegrationQueryVariables>;
export const getIncidentDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIncident"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetIncidentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIncident"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentFields"}}]}}]}},...incidentFieldsFragmentDoc.definitions,...geometryFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getIncidentQuery, getIncidentQueryVariables>;
export const getIncidentNearbyAssetsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIncidentNearbyAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetIncidentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIncident"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"nearbyAssetsFields"}}]}}]}},...nearbyAssetsFieldsFragmentDoc.definitions,...proximityAssetFieldsFragmentDoc.definitions,...contactMethodsWithoutAssetFieldsFragmentDoc.definitions,...emailContactFieldsFragmentDoc.definitions,...phoneContactFieldsFragmentDoc.definitions,...userContactFieldsFragmentDoc.definitions,...slackContactFieldsFragmentDoc.definitions,...assetSetContactFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getIncidentNearbyAssetsQuery, getIncidentNearbyAssetsQueryVariables>;
export const getIncidentSummarySessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIncidentSummarySession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetIncidentSummarySessionParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIncidentSummarySession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident_summary_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"text_plain"}},{"kind":"Field","name":{"kind":"Name","value":"text_markdown"}},{"kind":"Field","name":{"kind":"Name","value":"followup_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<getIncidentSummarySessionQuery, getIncidentSummarySessionQueryVariables>;
export const getIncidentSummarySessionFollowupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIncidentSummarySessionFollowup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetIncidentSummarySessionFollowupParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIncidentSummarySessionFollowup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<getIncidentSummarySessionFollowupQuery, getIncidentSummarySessionFollowupQueryVariables>;
export const getPersonDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"personFields"}}]}}]}},...personFieldsFragmentDoc.definitions,...partialAccountFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getPersonQuery, getPersonQueryVariables>;
export const getProximityAssetSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProximityAssetSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetProximityAssetSetParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProximityAssetSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_count"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"proximity"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]}}]} as unknown as DocumentNode<getProximityAssetSetQuery, getProximityAssetSetQueryVariables>;
export const getResetPasswordRequestDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getResetPasswordRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetResetPasswordRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getResetPasswordRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"account_password_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accountPasswordPolicyFields"}}]}}]}}]}},...accountPasswordPolicyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getResetPasswordRequestQuery, getResetPasswordRequestQueryVariables>;
export const getSAMLConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSAMLConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSAMLConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certs"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"}},{"kind":"Field","name":{"kind":"Name","value":"issuer"}}]}}]}}]} as unknown as DocumentNode<getSAMLConfigurationQuery, getSAMLConfigurationQueryVariables>;
export const getTravellerDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTravellerData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTravellerData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"all_travellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin_1"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_count"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"pending_count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]} as unknown as DocumentNode<getTravellerDataQuery, getTravellerDataQueryVariables>;
export const getUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userFields"}}]}}]}},...userFieldsFragmentDoc.definitions,...accountFieldsFragmentDoc.definitions,...apiKeyFieldsFragmentDoc.definitions,...accountPasswordPolicyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getUserQuery, getUserQueryVariables>;
export const getWeatherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWeather"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetWeatherParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWeather"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"long_description"}},{"kind":"Field","name":{"kind":"Name","value":"short_description"}},{"kind":"Field","name":{"kind":"Name","value":"sunrise"}},{"kind":"Field","name":{"kind":"Name","value":"sunset"}},{"kind":"Field","name":{"kind":"Name","value":"temp"}},{"kind":"Field","name":{"kind":"Name","value":"wind_direction"}},{"kind":"Field","name":{"kind":"Name","value":"wind_speed"}}]}}]}}]} as unknown as DocumentNode<getWeatherQuery, getWeatherQueryVariables>;
export const getWhereByLongkeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWhereByLongkey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetWhereByLongkeyParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWhereByLongkey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compact_display"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"geo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<getWhereByLongkeyQuery, getWhereByLongkeyQueryVariables>;
export const listAccountMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAccountMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAccountMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"last_activity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<listAccountMembersQuery, listAccountMembersQueryVariables>;
export const listAlertsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAlerts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAlertsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAlerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"alertFields"}}]}}]}},...alertFieldsFragmentDoc.definitions,...incidentAlertFieldsFragmentDoc.definitions,...geometryFieldsFragmentDoc.definitions,...webAlertFieldsFragmentDoc.definitions,...darkWebAlertFieldsFragmentDoc.definitions,...darkWebPostFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listAlertsQuery, listAlertsQueryVariables>;
export const listAlertsSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAlertsSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAlertsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAlerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"stream_id"}}]}}]}}]} as unknown as DocumentNode<listAlertsSummaryQuery, listAlertsSummaryQueryVariables>;
export const listEverbridgeIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listEverbridgeIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListEverbridgeIntegrationsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listEverbridgeIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"api_key"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"default_vcc_category"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}}]}}]}}]} as unknown as DocumentNode<listEverbridgeIntegrationsQuery, listEverbridgeIntegrationsQueryVariables>;
export const listEverbridgeVCCCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listEverbridgeVCCCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listEverbridgeVCCCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<listEverbridgeVCCCategoriesQuery, listEverbridgeVCCCategoriesQueryVariables>;
export const listIncidentTypesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listIncidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listIncidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"incidentTypeFields"}}]}}]}},...incidentTypeFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listIncidentTypesQuery, listIncidentTypesQueryVariables>;
export const listInputStreamCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listInputStreamCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListInputStreamCategoriesParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listInputStreamCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<listInputStreamCategoriesQuery, listInputStreamCategoriesQueryVariables>;
export const listLanguagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"languageFields"}}]}}]}},...languageFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listLanguagesQuery, listLanguagesQueryVariables>;
export const listLocalAccountsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLocalAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLocalAccountsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLocalAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"localAccountFields"}}]}}]}},...localAccountFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listLocalAccountsQuery, listLocalAccountsQueryVariables>;
export const listMsTeamsWebhooksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listMsTeamsWebhooks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListMsTeamsWebhooksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMsTeamsWebhooks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"msTeamsWebhookFields"}}]}}]}},...msTeamsWebhookFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listMsTeamsWebhooksQuery, listMsTeamsWebhooksQueryVariables>;
export const listOutgoingWebhooksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listOutgoingWebhooks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListOutgoingWebhooksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOutgoingWebhooks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"outgoingWebhookFields"}}]}}]}},...outgoingWebhookFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listOutgoingWebhooksQuery, listOutgoingWebhooksQueryVariables>;
export const listPrivateIncidentsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPrivateIncidents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPrivateIncidentsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPrivateIncidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"privateIncidentFields"}}]}}]}}]}},...privateIncidentFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listPrivateIncidentsQuery, listPrivateIncidentsQueryVariables>;
export const listProximityAssetSetsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProximityAssetSets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProximityAssetSetsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProximityAssetSets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"proximityAssetSetFields"}}]}}]}},...proximityAssetSetFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listProximityAssetSetsQuery, listProximityAssetSetsQueryVariables>;
export const listProximityAssetsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProximityAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProximityAssetsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProximityAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"proximityAssetFields"}}]}}]}},...proximityAssetFieldsFragmentDoc.definitions,...contactMethodsWithoutAssetFieldsFragmentDoc.definitions,...emailContactFieldsFragmentDoc.definitions,...phoneContactFieldsFragmentDoc.definitions,...userContactFieldsFragmentDoc.definitions,...slackContactFieldsFragmentDoc.definitions,...assetSetContactFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listProximityAssetsQuery, listProximityAssetsQueryVariables>;
export const listResolverWebhooksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listResolverWebhooks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListResolverWebhooksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listResolverWebhooks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"resolverWebhookFields"}}]}}]}},...resolverWebhookFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listResolverWebhooksQuery, listResolverWebhooksQueryVariables>;
export const listSlackWebhooksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listSlackWebhooks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSlackWebhooksParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listSlackWebhooks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"slackWebhookFields"}}]}}]}},...slackWebhookFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listSlackWebhooksQuery, listSlackWebhooksQueryVariables>;
export const listSlackWorkspacesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listSlackWorkspaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSlackWorkspacesParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listSlackWorkspaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"slackWorkspaceFields"}}]}}]}},...slackWorkspaceFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listSlackWorkspacesQuery, listSlackWorkspacesQueryVariables>;
export const listStreamsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listStreams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListStreamsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listStreams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"streamFields"}}]}}]}},...streamFieldsFragmentDoc.definitions,...standardStreamFieldsFragmentDoc.definitions,...incidentStreamFieldsFragmentDoc.definitions,...webAlertsStreamFieldsFragmentDoc.definitions,...darkWebStreamFieldsFragmentDoc.definitions]} as unknown as DocumentNode<listStreamsQuery, listStreamsQueryVariables>;
export const searchIncidentAnalyticsTableDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchIncidentAnalyticsTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentsAnalyticsTableParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchIncidentAnalyticsTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"searchIncidentAnalyticsTableItemFields"}}]}}]}}]}},...searchIncidentAnalyticsTableItemFieldsFragmentDoc.definitions]} as unknown as DocumentNode<searchIncidentAnalyticsTableQuery, searchIncidentAnalyticsTableQueryVariables>;
export const searchIncidentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchIncidents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchIncidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_featured"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compact_display"}}]}}]}}]}}]}}]} as unknown as DocumentNode<searchIncidentsQuery, searchIncidentsQueryVariables>;
export const searchIncidentsAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchIncidentsAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentsAnalyticsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchIncidentsAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<searchIncidentsAnalyticsQuery, searchIncidentsAnalyticsQueryVariables>;
export const searchIncidentsAnalyticsDrilldownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchIncidentsAnalyticsDrilldown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentsAnalyticsDrilldownParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchIncidentsAnalyticsDrilldown"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<searchIncidentsAnalyticsDrilldownQuery, searchIncidentsAnalyticsDrilldownQueryVariables>;
export const searchIncidentsAnalyticsHeatmapDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchIncidentsAnalyticsHeatmap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentsAnalyticsHeatmapParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchIncidentsAnalyticsHeatmap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"heatmapPointFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},...heatmapPointFieldsFragmentDoc.definitions]} as unknown as DocumentNode<searchIncidentsAnalyticsHeatmapQuery, searchIncidentsAnalyticsHeatmapQueryVariables>;
export const searchIncidentsResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchIncidentsResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchIncidentsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchIncidentsResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compact_display"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"relation"}}]}}]}}]}}]} as unknown as DocumentNode<searchIncidentsResultsQuery, searchIncidentsResultsQueryVariables>;
export const searchLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchLocationsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<searchLocationsQuery, searchLocationsQueryVariables>;
export const searchRecentIncidentsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchRecentIncidents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchRecentIncidentsParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchRecentIncidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed_date"}},{"kind":"Field","name":{"kind":"Name","value":"detected_date"}},{"kind":"Field","name":{"kind":"Name","value":"polygons"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"geometries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"geometryFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wheres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compact_display"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"geo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longkey"}}]}}]}}]}},...geometryFieldsFragmentDoc.definitions]} as unknown as DocumentNode<searchRecentIncidentsQuery, searchRecentIncidentsQueryVariables>;
export const uploadStatusDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uploadStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadStatusParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"uploadStatusFields"}}]}}]}},...uploadStatusFieldsFragmentDoc.definitions]} as unknown as DocumentNode<uploadStatusQuery, uploadStatusQueryVariables>;